{
    "1f469-1f3fc-200d-1f9b2": [
        "c88e64",
        "0c0401"
    ],
    "1f97f": [
        "000002",
        "184072"
    ],
    "1f9a7": [
        "a04519",
        "c68872"
    ],
    "1f647-1f3fd-200d-2642-fe0f": [
        "a57f64",
        "0c0c1c"
    ],
    "1f6a3-1f3fc": [
        "d1b08a",
        "000000"
    ],
    "23f2-fe0f": [
        "c2c1c0",
        "dfdfde"
    ],
    "1f9d1-1f3ff-200d-1f9bd": [
        "646265",
        "2a282a"
    ],
    "1f96b": [
        "dfcac6",
        "c64936"
    ],
    "1f958": [
        "aea79c",
        "332922"
    ],
    "1f469-200d-2696-fe0f": [
        "f9c738",
        "1d1b1a"
    ],
    "1f970": [
        "a65f12",
        "fef09a"
    ],
    "1f469-1f3fc-200d-1f9bd": [
        "b17672",
        "333236"
    ],
    "1f9aa": [
        "3f372f",
        "a1917c"
    ],
    "1f9d1-1f3ff-200d-1f9b2": [
        "35251e",
        "e8e2d6"
    ],
    "1f964": [
        "b7b3b3",
        "9b2626"
    ],
    "1f9d1-200d-1f9b0": [
        "b44c05",
        "f9c82b"
    ],
    "1f1e7-1f1ed": [
        "731c25",
        "dbd9d9"
    ],
    "1f3ca-1f3fc-200d-2642-fe0f": [
        "dff7fb",
        "000000"
    ],
    "1f590-fe0f": [
        "ce7c07",
        "fdcb42"
    ],
    "23e9": [
        "66839e",
        "fdfdfd"
    ],
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": [
        "fdcbc7",
        "a1640d"
    ],
    "1f9d1-1f3fe-200d-1f9bd-200d-27a1-fe0f": [
        "b8b7b5",
        "634f3f"
    ],
    "1f596": [
        "d58708",
        "fdcb45"
    ],
    "1f1ee-1f1f4": [
        "223f75",
        "836e73"
    ],
    "1f930-1f3fe": [
        "6e4f4a",
        "a864a2"
    ],
    "1faf1-1f3fc-200d-1faf2-1f3fe": [
        "8c5634",
        "dab089"
    ],
    "1f3cb-1f3fc-200d-2640-fe0f": [
        "703442",
        "d3a17d"
    ],
    "25fb-fe0f": [
        "000000",
        "d9d9d9"
    ],
    "1f1ee-1f1e8": [
        "c8a516",
        "364840"
    ],
    "1f9d4-1f3fc": [
        "c49d61",
        "e8d7a1"
    ],
    "1f9dd-1f3fc-200d-2642-fe0f": [
        "d1bd8a",
        "b19669"
    ],
    "1f443-1f3fb": [
        "dea883",
        "f9e0c1"
    ],
    "25fc-fe0f": [
        "000000",
        "3c3c3c"
    ],
    "1f469-1f3fe-200d-1f37c": [
        "2d1f1e",
        "63356c"
    ],
    "1f48f-1f3fc": [
        "dfc38e",
        "b87f53"
    ],
    "1f233": [
        "0056af",
        "8ec3ee"
    ],
    "1f642-200d-2194-fe0f": [
        "55230c",
        "fdf393"
    ],
    "1f469-200d-1f469-200d-1f467": [
        "64819b",
        "fdfdfd"
    ],
    "1f555": [
        "aeb1b5",
        "f7f8f8"
    ],
    "1f470-1f3fd": [
        "d1d0cf",
        "856f61"
    ],
    "1f642-200d-2195-fe0f": [
        "552a13",
        "fcf394"
    ],
    "1f646-1f3fd": [
        "cfcecc",
        "7c7b7b"
    ],
    "1f3c3-1f3ff-200d-2642-fe0f-200d-27a1-fe0f": [
        "453130",
        "f7f3ed"
    ],
    "1fac5-1f3ff": [
        "cf9c14",
        "312724"
    ],
    "1f469-1f3fd-200d-1f9b1": [
        "512e15",
        "bc8b66"
    ],
    "1f55c": [
        "c5c9cc",
        "f5f5f5"
    ],
    "1f39a-fe0f": [
        "54575b",
        "a9aeb1"
    ],
    "1faf3-1f3fd": [
        "975d43",
        "000000"
    ],
    "1f1ff-1f1f2": [
        "2c8719",
        "2f350d"
    ],
    "1f6b6-1f3fb": [
        "d1cdc8",
        "241f32"
    ],
    "1f384": [
        "2f502e",
        "6caa6a"
    ],
    "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f": [
        "163c64",
        "e9eaeb"
    ],
    "1f390": [
        "c0c7cf",
        "ff0000"
    ],
    "1f6b6-1f3fe-200d-2642-fe0f-200d-27a1-fe0f": [
        "d62d52",
        "3d4886"
    ],
    "1f38b": [
        "82a932",
        "d21013"
    ],
    "1f574-1f3ff": [
        "575351",
        "060504"
    ],
    "1f347": [
        "f4e2ed",
        "8a1d47"
    ],
    "1f468-200d-1f468-200d-1f466-200d-1f466": [
        "4f677b",
        "c0cdd8"
    ],
    "1f421": [
        "daa541",
        "84705a"
    ],
    "1f3bf": [
        "2e9ec4",
        "d7bc32"
    ],
    "1f3c3-1f3fb-200d-2640-fe0f-200d-27a1-fe0f": [
        "cfa58c",
        "443b49"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe": [
        "734e4c",
        "312724"
    ],
    "1f435": [
        "ab8654",
        "caa984"
    ],
    "1f486-1f3fc-200d-2640-fe0f": [
        "d1b077",
        "52274b"
    ],
    "1f46e-1f3ff": [
        "2e2725",
        "1d3e68"
    ],
    "1f4ed": [
        "4087ae",
        "8a5748"
    ],
    "1f353": [
        "cc3835",
        "759b3f"
    ],
    "1f4d6": [
        "436f84",
        "bebec3"
    ],
    "1f34a": [
        "d4ab73",
        "c45d17"
    ],
    "1f3b0": [
        "b5ada7",
        "dd1514"
    ],
    "1f9cd-1f3fe": [
        "d4d1d1",
        "42342d"
    ],
    "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb": [
        "9c9693",
        "372f2b"
    ],
    "1f3cc-1f3fe": [
        "bab8b7",
        "57453a"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe": [
        "4f372b",
        "221713"
    ],
    "1f409": [
        "8ea856",
        "dac15e"
    ],
    "1f43c": [
        "323231",
        "e4e4e4"
    ],
    "1f3c4": [
        "ecb12d",
        "7a410e"
    ],
    "1f4e2": [
        "8c8d8e",
        "b1b3b5"
    ],
    "1f35e": [
        "a15b21",
        "e3d3a8"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc": [
        "d9b885",
        "422c21"
    ],
    "1f477-1f3fb-200d-2642-fe0f": [
        "d8a24c",
        "96c9f5"
    ],
    "1f46e-1f3fe-200d-2640-fe0f": [
        "694935",
        "2381db"
    ],
    "1faf5": [
        "9c5e00",
        "facb43"
    ],
    "1f468-1f3fe-200d-1f9bd-200d-27a1-fe0f": [
        "bd2532",
        "644c43"
    ],
    "1f93d-1f3fc-200d-2640-fe0f": [
        "cd9b76",
        "f0f4f3"
    ],
    "1f192": [
        "65839d",
        "f8f9fa"
    ],
    "1f926-1f3fd-200d-2642-fe0f": [
        "6b4329",
        "3d5977"
    ],
    "1faf1-1f3ff-200d-1faf2-1f3fd": [
        "b58160",
        "2f2119"
    ],
    "1faf5-1f3fc": [
        "af673d",
        "e6b88e"
    ],
    "1f476-1f3fc": [
        "d1a076",
        "7c4c28"
    ],
    "1f9dc-1f3ff": [
        "933146",
        "5f6996"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb": [
        "e0b78e",
        "3781b6"
    ],
    "1f448-1f3ff": [
        "412e28",
        "000000"
    ],
    "1f481-1f3ff": [
        "241e1c",
        "a5a5a4"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe": [
        "705040",
        "291f1a"
    ],
    "1f623": [
        "b86f20",
        "fdf490"
    ],
    "1f1ec-1f1fe": [
        "1e7541",
        "f4cf48"
    ],
    "1f9d2-1f3fd": [
        "774a2d",
        "bc8d68"
    ],
    "25fe": [
        "000000",
        "3c3c3c"
    ],
    "1f64e-200d-2642-fe0f": [
        "be841a",
        "3866a3"
    ],
    "1f1f1-1f1fa": [
        "ce3b3b",
        "106a8c"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc": [
        "c69e68",
        "e8cfac"
    ],
    "1f637": [
        "723d0b",
        "ebe9d4"
    ],
    "1f62e": [
        "be721e",
        "fdf592"
    ],
    "1f1ec-1f1f3": [
        "22845f",
        "a07c64"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "2c211f",
        "d49f7c"
    ],
    "1f64e-1f3ff-200d-2642-fe0f": [
        "423731",
        "4472b0"
    ],
    "1f936-1f3fb": [
        "964b48",
        "d5a991"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc": [
        "dfb599",
        "8d5b53"
    ],
    "1f1f1-1f1f7": [
        "c4344e",
        "eae2e3"
    ],
    "1f469-1f3fe-200d-1f9bc": [
        "4c3c3c",
        "9e98a9"
    ],
    "1f63a": [
        "efd7c8",
        "bf8d25"
    ],
    "1f9dc-1f3fc-200d-2640-fe0f": [
        "cea16d",
        "64759a"
    ],
    "1f936-1f3fc": [
        "7f4f4b",
        "eeeae8"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "6b4e3d",
        "bb8864"
    ],
    "1f62d": [
        "ae6a1d",
        "67b8ed"
    ],
    "1f1ec-1f1f2": [
        "cb4548",
        "0e4a29"
    ],
    "1f9b9-1f3fc-200d-2640-fe0f": [
        "ac874b",
        "1d141a"
    ],
    "1f6d5": [
        "dc9e7c",
        "853c1c"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f0bfb6",
        "7b5052"
    ],
    "1f3c3-1f3fe-200d-27a1-fe0f": [
        "714730",
        "c1bebb"
    ],
    "1f636": [
        "c06321",
        "fed136"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb": [
        "eaccaa",
        "282222"
    ],
    "1f9d2-1f3fe": [
        "4e362a",
        "9b653e"
    ],
    "1f622": [
        "bd731f",
        "fdd53c"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd": [
        "9c735a",
        "362921"
    ],
    "1f6dc": [
        "0340a7",
        "f9fbfe"
    ],
    "1f9d1-1f3fe-200d-2708-fe0f": [
        "26201d",
        "aca394"
    ],
    "25fd": [
        "000000",
        "d9d9d9"
    ],
    "1f44d-1f3ff": [
        "43312a",
        "5a453a"
    ],
    "1f9d7-1f3fc-200d-2640-fe0f": [
        "b9936f",
        "84745f"
    ],
    "1f476-1f3fb": [
        "e3b796",
        "362b25"
    ],
    "1f468-1f3fe-200d-2696-fe0f": [
        "d69a4e",
        "4b362a"
    ],
    "1fae8": [
        "df860f",
        "8c8886"
    ],
    "1f193": [
        "6784a0",
        "baccdb"
    ],
    "1faf5-1f3fb": [
        "cc865f",
        "fbd3af"
    ],
    "1faf1-1f3ff-200d-1faf2-1f3fe": [
        "8d5734",
        "302018"
    ],
    "1f9cf-1f3fb-200d-2642-fe0f": [
        "d19670",
        "7b7572"
    ],
    "1faf4": [
        "bc7a00",
        "000000"
    ],
    "1f3c5": [
        "163378",
        "c48829"
    ],
    "1f43b": [
        "764e2b",
        "cfaa7f"
    ],
    "1f408": [
        "c2a892",
        "ab7652"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd": [
        "ba8b6b",
        "81553b"
    ],
    "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc": [
        "9a9694",
        "4c352c"
    ],
    "1f3cc-1f3fd": [
        "b9b7b5",
        "817975"
    ],
    "1f5bc-fe0f": [
        "c89728",
        "bcd8de"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb": [
        "baa89b",
        "3b281f"
    ],
    "1f35d": [
        "8f8c85",
        "2d2922"
    ],
    "1f9d1-1f3ff-200d-1f373": [
        "dedbd6",
        "271c16"
    ],
    "1f4e3": [
        "897464",
        "92701e"
    ],
    "1f4d7": [
        "7b925d",
        "1b2414"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff": [
        "9b1613",
        "2f96c8"
    ],
    "1f469-1f3fc-200d-1f3a4": [
        "a14583",
        "211f25"
    ],
    "270a": [
        "91470c",
        "eaa818"
    ],
    "1f9cd-1f3fd": [
        "d8d5d5",
        "73716f"
    ],
    "1f9d4-1f3fc-200d-2642-fe0f": [
        "d7b882",
        "89643b"
    ],
    "1f3b1": [
        "747474",
        "202020"
    ],
    "1f42f": [
        "a99b87",
        "161513"
    ],
    "1f469-1f3ff": [
        "51443f",
        "14100e"
    ],
    "1f9ce-1f3fb-200d-2640-fe0f": [
        "2b273a",
        "b09390"
    ],
    "1f6a3-200d-2642-fe0f": [
        "e0ad35",
        "000000"
    ],
    "1f9d1-1f3ff-200d-1f3a4": [
        "46a93a",
        "343025"
    ],
    "1f434": [
        "a99867",
        "cac6c0"
    ],
    "1f1f2-1f1ed": [
        "b07d54",
        "0b2756"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd": [
        "b37c64",
        "2c2523"
    ],
    "1f352": [
        "3e5412",
        "bd2a3b"
    ],
    "1f4ee": [
        "be9191",
        "cf1111"
    ],
    "1f346": [
        "8c5e87",
        "180c16"
    ],
    "1f4da": [
        "627276",
        "cacfcb"
    ],
    "1f9cd-200d-2642-fe0f": [
        "5c261e",
        "e9ac2c"
    ],
    "1f420": [
        "93a88c",
        "e2ede1"
    ],
    "1f469-1f3fc-200d-1f373": [
        "e2e0d9",
        "9b7145"
    ],
    "1f5a8-fe0f": [
        "8e9296",
        "2f3032"
    ],
    "1f38c": [
        "dedede",
        "9a9693"
    ],
    "1f64d-1f3fd-200d-2640-fe0f": [
        "f8dc8e",
        "6d452b"
    ],
    "1f391": [
        "f7f6ea",
        "415c7a"
    ],
    "1f3c2-1f3ff": [
        "1873a8",
        "c85d2c"
    ],
    "1f385": [
        "d5d1cd",
        "cf9320"
    ],
    "1f9d9-1f3fe-200d-2642-fe0f": [
        "94aa93",
        "3f3228"
    ],
    "1f6b6-1f3fc": [
        "cecbca",
        "040411"
    ],
    "1faf3-1f3fe": [
        "6c371c",
        "010000"
    ],
    "1f6b5-1f3fc-200d-2642-fe0f": [
        "7c7d7a",
        "bdaa91"
    ],
    "1f646-1f3ff-200d-2640-fe0f": [
        "a65eb4",
        "591766"
    ],
    "1f469-1f3fd-200d-1f9b0": [
        "e38d27",
        "3d2214"
    ],
    "1f55b": [
        "b0b3b7",
        "f7f8f8"
    ],
    "1f470-1f3fb-200d-2640-fe0f": [
        "d1d0d0",
        "3b3532"
    ],
    "1f37d-fe0f": [
        "a7afb8",
        "2a3139"
    ],
    "1f482-1f3fc-200d-2640-fe0f": [
        "7d5837",
        "ac8762"
    ],
    "1f646-1f3fe": [
        "d0cfcf",
        "7b7978"
    ],
    "1f935-200d-2640-fe0f": [
        "fac73d",
        "221e1c"
    ],
    "26ab": [
        "383736",
        "030303"
    ],
    "1f232": [
        "e12614",
        "f8f3f3"
    ],
    "1f470-1f3fe": [
        "e4e3e2",
        "8e5b39"
    ],
    "1f554": [
        "c8cbce",
        "f6f6f5"
    ],
    "1f469-200d-1f469-200d-1f466": [
        "64819b",
        "fdfdfd"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff": [
        "4a3a34",
        "e348a0"
    ],
    "1f443-1f3fc": [
        "cb9269",
        "000000"
    ],
    "1f64b-1f3ff-200d-2640-fe0f": [
        "614f40",
        "a759a8"
    ],
    "1f48f-1f3fb": [
        "3d3534",
        "ce9571"
    ],
    "2665-fe0f": [
        "bd1616",
        "e14d4d"
    ],
    "1f9d4-1f3fb": [
        "231d1c",
        "f6d9bc"
    ],
    "1f1ee-1f1e9": [
        "c31818",
        "ada2a2"
    ],
    "1f468-200d-1f3eb": [
        "d8bc94",
        "435d47"
    ],
    "1faf1-1f3fc-200d-1faf2-1f3fd": [
        "ac6f4e",
        "000000"
    ],
    "1f1e9-1f1f4": [
        "b01f3a",
        "e8e6e7"
    ],
    "1f468-200d-1f33e": [
        "796216",
        "b7c5ad"
    ],
    "1f930-1f3fd": [
        "9b7152",
        "9b579b"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "392e29",
        "d84297"
    ],
    "1f937-1f3fc-200d-2642-fe0f": [
        "b98356",
        "30396c"
    ],
    "26d1-fe0f": [
        "e5f6f6",
        "ab605a"
    ],
    "1f575-fe0f": [
        "e1ac23",
        "231e1a"
    ],
    "1f468-200d-1f680": [
        "ccc8c2",
        "a1782f"
    ],
    "1f1f9-1f1e6": [
        "0d2551",
        "bb6243"
    ],
    "1f938-200d-2640-fe0f": [
        "3e3e34",
        "e4ae27"
    ],
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": [
        "fbcd33",
        "fdc6ca"
    ],
    "231a": [
        "7e7d7d",
        "171717"
    ],
    "1f574-fe0f": [
        "413f3e",
        "080706"
    ],
    "1f1fe-1f1ea": [
        "ce3a3a",
        "050505"
    ],
    "1f5e1-fe0f": [
        "4b4c4f",
        "c7d4df"
    ],
    "1f1e7-1f1ee": [
        "249338",
        "b08383"
    ],
    "3297-fe0f": [
        "d10901",
        "f9efef"
    ],
    "1f9d1-200d-1f9b1": [
        "c18410",
        "e3a71a"
    ],
    "1f46e-200d-2640-fe0f": [
        "f1c034",
        "163b69"
    ],
    "1f575-1f3fb-200d-2640-fe0f": [
        "221e1c",
        "f4e4cf"
    ],
    "1f9d1-1f3ff-200d-1f9b3": [
        "86827e",
        "eeeeee"
    ],
    "1f965": [
        "855b36",
        "c7bda3"
    ],
    "1f469-200d-1f52c": [
        "e0dccb",
        "9c6c19"
    ],
    "1f939-1f3fe-200d-2640-fe0f": [
        "3a342a",
        "d1c8bd"
    ],
    "1f645-1f3ff-200d-2642-fe0f": [
        "594337",
        "2c61a3"
    ],
    "1f971": [
        "c9781b",
        "fbf496"
    ],
    "1f6b6-1f3fc-200d-2640-fe0f": [
        "b236ba",
        "a67a58"
    ],
    "1f6a3-1f3fb": [
        "debc9d",
        "403b39"
    ],
    "1f959": [
        "be9661",
        "594b16"
    ],
    "1f96c": [
        "055e11",
        "8cb568"
    ],
    "1f469-1f3fc-200d-1f9b3": [
        "cec7c0",
        "a16f4d"
    ],
    "1f473-1f3fb-200d-2642-fe0f": [
        "dfd6cc",
        "392720"
    ],
    "1f481-1f3fc-200d-2642-fe0f": [
        "3a598d",
        "dcbb83"
    ],
    "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff": [
        "114c84",
        "3a2a24"
    ],
    "1f9a6": [
        "301b0e",
        "a6c7d2"
    ],
    "1f96a": [
        "c07125",
        "f6e5a4"
    ],
    "1f469-200d-1f527": [
        "edb82e",
        "3560c8"
    ],
    "1f64e-1f3fb-200d-2640-fe0f": [
        "211d1f",
        "9a40a6"
    ],
    "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd": [
        "104c85",
        "7b563d"
    ],
    "1f9a4": [
        "dbc9c1",
        "7c4720"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "3a3230",
        "e6c59c"
    ],
    "1f9d8-1f3fc-200d-2642-fe0f": [
        "a65b33",
        "deba8d"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb": [
        "eebcb0",
        "916042"
    ],
    "1f469-1f3fc-200d-1f9b1": [
        "c9ab69",
        "e0c496"
    ],
    "1f97e": [
        "574b41",
        "2d7272"
    ],
    "1f967": [
        "fbb34b",
        "000000"
    ],
    "1f469-200d-1f466-200d-1f466": [
        "607c95",
        "fcfcfc"
    ],
    "1f9d1-1f3ff-200d-1f9b1": [
        "1d1510",
        "5c483b"
    ],
    "1f46c-1f3fb": [
        "0f4d86",
        "b1896e"
    ],
    "1f9da-1f3fe-200d-2642-fe0f": [
        "9ee4cc",
        "683e23"
    ],
    "1f9ab": [
        "6f503d",
        "b08c68"
    ],
    "1f9b8": [
        "dba11e",
        "552d68"
    ],
    "1f973": [
        "834722",
        "fcee7b"
    ],
    "1f1f9-1f1eb": [
        "10235c",
        "d6d6de"
    ],
    "1f998": [
        "a07a51",
        "000000"
    ],
    "1f469-1f3fb-200d-1f37c": [
        "232124",
        "ddb08d"
    ],
    "1f9cd-1f3fd-200d-2640-fe0f": [
        "af7b5c",
        "2a92ce"
    ],
    "1f1fe-1f1f9": [
        "ada5a4",
        "000000"
    ],
    "0034-fe0f-20e3": [
        "65829d",
        "fbfbfb"
    ],
    "1f3c3-1f3fe-200d-2640-fe0f": [
        "7b4d32",
        "b7ced3"
    ],
    "1f9d1-200d-1f9b3": [
        "cbae69",
        "e5ac21"
    ],
    "1f477-1f3ff-200d-2640-fe0f": [
        "ce9635",
        "42352e"
    ],
    "1f3c4-1f3fc": [
        "dcbb91",
        "ce660f"
    ],
    "1faf1-1f3fc-200d-1faf2-1f3ff": [
        "4f3a31",
        "dab089"
    ],
    "1f6cc-1f3fc": [
        "d6dde4",
        "926246"
    ],
    "1f595": [
        "d88c07",
        "fecf4f"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "593e2f",
        "d94296"
    ],
    "1f1ee-1f1f7": [
        "4d985e",
        "700b0b"
    ],
    "1f930-1f3ff": [
        "524045",
        "9f59a1"
    ],
    "1f468-200d-1f4bb": [
        "8d8f90",
        "f0c243"
    ],
    "1f9d6-1f3fe-200d-2640-fe0f": [
        "deedef",
        "91684c"
    ],
    "0023-fe0f-20e3": [
        "65839e",
        "b4c8d9"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd": [
        "b27964",
        "281f1c"
    ],
    "1f469-1f3fc-200d-2696-fe0f": [
        "e7daa3",
        "996734"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb": [
        "dfab87",
        "3d3a3f"
    ],
    "1f44b-1f3fc": [
        "b9774d",
        "dfb893"
    ],
    "1fac5-1f3fe": [
        "d4a017",
        "432e23"
    ],
    "1f9ce-1f3fb-200d-27a1-fe0f": [
        "6c6a67",
        "dec1a4"
    ],
    "1f487-1f3fb": [
        "e6d6c6",
        "2d2726"
    ],
    "1f9d9-1f3fc": [
        "625c40",
        "070508"
    ],
    "1f556": [
        "c7cacd",
        "f5f5f5"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc": [
        "e8bca3",
        "694126"
    ],
    "1f469-1f3fd-200d-1f9bd": [
        "56443c",
        "a8736a"
    ],
    "1f9db-1f3fe-200d-2640-fe0f": [
        "070607",
        "9c1c25"
    ],
    "1f54d": [
        "9a7955",
        "e5c398"
    ],
    "1f9b8-1f3fe-200d-2640-fe0f": [
        "352426",
        "d02742"
    ],
    "1f469-1f3fd-200d-1f9b2": [
        "946149",
        "563723"
    ],
    "1f3c2-1f3fd": [
        "1873a8",
        "c85d2c"
    ],
    "1f393": [
        "262524",
        "88581f"
    ],
    "1f469-1f3fb-200d-1f9bc": [
        "3a363a",
        "af979c"
    ],
    "1f9d1-200d-1f373": [
        "dddbd5",
        "e4ac2c"
    ],
    "1f387": [
        "f9f8f3",
        "a44913"
    ],
    "1f469-1f3fe-200d-1f9bc-200d-27a1-fe0f": [
        "c042bf",
        "282022"
    ],
    "1f574-1f3fe": [
        "6e5648",
        "090806"
    ],
    "1f938-1f3fc-200d-2640-fe0f": [
        "393e39",
        "d3ae81"
    ],
    "1f9d1-200d-1f3a4": [
        "4da538",
        "e7b327"
    ],
    "1f38a": [
        "ee5e80",
        "5e8bee"
    ],
    "1f935-1f3fe-200d-2640-fe0f": [
        "584339",
        "d6d3cf"
    ],
    "1f46e-1f3fe": [
        "3c2b24",
        "dcd292"
    ],
    "1f350": [
        "9f9e38",
        "d5e47d"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff": [
        "544047",
        "e047a1"
    ],
    "1f469-200d-1f692": [
        "a17e69",
        "e5b330"
    ],
    "1f436": [
        "a48170",
        "e3dfdb"
    ],
    "1f3ca": [
        "cbe5ef",
        "000000"
    ],
    "1f469-1f3fd": [
        "976c51",
        "6e472c"
    ],
    "2705": [
        "008e0a",
        "7edc88"
    ],
    "1f422": [
        "6f8d45",
        "000000"
    ],
    "1f3be": [
        "a1b723",
        "d4ea1d"
    ],
    "1f4dc": [
        "b99872",
        "9b7d5a"
    ],
    "1f344": [
        "f3776a",
        "d83725"
    ],
    "1f4e1": [
        "e0e1e5",
        "4a5158"
    ],
    "1f35f": [
        "ba312c",
        "f8c454"
    ],
    "1f4aa-1f3fc": [
        "c38961",
        "e2be99"
    ],
    "1f3cc-1f3ff": [
        "b7b8b7",
        "594f49"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff": [
        "705140",
        "f44eaf"
    ],
    "1f3c7": [
        "38251a",
        "4498cb"
    ],
    "1f42d": [
        "797276",
        "e7e0ea"
    ],
    "1f3b3": [
        "afaba8",
        "323332"
    ],
    "1f9cd-1f3ff": [
        "d7d5d5",
        "3e332e"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd": [
        "542b21",
        "a77559"
    ],
    "1f4d5": [
        "c57362",
        "c52724"
    ],
    "1f378": [
        "f2f2f0",
        "7f7c70"
    ],
    "1f34b": [
        "f4d151",
        "698034"
    ],
    "1f91f-1f3fb": [
        "cd8d66",
        "f8dcbc"
    ],
    "1f469-200d-1f3ed": [
        "221e1f",
        "c98f1a"
    ],
    "1f191": [
        "da2514",
        "efb9b3"
    ],
    "1faf6": [
        "ac6000",
        "020000"
    ],
    "2618-fe0f": [
        "31880a",
        "82e34d"
    ],
    "1f448-1f3fe": [
        "714027",
        "000000"
    ],
    "1f481-1f3fe": [
        "442f24",
        "92908f"
    ],
    "1f44d-1f3fd": [
        "a26c52",
        "c3916a"
    ],
    "1fac3-1f3fb": [
        "d7ad8f",
        "4e72a3"
    ],
    "1f9dc-1f3fe": [
        "8a3e3c",
        "5f6894"
    ],
    "1f6b6-1f3fc-200d-27a1-fe0f": [
        "d7d4d3",
        "2a2d8b"
    ],
    "23f9-fe0f": [
        "64819c",
        "fcfdfd"
    ],
    "1f471-1f3fd-200d-2640-fe0f": [
        "be9f5f",
        "9f7741"
    ],
    "1f634": [
        "d7810e",
        "2c56bd"
    ],
    "1f6a3-1f3fe-200d-2642-fe0f": [
        "814b34",
        "a47d68"
    ],
    "1f1f1-1f1e8": [
        "559fbf",
        "030303"
    ],
    "1f1f1-1f1fb": [
        "54161e",
        "eae9e9"
    ],
    "23f8-fe0f": [
        "66849f",
        "fdfdfd"
    ],
    "1f620": [
        "bd631f",
        "fed439"
    ],
    "1f6b4-1f3fe-200d-2642-fe0f": [
        "0d0d7c",
        "919481"
    ],
    "1f63b": [
        "edc595",
        "c87021"
    ],
    "1f608": [
        "561064",
        "d08cdf"
    ],
    "1faf8-1f3fc": [
        "b56d42",
        "e1af85"
    ],
    "1f3c3-200d-2642-fe0f": [
        "eeb022",
        "2f3066"
    ],
    "1f9dc-200d-2640-fe0f": [
        "dba82f",
        "60759a"
    ],
    "1f6d7": [
        "005bbd",
        "f6f9fc"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "211918",
        "cc9673"
    ],
    "1f62f": [
        "c7781b",
        "fcf694"
    ],
    "1f6d6": [
        "8e7b62",
        "594935"
    ],
    "1f1ec-1f1f1": [
        "b6a6a9",
        "610a1b"
    ],
    "1faf8-1f3fb": [
        "c47c56",
        "f6c8a4"
    ],
    "1f609": [
        "b96f1f",
        "fdf48f"
    ],
    "1f63c": [
        "f5d585",
        "6f5c30"
    ],
    "1f473-1f3ff-200d-2640-fe0f": [
        "7f756d",
        "d7d6d6"
    ],
    "1f575-1f3ff-200d-2642-fe0f": [
        "362e2a",
        "938b76"
    ],
    "1f9d2-1f3ff": [
        "372e2d",
        "d1c5b1"
    ],
    "1f621": [
        "e64404",
        "fdc15f"
    ],
    "1f635": [
        "c2761a",
        "fdf48d"
    ],
    "1f5fa-fe0f": [
        "8b763d",
        "75cbf5"
    ],
    "1f645-1f3fb-200d-2640-fe0f": [
        "e1ba9b",
        "372236"
    ],
    "1f9ce-1f3fe-200d-2642-fe0f-200d-27a1-fe0f": [
        "281f27",
        "a14036"
    ],
    "1f468-1f3ff-200d-1f37c": [
        "231a1a",
        "63386a"
    ],
    "1f9dc-1f3fd": [
        "d2aa57",
        "5f6793"
    ],
    "1f469-1f3fd-200d-1f373": [
        "dedcd7",
        "b78662"
    ],
    "1f481-1f3fd": [
        "653d23",
        "a68e7c"
    ],
    "1f448-1f3fd": [
        "9d664f",
        "000000"
    ],
    "1fac3-1f3fc": [
        "bb9464",
        "4f7dba"
    ],
    "1f44d-1f3fe": [
        "78462a",
        "9d663e"
    ],
    "1faf7": [
        "c27700",
        "f4bf26"
    ],
    "1f469-1f3fd-200d-1f3a4": [
        "a04a79",
        "282326"
    ],
    "1f3cc-1f3fe-200d-2640-fe0f": [
        "b5b3ad",
        "41261f"
    ],
    "270b": [
        "d68606",
        "fdcc45"
    ],
    "1f3b2": [
        "a9a9a9",
        "181818"
    ],
    "1f42e": [
        "ebe3d8",
        "90796b"
    ],
    "1f469-1f3fd-200d-1f9af-200d-27a1-fe0f": [
        "bf42bd",
        "26203e"
    ],
    "1f91f-1f3fc": [
        "bc7a50",
        "e2bf99"
    ],
    "1f34c": [
        "f8f5e4",
        "eec62d"
    ],
    "1f379": [
        "6e7376",
        "e0dcbe"
    ],
    "1f4d4": [
        "6b0d16",
        "e5e2db"
    ],
    "1f4aa-1f3fb": [
        "d69e79",
        "f7daba"
    ],
    "1f4e0": [
        "a8a196",
        "ff0000"
    ],
    "1f3c6": [
        "a05e06",
        "d39616"
    ],
    "1f43a": [
        "b6b4b2",
        "474848"
    ],
    "1f646-200d-2640-fe0f": [
        "963da8",
        "f0bc32"
    ],
    "1f3bd": [
        "194d88",
        "04cbf1"
    ],
    "1f423": [
        "fad63e",
        "9d866b"
    ],
    "1f64b-1f3fb-200d-2642-fe0f": [
        "8c7d73",
        "342f30"
    ],
    "1f9d1-200d-1f9d1-200d-1f9d2": [
        "64819b",
        "fdfdfd"
    ],
    "0030-fe0f-20e3": [
        "7090ad",
        "bbcedd"
    ],
    "1f345": [
        "d94215",
        "54971e"
    ],
    "1f4db": [
        "e23616",
        "f1ebe9"
    ],
    "1f351": [
        "f3c6ab",
        "c65b3f"
    ],
    "1f46e-1f3fd": [
        "6b4933",
        "1b2f4c"
    ],
    "1f4ef": [
        "f1e2d4",
        "b96130"
    ],
    "1f575-fe0f-200d-2640-fe0f": [
        "e5b12e",
        "24201c"
    ],
    "1f469-1f3fe": [
        "745645",
        "201612"
    ],
    "1f437": [
        "d99d92",
        "90584f"
    ],
    "1f470-1f3ff-200d-2642-fe0f": [
        "c6c5c5",
        "514038"
    ],
    "1f574-1f3fd": [
        "5b5957",
        "080706"
    ],
    "1f386": [
        "f7f5f7",
        "1a1b3c"
    ],
    "1f3c4-1f3fe-200d-2642-fe0f": [
        "0d6378",
        "c2e9ad"
    ],
    "1f646-1f3fb-200d-2642-fe0f": [
        "518cce",
        "f1d0af"
    ],
    "1f392": [
        "d8605b",
        "542b22"
    ],
    "1f3c2-1f3fe": [
        "1873a8",
        "c85d2c"
    ],
    "267f": [
        "0055af",
        "f8f9fb"
    ],
    "26f9-1f3fd-200d-2640-fe0f": [
        "a26e54",
        "a92d12"
    ],
    "1f55a": [
        "b1b5b8",
        "d6d9da"
    ],
    "1f468-1f3ff-200d-1f9bc": [
        "3f373a",
        "84838a"
    ],
    "1f469-1f3fd-200d-1f9b3": [
        "c3c2c1",
        "7c5740"
    ],
    "1faf3-1f3ff": [
        "3f2a24",
        "000000"
    ],
    "1f54e": [
        "9639b2",
        "f8f5f9"
    ],
    "1f470-1f3ff": [
        "dddcdb",
        "524139"
    ],
    "1f9d9-1f3fb": [
        "6b5b41",
        "e2cdb2"
    ],
    "1f557": [
        "b1b5b9",
        "f8f8f8"
    ],
    "26aa": [
        "d9d9d9",
        "000000"
    ],
    "271d-fe0f": [
        "9438b0",
        "d097dc"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb": [
        "513421",
        "c18c6b"
    ],
    "1fac5-1f3fd": [
        "d6a319",
        "83552d"
    ],
    "1f44b-1f3fb": [
        "ca8962",
        "faddbf"
    ],
    "1f646-1f3ff": [
        "cacaca",
        "4e3f38"
    ],
    "1f487-1f3fc": [
        "adaba9",
        "a88464"
    ],
    "1f9ce-1f3ff-200d-2642-fe0f": [
        "494e6c",
        "9e142b"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc": [
        "c58a5f",
        "312828"
    ],
    "1f468-200d-1f4bc": [
        "e6aa1a",
        "94aec5"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe": [
        "734e39",
        "2c221d"
    ],
    "1f9d4-200d-2640-fe0f": [
        "fac83c",
        "a86a08"
    ],
    "1f1ee-1f1f6": [
        "b52433",
        "98b1a5"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "4c372d",
        "d94297"
    ],
    "1f93e-1f3fe-200d-2640-fe0f": [
        "473727",
        "7d9a80"
    ],
    "1f6cc-1f3fb": [
        "d6dde4",
        "926246"
    ],
    "231b": [
        "c5beb5",
        "7b4d36"
    ],
    "1f9d1-200d-1f9bd": [
        "8f7342",
        "343439"
    ],
    "1f9cf-1f3ff-200d-2640-fe0f": [
        "38252a",
        "7c4b81"
    ],
    "1f9d1-1f3fc-200d-2695-fe0f": [
        "b18656",
        "dac389"
    ],
    "1f3c4-1f3fb": [
        "e8ccb0",
        "de6c09"
    ],
    "1f9d1-200d-1f9b2": [
        "c68f18",
        "fbd152"
    ],
    "1f1e7-1f1ef": [
        "d5b839",
        "167951"
    ],
    "1f999": [
        "d2c49d",
        "39342b"
    ],
    "1f1f9-1f1ec": [
        "dab618",
        "041d17"
    ],
    "1f1f9-1f1f9": [
        "af202f",
        "411b1e"
    ],
    "1f9d1-200d-1f9af-200d-27a1-fe0f": [
        "cfcac7",
        "444568"
    ],
    "1f487-1f3fe-200d-2640-fe0f": [
        "9b9b9b",
        "4b362f"
    ],
    "1f9b9": [
        "e7a91d",
        "21161d"
    ],
    "1f9ac": [
        "52443f",
        "ad805f"
    ],
    "1f972": [
        "7b440a",
        "f5b725"
    ],
    "26f9-fe0f-200d-2642-fe0f": [
        "f1c13d",
        "105095"
    ],
    "1f966": [
        "73945d",
        "314d21"
    ],
    "1f46c-1f3fc": [
        "144c82",
        "d4af7d"
    ],
    "1f9d1-1f3ff-200d-1f9b0": [
        "241a18",
        "9e3d07"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc": [
        "e1b69b",
        "483024"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "c59a64",
        "da4296"
    ],
    "1f9a5": [
        "41301e",
        "b39969"
    ],
    "1f97d": [
        "323333",
        "e8e8e8"
    ],
    "1f469-1f3fc-200d-1f9b0": [
        "d78f3f",
        "b25320"
    ],
    "2626-fe0f": [
        "9337af",
        "f8f6f9"
    ],
    "1f9d9-200d-2640-fe0f": [
        "423526",
        "a49e5b"
    ],
    "1f9c9": [
        "736b66",
        "431d0f"
    ],
    "1f962": [
        "9f2e2e",
        "d57e7d"
    ],
    "1f976": [
        "3174b9",
        "c3d4ee"
    ],
    "1f56f-fe0f": [
        "d3bdae",
        "f0e9dc"
    ],
    "2744-fe0f": [
        "8ebbdd",
        "cde8f2"
    ],
    "1f6a3-1f3fe": [
        "704531",
        "d9c5ac"
    ],
    "1f5dc-fe0f": [
        "949c9f",
        "3f464a"
    ],
    "1f937-1f3fd-200d-2640-fe0f": [
        "8a5d3b",
        "501957"
    ],
    "1f96d": [
        "9d5431",
        "c5a11a"
    ],
    "1f645-200d-2640-fe0f": [
        "f7c73e",
        "fdecab"
    ],
    "1f9a1": [
        "000000",
        "817c71"
    ],
    "1f3c4-1f3ff": [
        "251a15",
        "dd700c"
    ],
    "23f3": [
        "f5f6f7",
        "b3a89e"
    ],
    "1f6b5-1f3fd-200d-2640-fe0f": [
        "998c7d",
        "6a635a"
    ],
    "1f3c4-1f3ff-200d-2642-fe0f": [
        "0a5f78",
        "85d05b"
    ],
    "1f9d1-200d-2696-fe0f": [
        "edb428",
        "2e2720"
    ],
    "1f989": [
        "473020",
        "b19988"
    ],
    "1f1e7-1f1f8": [
        "118b9f",
        "040404"
    ],
    "1f1e7-1f1eb": [
        "ce3838",
        "084d26"
    ],
    "1f470-1f3fe-200d-2642-fe0f": [
        "d1d1d0",
        "664736"
    ],
    "1f482-1f3fd-200d-2642-fe0f": [
        "594a41",
        "f3ede8"
    ],
    "1f469-1f3fe-200d-1f3a4": [
        "a74188",
        "1e1a1b"
    ],
    "1f443-1f3fd": [
        "936149",
        "ba8764"
    ],
    "1f6b6-1f3fd-200d-2642-fe0f": [
        "c41146",
        "434f89"
    ],
    "1f48f-1f3fe": [
        "614130",
        "fd91d7"
    ],
    "1f575-1f3fe-200d-2642-fe0f": [
        "46372f",
        "ced5d5"
    ],
    "1f468-1f3fb-200d-1f9bd-200d-27a1-fe0f": [
        "c72936",
        "393537"
    ],
    "1f939-1f3fb-200d-2642-fe0f": [
        "394336",
        "afa379"
    ],
    "1f9d4-1f3fe": [
        "2a1c15",
        "8b6245"
    ],
    "0037-fe0f-20e3": [
        "66839e",
        "fcfcfc"
    ],
    "1f6cc-1f3ff": [
        "d6dde4",
        "926246"
    ],
    "26f9-fe0f": [
        "edb944",
        "aba7a1"
    ],
    "1f469-1f3fe-200d-1f373": [
        "dddbd6",
        "805435"
    ],
    "1f473-1f3fe-200d-2640-fe0f": [
        "a5a4a2",
        "d5d4d4"
    ],
    "1f481-1f3fd-200d-2640-fe0f": [
        "835638",
        "973ea5"
    ],
    "1f1ee-1f1f2": [
        "a51e30",
        "61131c"
    ],
    "1f930-1f3fc": [
        "d6bf84",
        "824b69"
    ],
    "26f8-fe0f": [
        "868484",
        "d3d4d5"
    ],
    "1faf3-1f3fb": [
        "d29975",
        "000000"
    ],
    "1f3cc-1f3ff-200d-2640-fe0f": [
        "cbcac3",
        "422f2b"
    ],
    "1f55e": [
        "c8cbce",
        "f5f6f6"
    ],
    "2648": [
        "762d8b",
        "d4a0df"
    ],
    "1f646-1f3fb": [
        "adb3ba",
        "807e7d"
    ],
    "1f44b-1f3ff": [
        "2d2018",
        "584339"
    ],
    "1f9ce-1f3fc-200d-2640-fe0f-200d-27a1-fe0f": [
        "cfb07a",
        "2e2f63"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff": [
        "4b3427",
        "f34cae"
    ],
    "1f468-1f3ff-200d-1f9b1": [
        "1e1714",
        "392c28"
    ],
    "1f235": [
        "e12615",
        "fbf7f7"
    ],
    "1f553": [
        "c4c8cb",
        "f4f4f5"
    ],
    "1f9d9-1f3ff": [
        "6f8858",
        "080504"
    ],
    "1f470-1f3fb": [
        "eedecc",
        "272220"
    ],
    "1f469-1f3fb-200d-1f9b0": [
        "e09740",
        "f4d8ba"
    ],
    "1f487-1f3ff-200d-2640-fe0f": [
        "afafaf",
        "423535"
    ],
    "1f38d": [
        "e8e1c5",
        "757639"
    ],
    "1f9d7-1f3fd-200d-2642-fe0f": [
        "e17438",
        "c00804"
    ],
    "1f468-1f3fb-200d-2695-fe0f": [
        "5d7373",
        "d2a07e"
    ],
    "2696-fe0f": [
        "656e77",
        "99a1a9"
    ],
    "1f9b9-200d-2640-fe0f": [
        "b4700c",
        "3a243b"
    ],
    "1f9cf-1f3fe-200d-2640-fe0f": [
        "6f452d",
        "2c1a19"
    ],
    "1f6b6-1f3fd": [
        "cecdcb",
        "2f3070"
    ],
    "2697-fe0f": [
        "dfedf1",
        "5d5655"
    ],
    "1f382": [
        "b4ad9c",
        "eae6d2"
    ],
    "1f469-200d-1f467-200d-1f467": [
        "607c95",
        "fcfcfc"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc": [
        "d6b680",
        "92653d"
    ],
    "1f9b9-1f3fd-200d-2642-fe0f": [
        "51311e",
        "682ba4"
    ],
    "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd": [
        "9b9592",
        "483429"
    ],
    "1f3cc-1f3fc": [
        "c3b6a1",
        "847d76"
    ],
    "2728": [
        "fbb34b",
        "f38c27"
    ],
    "1f3c2": [
        "1873a8",
        "c85d2c"
    ],
    "1f43e": [
        "000000",
        "464646"
    ],
    "1f35c": [
        "f0f1f0",
        "9a5f2a"
    ],
    "1f369": [
        "704528",
        "9e6f47"
    ],
    "1f4e4": [
        "d1b7bd",
        "4390d9"
    ],
    "1f4aa-1f3ff": [
        "382821",
        "5a453a"
    ],
    "1f4d0": [
        "a8b9cd",
        "9bacbf"
    ],
    "1f9dc-1f3fd-200d-2642-fe0f": [
        "c99d56",
        "626c95"
    ],
    "1f3b6": [
        "848e96",
        "bdc4ca"
    ],
    "1f42a": [
        "b27e4d",
        "000000"
    ],
    "1f9cd-1f3fc": [
        "d9d3ca",
        "767573"
    ],
    "1f1f2-1f1f9": [
        "821d29",
        "e3e2e2"
    ],
    "1f1f2-1f1ec": [
        "db4a41",
        "022110"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc": [
        "deb497",
        "332b29"
    ],
    "1f433": [
        "58cdd7",
        "25688d"
    ],
    "1f355": [
        "b33a11",
        "dba351"
    ],
    "1f4eb": [
        "3782aa",
        "75634f"
    ],
    "1f4f8": [
        "c7c5bf",
        "727271"
    ],
    "1f341": [
        "7d1f0c",
        "cb6c1d"
    ],
    "1f4df": [
        "414242",
        "838484"
    ],
    "1f9d1-1f3fb-200d-1f9bd-200d-27a1-fe0f": [
        "d9c3af",
        "333235"
    ],
    "1f427": [
        "1b1b1a",
        "969696"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd": [
        "ac6a48",
        "223e68"
    ],
    "1f476-1f3fe": [
        "70432a",
        "dbd1c5"
    ],
    "1f194": [
        "9036ac",
        "fcfbfc"
    ],
    "1f9d9-1f3fb-200d-2640-fe0f": [
        "362a1e",
        "76794b"
    ],
    "1faf1-1f3ff-200d-1faf2-1f3fb": [
        "eec5a2",
        "2f2119"
    ],
    "1f3c3-200d-2642-fe0f-200d-27a1-fe0f": [
        "d28b20",
        "111439"
    ],
    "1faf5-1f3fe": [
        "562a16",
        "91512b"
    ],
    "1f64d-1f3fc-200d-2642-fe0f": [
        "ddc386",
        "37639e"
    ],
    "1faf3": [
        "c18202",
        "000000"
    ],
    "1f469-200d-1f4bc": [
        "f9c432",
        "282e3d"
    ],
    "1f93e-1f3ff-200d-2640-fe0f": [
        "332c22",
        "7c9980"
    ],
    "26b0-fe0f": [
        "a67657",
        "724831"
    ],
    "1f9d4-1f3fd-200d-2640-fe0f": [
        "8b5e3f",
        "3d210d"
    ],
    "1faf8-1f3ff": [
        "2b1b14",
        "533a31"
    ],
    "26b1-fe0f": [
        "5c411d",
        "e0c763"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "9e7656",
        "26201f"
    ],
    "1f619": [
        "d4801d",
        "fef696"
    ],
    "1f62c": [
        "c07621",
        "f0ebb1"
    ],
    "1f1ec-1f1f5": [
        "19337b",
        "0a0c0b"
    ],
    "1f936-1f3fd": [
        "8f5a4c",
        "e7e3e1"
    ],
    "1f6d2": [
        "423e3f",
        "959293"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe": [
        "84544b",
        "422f27"
    ],
    "1f469-1f3fe-200d-1f9b3": [
        "b9b8b8",
        "895938"
    ],
    "2604-fe0f": [
        "fed6b4",
        "df4e06"
    ],
    "1f587-fe0f": [
        "9ea5aa",
        "787777"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe": [
        "613e2e",
        "e2c69f"
    ],
    "1f9d7-200d-2640-fe0f": [
        "e2a427",
        "c10201"
    ],
    "1f631": [
        "969a92",
        "a45408"
    ],
    "1f625": [
        "b97120",
        "fdd63c"
    ],
    "1f1ec-1f1e9": [
        "7a1721",
        "14745b"
    ],
    "1f1ec-1f1fc": [
        "d7bb39",
        "4a231f"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc": [
        "d2b8ab",
        "211b17"
    ],
    "1f9d2-1f3fb": [
        "3b3534",
        "f6d8b9"
    ],
    "1f9ce-1f3fe-200d-2642-fe0f": [
        "4a4f71",
        "d4cec3"
    ],
    "1f6dd": [
        "5f95f8",
        "2c4bae"
    ],
    "1f9d2-1f3fc": [
        "d4b97b",
        "b47e4e"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb": [
        "f6c3c2",
        "221c19"
    ],
    "1f624": [
        "d6861c",
        "f3f5e3"
    ],
    "1f6de": [
        "222323",
        "878e91"
    ],
    "1f486-1f3fd-200d-2642-fe0f": [
        "87593e",
        "3983c7"
    ],
    "2049-fe0f": [
        "f08770",
        "951d03"
    ],
    "1f9d6-1f3ff-200d-2640-fe0f": [
        "cbdcde",
        "695b53"
    ],
    "1f469-1f3fe-200d-1f9b2": [
        "6a3d25",
        "935e38"
    ],
    "1f630": [
        "96a086",
        "efa820"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd": [
        "ac7e54",
        "e3c8a2"
    ],
    "1f936-1f3fe": [
        "9a604e",
        "efeceb"
    ],
    "1f62b": [
        "ad6b23",
        "fcd338"
    ],
    "1f618": [
        "d6751f",
        "fef392"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "3c3534",
        "f3cab4"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd": [
        "966a4f",
        "6854a4"
    ],
    "1f1f1-1f1f0": [
        "a7842c",
        "000000"
    ],
    "1f469-1f3fe-200d-1f9bd": [
        "302b2c",
        "7e5135"
    ],
    "1f63f": [
        "c5eefe",
        "c89529"
    ],
    "1f9b8-1f3ff-200d-2640-fe0f": [
        "231d21",
        "cb2640"
    ],
    "0033-fe0f-20e3": [
        "66839e",
        "fafbfb"
    ],
    "1f469-200d-1f4bb": [
        "f7c438",
        "7c7f8e"
    ],
    "1faf2": [
        "dba415",
        "000000"
    ],
    "1f195": [
        "66849f",
        "f8f9fa"
    ],
    "1f469-1f3fb-200d-2708-fe0f": [
        "3e3b38",
        "d1b89d"
    ],
    "1faf5-1f3fd": [
        "844d37",
        "c1835c"
    ],
    "1f9db-1f3ff-200d-2640-fe0f": [
        "0c0b0b",
        "9c4c67"
    ],
    "1faf1-1f3ff-200d-1faf2-1f3fc": [
        "d8aa83",
        "2e2019"
    ],
    "1f476-1f3fd": [
        "a46f54",
        "50311e"
    ],
    "1fac3-1f3ff": [
        "2a2323",
        "6293d4"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe": [
        "34221e",
        "d1a778"
    ],
    "1f9da-1f3ff-200d-2642-fe0f": [
        "9ee3cd",
        "49382a"
    ],
    "1f340": [
        "51a222",
        "87e04e"
    ],
    "1f426": [
        "628284",
        "bfcdcf"
    ],
    "1f3ba": [
        "7f5c23",
        "e1cb5b"
    ],
    "1f432": [
        "a69c50",
        "d4d151"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f0bfb6",
        "2c2624"
    ],
    "1f1f2-1f1eb": [
        "c33c34",
        "7d8190"
    ],
    "1f1f2-1f1f8": [
        "11114b",
        "db2a25"
    ],
    "1f9d1-1f3ff-200d-1f37c": [
        "211c1b",
        "65376b"
    ],
    "1f4f9": [
        "373738",
        "999da2"
    ],
    "1f4ec": [
        "8ea9b6",
        "2c2a26"
    ],
    "1f354": [
        "a55a2b",
        "f1b566"
    ],
    "1f64b-200d-2640-fe0f": [
        "f3bf31",
        "842a94"
    ],
    "1f91f-1f3ff": [
        "2a1d16",
        "5a453a"
    ],
    "1f4d1": [
        "6ea7e7",
        "dfdfe0"
    ],
    "1f34f": [
        "7cae35",
        "bbe66e"
    ],
    "1f469-1f3fc-200d-1f37c": [
        "c29c60",
        "673f63"
    ],
    "1f9cd-1f3fb": [
        "dbd3ce",
        "343231"
    ],
    "1f3b7": [
        "b8973a",
        "82682e"
    ],
    "1f43d": [
        "ad535f",
        "000000"
    ],
    "1f3c3": [
        "f2b931",
        "171831"
    ],
    "1f3df-fe0f": [
        "ed7762",
        "5d6e61"
    ],
    "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe": [
        "bcb9b8",
        "7b4d31"
    ],
    "1f3cc-1f3fb": [
        "d5d1ca",
        "737170"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb": [
        "825c46",
        "efcaa9"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd": [
        "b0886a",
        "422b1e"
    ],
    "1f4e5": [
        "c7c3c2",
        "4390d9"
    ],
    "1f368": [
        "9f8a72",
        "e3dac9"
    ],
    "1f35b": [
        "e2ded4",
        "000000"
    ],
    "1f383": [
        "711f0b",
        "f0a90b"
    ],
    "1f926-1f3fc-200d-2640-fe0f": [
        "ecdeb4",
        "420a4b"
    ],
    "1f6b6-1f3fe": [
        "cfcbc8",
        "2c2e76"
    ],
    "1f93d-1f3fd-200d-2642-fe0f": [
        "ac7e5f",
        "f0f2f0"
    ],
    "1f469-200d-1f467-200d-1f466": [
        "607c95",
        "fcfcfc"
    ],
    "1f46e-1f3fb-200d-2642-fe0f": [
        "af957e",
        "223c60"
    ],
    "1f93e-200d-2642-fe0f": [
        "a74425",
        "d6d5ca"
    ],
    "1f487-200d-2640-fe0f": [
        "94928f",
        "7d4c0b"
    ],
    "1f477-1f3fe-200d-2640-fe0f": [
        "d39a34",
        "6e4a31"
    ],
    "1f9d1-1f3ff-200d-1f9af-200d-27a1-fe0f": [
        "cdc5c3",
        "493b37"
    ],
    "1f38e": [
        "413f63",
        "e0cb9b"
    ],
    "1f468-200d-1f527": [
        "eab62f",
        "1c1817"
    ],
    "1f469-1f3fb-200d-1f9b1": [
        "3e3936",
        "f6d8ba"
    ],
    "1f3c3-1f3ff-200d-2640-fe0f": [
        "4b3a38",
        "d3cfcb"
    ],
    "1f234": [
        "e32715",
        "fcf8f8"
    ],
    "1f468-1f3ff-200d-1f9b0": [
        "ee9a2a",
        "543b31"
    ],
    "1f468-1f3ff-200d-1f9af-200d-27a1-fe0f": [
        "c32542",
        "4c5381"
    ],
    "269c-fe0f": [
        "dfc658",
        "76531a"
    ],
    "1f470-1f3fc": [
        "d1d1cf",
        "927c66"
    ],
    "1f552": [
        "abaeb0",
        "f6f6f6"
    ],
    "1f487-1f3ff": [
        "d2d2d2",
        "4b403d"
    ],
    "1f3ca-1f3fd-200d-2640-fe0f": [
        "cce5f0",
        "56353f"
    ],
    "2733-fe0f": [
        "02af08",
        "d1e2d1"
    ],
    "1f1ff-1f1fc": [
        "c53624",
        "2a5115"
    ],
    "269b-fe0f": [
        "9337af",
        "f8f5f8"
    ],
    "1f646-1f3fc": [
        "d6d3c5",
        "847a70"
    ],
    "2649": [
        "9237ae",
        "f9f8fa"
    ],
    "1f55d": [
        "adb0b3",
        "f8f8f8"
    ],
    "1faf3-1f3fc": [
        "c1845b",
        "000000"
    ],
    "1f22f": [
        "03b806",
        "f4f9f4"
    ],
    "1f1e9-1f1f2": [
        "156c3a",
        "986c66"
    ],
    "1f930-1f3fb": [
        "625357",
        "a76799"
    ],
    "1f1ee-1f1f3": [
        "a6a1a0",
        "185c12"
    ],
    "1f6b4-1f3ff-200d-2642-fe0f": [
        "0c0d80",
        "4c4a48"
    ],
    "1f647-1f3fc-200d-2640-fe0f": [
        "e3d193",
        "7b3a84"
    ],
    "1faf1-1f3fc-200d-1faf2-1f3fb": [
        "dcb08a",
        "000000"
    ],
    "1f9ce-200d-2640-fe0f-200d-27a1-fe0f": [
        "d09825",
        "41487b"
    ],
    "1f9d4-1f3fd": [
        "6e4425",
        "b78966"
    ],
    "1f468-200d-1f3ed": [
        "5c6074",
        "f4be2b"
    ],
    "1f443-1f3fe": [
        "724227",
        "97613b"
    ],
    "1f6a3-1f3ff-200d-2642-fe0f": [
        "4a3a33",
        "ab715d"
    ],
    "1f48f-1f3fd": [
        "8d5c41",
        "b68865"
    ],
    "1f1f7-1f1fa": [
        "b7b8bc",
        "84241d"
    ],
    "1f1e7-1f1ec": [
        "b2b8b6",
        "872217"
    ],
    "1f1e7-1f1f9": [
        "be503c",
        "dddad8"
    ],
    "1f988": [
        "b4babb",
        "6e7e82"
    ],
    "1f1f9-1f1ef": [
        "c43153",
        "dfdcd7"
    ],
    "1f468-200d-1f692": [
        "a37f6b",
        "d13d33"
    ],
    "1f97a": [
        "f3980e",
        "fcd241"
    ],
    "1f3cb-1f3fd-200d-2642-fe0f": [
        "785e51",
        "6e1b18"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff": [
        "88593d",
        "e647a2"
    ],
    "1f58b-fe0f": [
        "909192",
        "675d5f"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "3e3029",
        "d9b885"
    ],
    "1f9a0": [
        "6fb61d",
        "21790c"
    ],
    "1f9d1-1f3ff-200d-1f9bc": [
        "53515a",
        "9ca7a7"
    ],
    "1f6a3-1f3fd": [
        "c0926e",
        "000000"
    ],
    "1f58c-fe0f": [
        "6b7392",
        "d5dded"
    ],
    "1f96e": [
        "762e06",
        "eda43c"
    ],
    "1f469-1f3fc-200d-1f9bc": [
        "443c42",
        "93818a"
    ],
    "1f977": [
        "020303",
        "3a3d40"
    ],
    "1f9af": [
        "515050",
        "852029"
    ],
    "1f1ef-1f1ea": [
        "b7a8a8",
        "000000"
    ],
    "1f46c-1f3ff": [
        "0d4d87",
        "372926"
    ],
    "1f935-1f3ff-200d-2640-fe0f": [
        "443c3a",
        "6e6a68"
    ],
    "1f6f0-fe0f": [
        "ebe3d9",
        "6a6e59"
    ],
    "1f9c8": [
        "dcb14c",
        "000000"
    ],
    "1f963": [
        "73757d",
        "9fbcdd"
    ],
    "1f9dd-1f3fd-200d-2640-fe0f": [
        "a1805a",
        "d0c384"
    ],
    "1f9ad": [
        "9e9d9b",
        "42403e"
    ],
    "1f325-fe0f": [
        "bac6d1",
        "060003"
    ],
    "1f975": [
        "e85b11",
        "ee5f9c"
    ],
    "1f324-fe0f": [
        "3a0120",
        "bcc7d0"
    ],
    "1f961": [
        "b49ca0",
        "fcfcfc"
    ],
    "1f46c-1f3fd": [
        "114d85",
        "7c573f"
    ],
    "1f9a2": [
        "cbc8b7",
        "030302"
    ],
    "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb": [
        "104e87",
        "826048"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "5f3b22",
        "c29366"
    ],
    "1f93e-1f3fb-200d-2642-fe0f": [
        "ad8978",
        "422928"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd": [
        "9f6c4c",
        "4c3224"
    ],
    "1f949": [
        "822d0a",
        "b86c27"
    ],
    "1f97c": [
        "d1d3d4",
        "e7eaeb"
    ],
    "1f469-1f3fb-200d-1f9bc-200d-27a1-fe0f": [
        "c044be",
        "292023"
    ],
    "1f6a3-1f3ff": [
        "4a3931",
        "cfc6b7"
    ],
    "1f9d9-1f3ff-200d-2642-fe0f": [
        "98b495",
        "201911"
    ],
    "1f6e5-fe0f": [
        "9db4bf",
        "020305"
    ],
    "1f1e7-1f1e7": [
        "0e2a6b",
        "846a1f"
    ],
    "1f9d1-200d-1f9bc": [
        "444148",
        "9ba4a0"
    ],
    "26f9-1f3fc-200d-2642-fe0f": [
        "d1ab7d",
        "161a27"
    ],
    "1f469-1f3fb-200d-1f373": [
        "ebe3d7",
        "31251d"
    ],
    "1f6e4-fe0f": [
        "495e2f",
        "e1dfe1"
    ],
    "1f468-200d-1f468-200d-1f467-200d-1f467": [
        "4f677b",
        "c0cdd8"
    ],
    "23f0": [
        "df8d8e",
        "e0dedf"
    ],
    "1f3c4-1f3fe": [
        "855a3b",
        "bb9a7c"
    ],
    "1f1e7-1f1ea": [
        "a11c26",
        "060605"
    ],
    "1f1f9-1f1ed": [
        "dcdadb",
        "6f0e12"
    ],
    "21a9-fe0f": [
        "65829c",
        "fafbfb"
    ],
    "1f469-1f3fb-200d-1f3a4": [
        "9f427e",
        "222027"
    ],
    "1f9d4-1f3ff": [
        "120f0d",
        "514037"
    ],
    "2764-fe0f-200d-1f525": [
        "f54222",
        "fdb97c"
    ],
    "1f1e9-1f1ff": [
        "919b93",
        "0e5f2f"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd": [
        "a26f4a",
        "392820"
    ],
    "1f9d1-1f3ff-200d-2708-fe0f": [
        "201b19",
        "a8a599"
    ],
    "1f1f7-1f1fc": [
        "1c81ad",
        "d4ba27"
    ],
    "1f3c3-1f3ff-200d-27a1-fe0f": [
        "241c28",
        "dad8d4"
    ],
    "1f48f-1f3ff": [
        "3b2f2c",
        "d94196"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f0beb5",
        "4c3d39"
    ],
    "1f1ee-1f1f1": [
        "abafb9",
        "17439a"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "362a25",
        "ca8f6a"
    ],
    "1f1e9-1f1f0": [
        "6b0f21",
        "ebe9ea"
    ],
    "1f468-1f3fd-200d-2708-fe0f": [
        "c0b1a0",
        "6d4e3c"
    ],
    "1f6cc-1f3fe": [
        "d6dde4",
        "926246"
    ],
    "1f55f": [
        "aeb1b5",
        "f8f9f8"
    ],
    "1f468-1f3ff-200d-1f9bd": [
        "b21b2c",
        "433a3c"
    ],
    "1f54b": [
        "c2ae83",
        "3b3a38"
    ],
    "1f9d1-1f3fd-200d-2696-fe0f": [
        "563925",
        "c6915c"
    ],
    "1f9d9-1f3fe": [
        "7f7047",
        "5a4a35"
    ],
    "1f550": [
        "b1b5b8",
        "f7f7f7"
    ],
    "1f468-1f3ff-200d-2696-fe0f": [
        "564036",
        "ce934a"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe": [
        "70482f",
        "fd92d8"
    ],
    "1f487-1f3fb-200d-2642-fe0f": [
        "dbcaba",
        "7e6e6c"
    ],
    "1f468-1f3ff-200d-1f9b2": [
        "291b14",
        "5b463a"
    ],
    "1f236": [
        "f89102",
        "ded1b9"
    ],
    "1f44b-1f3fe": [
        "4f2c1a",
        "9a633c"
    ],
    "1fac5-1f3fc": [
        "cb9814",
        "f1d761"
    ],
    "1f468-200d-1f9bd-200d-27a1-fe0f": [
        "c12531",
        "515566"
    ],
    "1f487-1f3fd": [
        "d7d4d2",
        "89634a"
    ],
    "1f9d1-200d-1f37c": [
        "d2991e",
        "633967"
    ],
    "1f46f-200d-2640-fe0f": [
        "e2a819",
        "312f2f"
    ],
    "1f1fc-1f1f8": [
        "bb2e31",
        "464e87"
    ],
    "1f1fc-1f1eb": [
        "b82e3b",
        "6a1c25"
    ],
    "1f469-1f3fb-200d-1f9b3": [
        "cccccb",
        "a99383"
    ],
    "1f574-1f3fc": [
        "696765",
        "070605"
    ],
    "1f468-200d-1f52c": [
        "dedbd3",
        "e8b533"
    ],
    "1f3cc-1f3fb-200d-2642-fe0f": [
        "b9cac6",
        "6a8290"
    ],
    "1f381": [
        "ba7f1b",
        "ccaca9"
    ],
    "1f3c2-1f3fb": [
        "1873a8",
        "c85d2c"
    ],
    "1f34b-200d-1f7e9": [
        "f3e3e4",
        "3f4f00"
    ],
    "1f3b5": [
        "6c7a85",
        "525c64"
    ],
    "1f42b": [
        "b17f5b",
        "000000"
    ],
    "1f418": [
        "828480",
        "565754"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb": [
        "832e1e",
        "dab190"
    ],
    "1f3d8-fe0f": [
        "6d3c31",
        "ddcfb9"
    ],
    "1f34d": [
        "b8c98e",
        "a96e29"
    ],
    "1f4d3": [
        "acacac",
        "4d4d4d"
    ],
    "1f91f-1f3fd": [
        "7d4f3b",
        "b58060"
    ],
    "1f4e7": [
        "e7e7e7",
        "ff0000"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff": [
        "725342",
        "afadab"
    ],
    "1f4aa-1f3fe": [
        "5e3621",
        "8f5a36"
    ],
    "1f3d9-fe0f": [
        "f8fbfc",
        "1c4b83"
    ],
    "1f1f2-1f1e6": [
        "99151e",
        "690d10"
    ],
    "1f3c1": [
        "2b2b2b",
        "cbcbcb"
    ],
    "1f645-1f3fe-200d-2642-fe0f": [
        "9a633b",
        "2660a5"
    ],
    "1f469-200d-1f680": [
        "cfcbc2",
        "8d8d8e"
    ],
    "1f471-200d-2640-fe0f": [
        "a77d28",
        "e6d698"
    ],
    "1f3bc": [
        "afafaf",
        "2a2a2a"
    ],
    "1f3a9": [
        "4d4f4e",
        "a6790e"
    ],
    "1f424": [
        "d8a81f",
        "030302"
    ],
    "1f342": [
        "9b622e",
        "ca9132"
    ],
    "1f4de": [
        "626466",
        "dadbdc"
    ],
    "1f356": [
        "e6a36e",
        "8a3215"
    ],
    "1f46e-1f3fc": [
        "b38f60",
        "1c416e"
    ],
    "1f4ea": [
        "3c88b0",
        "73604b"
    ],
    "1f430": [
        "b3a6a7",
        "e5ddde"
    ],
    "1f469-1f3fb": [
        "564e4c",
        "f2d4b5"
    ],
    "1f939-1f3ff-200d-2640-fe0f": [
        "3e322d",
        "d5cdc5"
    ],
    "1f18e": [
        "ef301c",
        "fbf9f8"
    ],
    "1f9dc-1f3fc": [
        "d5ab5e",
        "616994"
    ],
    "1f476-1f3ff": [
        "251913",
        "4b372f"
    ],
    "1f448-1f3fc": [
        "cd966d",
        "000000"
    ],
    "1f481-1f3fc": [
        "be9060",
        "dec287"
    ],
    "1fad8": [
        "919090",
        "702a25"
    ],
    "1f19a": [
        "f89202",
        "f0e6d3"
    ],
    "1f469-200d-1f33e": [
        "906717",
        "e9af2d"
    ],
    "1f44d-1f3fb": [
        "e3b28e",
        "f9ddbd"
    ],
    "1fac3-1f3fd": [
        "89583b",
        "568fdc"
    ],
    "1faf0": [
        "cb8d02",
        "fdd558"
    ],
    "1f3f3-fe0f-200d-1f308": [
        "e4a616",
        "1ac468"
    ],
    "1f3f4-200d-2620-fe0f": [
        "282828",
        "f3f3f3"
    ],
    "1f469-200d-1f3eb": [
        "cacbc4",
        "a15e1e"
    ],
    "1faf5-1f3ff": [
        "261710",
        "594035"
    ],
    "1f3c4-1f3fb-200d-2640-fe0f": [
        "cf9975",
        "5d334c"
    ],
    "1f646-1f3fe-200d-2640-fe0f": [
        "a85db5",
        "581665"
    ],
    "1f197": [
        "6784a0",
        "fafbfb"
    ],
    "1f6d1": [
        "d92c06",
        "ef8669"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff": [
        "3d2e27",
        "f6a3d9"
    ],
    "1f1ec-1f1f6": [
        "418650",
        "dbdbd8"
    ],
    "1f63d": [
        "f5d790",
        "b68120"
    ],
    "1faf8-1f3fe": [
        "5c2d17",
        "7b4122"
    ],
    "1f626": [
        "ca7a1b",
        "fff58d"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff": [
        "2f2421",
        "e3c8a2"
    ],
    "1f632": [
        "c57719",
        "fcf396"
    ],
    "1f64b-1f3fe-200d-2640-fe0f": [
        "5a4138",
        "842b94"
    ],
    "1f469-1f3fe-200d-1f9b0": [
        "e79027",
        "795647"
    ],
    "1f6f9": [
        "6d553d",
        "4b4843"
    ],
    "1f6ec": [
        "848e92",
        "000000"
    ],
    "1f633": [
        "c2732d",
        "e9e7d2"
    ],
    "1f1f1-1f1fe": [
        "c51926",
        "204427"
    ],
    "1f6eb": [
        "6092ed",
        "000000"
    ],
    "1f469-1f3fe-200d-1f9b1": [
        "3f2e25",
        "97633b"
    ],
    "1f6f8": [
        "3d4141",
        "040d09"
    ],
    "1f6df": [
        "a5a3a3",
        "642511"
    ],
    "1f935-1f3fb-200d-2642-fe0f": [
        "edd1b6",
        "292726"
    ],
    "1f1ec-1f1fa": [
        "9d2e35",
        "1a5d9c"
    ],
    "1f627": [
        "ba6f1e",
        "fcf592"
    ],
    "1faf8-1f3fd": [
        "74442f",
        "bb7b58"
    ],
    "1f63e": [
        "eac294",
        "c18f1f"
    ],
    "1f6d0": [
        "9237ae",
        "f7f4f8"
    ],
    "1f936-1f3ff": [
        "ad7270",
        "3a2923"
    ],
    "1f32a-fe0f": [
        "a1a6b4",
        "5a5c70"
    ],
    "1f1ec-1f1f7": [
        "12125d",
        "e9e9eb"
    ],
    "1f62a": [
        "714715",
        "3ca6e0"
    ],
    "1f196": [
        "65839e",
        "fbfbfb"
    ],
    "1f469-1f3fd-200d-1f37c": [
        "120a05",
        "62396a"
    ],
    "1f468-1f3ff-200d-1f373": [
        "dedcd7",
        "5d4537"
    ],
    "1faf1": [
        "be7c01",
        "fcd357"
    ],
    "1f481-1f3fb": [
        "292423",
        "b6b5b5"
    ],
    "1f448-1f3fb": [
        "e2af89",
        "000000"
    ],
    "1fac3-1f3fe": [
        "77482e",
        "5891dd"
    ],
    "1f44d-1f3fc": [
        "d3a27a",
        "e1bd97"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff": [
        "2d1f1a",
        "d0a678"
    ],
    "1fad9": [
        "fdfdfd",
        "b7b7b7"
    ],
    "1f9dc-1f3fb": [
        "e1b772",
        "606895"
    ],
    "1f468-1f3ff-200d-1f3a4": [
        "476497",
        "231a16"
    ],
    "1f938-1f3fd-200d-2642-fe0f": [
        "312d2e",
        "a36d53"
    ],
    "1f46e-1f3fb": [
        "202023",
        "e1b88d"
    ],
    "1f357": [
        "c98c4d",
        "d6c3a8"
    ],
    "1f469-1f3fc": [
        "dcc490",
        "9b6f3b"
    ],
    "270c-fe0f": [
        "ca830a",
        "381504"
    ],
    "1f431": [
        "cc9809",
        "fbe17d"
    ],
    "1f3cf": [
        "1c0c0b",
        "cd2523"
    ],
    "1f1f2-1f1ea": [
        "9b743a",
        "63501d"
    ],
    "1f471-1f3fc-200d-2642-fe0f": [
        "c8a367",
        "b2774b"
    ],
    "1f425": [
        "f7c833",
        "9e4d1c"
    ],
    "1f3a8": [
        "d59d3d",
        "68601e"
    ],
    "1f3bb": [
        "29150c",
        "a56d42"
    ],
    "1f6a3-1f3fb-200d-2640-fe0f": [
        "d0bda7",
        "010101"
    ],
    "1f4dd": [
        "7d6d69",
        "e5e5e5"
    ],
    "1f6b4-200d-2640-fe0f": [
        "631586",
        "d7a423"
    ],
    "1f343": [
        "d1d0d1",
        "82b436"
    ],
    "1f4aa-1f3fd": [
        "825840",
        "bf8e68"
    ],
    "1f4e6": [
        "bca691",
        "76522d"
    ],
    "1f35a": [
        "cdcac6",
        "b1afac"
    ],
    "1f3c0": [
        "ce8c69",
        "43332a"
    ],
    "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff": [
        "9b9998",
        "5c4334"
    ],
    "1f3c4-200d-2640-fe0f": [
        "e8b630",
        "632b47"
    ],
    "1f419": [
        "9a2738",
        "ed8d9d"
    ],
    "1f42c": [
        "4ec9e2",
        "2396bc"
    ],
    "1f6b4-1f3fb-200d-2640-fe0f": [
        "1b151a",
        "dcb289"
    ],
    "1f3b4": [
        "595656",
        "dbd0c5"
    ],
    "1f91f-1f3fe": [
        "58301d",
        "9d663e"
    ],
    "1f4d2": [
        "b4992f",
        "aeb1b6"
    ],
    "1f34e": [
        "fc8d79",
        "489215"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc": [
        "842d1d",
        "c79e71"
    ],
    "1f9dd-200d-2642-fe0f": [
        "e6b128",
        "e9e0ac"
    ],
    "1f468-200d-2708-fe0f": [
        "a8a28f",
        "252422"
    ],
    "1f3c2-1f3fc": [
        "1873a8",
        "c85d2c"
    ],
    "1f469-1f3fb-200d-1f9bd": [
        "1c1a20",
        "dfb899"
    ],
    "1f380": [
        "c05779",
        "e080a1"
    ],
    "1f6b6-1f3ff": [
        "cfcdcc",
        "120f20"
    ],
    "1f574-1f3fb": [
        "5c5957",
        "e3c8b2"
    ],
    "1f469-1f3fb-200d-1f9b2": [
        "e2b18c",
        "040301"
    ],
    "1f38f": [
        "e4e7da",
        "edcb6f"
    ],
    "1fac5-1f3fb": [
        "cc9916",
        "3c3430"
    ],
    "1f44b-1f3fd": [
        "6b4431",
        "be8f6a"
    ],
    "1f487-1f3fe": [
        "d1cfcd",
        "564238"
    ],
    "1f9d9-1f3fd": [
        "9c8a63",
        "66593e"
    ],
    "1f9cd-1f3fc-200d-2642-fe0f": [
        "5a2720",
        "ce9c73"
    ],
    "1f551": [
        "aeb1b5",
        "f6f6f6"
    ],
    "1f469-1f3fd-200d-1f9bc": [
        "3b373b",
        "9f9193"
    ],
    "1f3c3-1f3fb-200d-2642-fe0f": [
        "e4ba99",
        "2c2b42"
    ],
    "1f468-1f3ff-200d-1f9b3": [
        "c4c4c3",
        "2a1d15"
    ],
    "1f54c": [
        "6b4a35",
        "f4d3b2"
    ],
    "1f46e-1f3ff-200d-2640-fe0f": [
        "4a3e39",
        "396a9d"
    ],
    "1f23a": [
        "f89202",
        "fbfaf7"
    ],
    "26a1": [
        "dfae27",
        "0f3053"
    ],
    "1f9d8-1f3fd-200d-2640-fe0f": [
        "56341d",
        "ad7a5c"
    ],
    "1f1f7-1f1f4": [
        "a12029",
        "f1cd3a"
    ],
    "1f6cc-1f3fd": [
        "d6dde4",
        "926246"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "b37d4d",
        "352922"
    ],
    "1f64e-1f3fe-200d-2642-fe0f": [
        "573e30",
        "4372b1"
    ],
    "1f926-200d-2640-fe0f": [
        "f4c130",
        "76048b"
    ],
    "1f9da-1f3fb-200d-2640-fe0f": [
        "9ee3cc",
        "c68f65"
    ],
    "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc": [
        "e3b8a0",
        "312723"
    ],
    "1f443-1f3ff": [
        "43312a",
        "533e35"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe": [
        "673c29",
        "1f4576"
    ],
    "1f3c3-1f3fd-200d-2642-fe0f-200d-27a1-fe0f": [
        "ba215f",
        "f7f3ec"
    ],
    "1f469-1f3fc-200d-1f9af-200d-27a1-fe0f": [
        "bf45bc",
        "e7e2da"
    ],
    "1f468-200d-1f468-200d-1f467-200d-1f466": [
        "4f677b",
        "c0cdd8"
    ],
    "1f9b8-1f3fb-200d-2642-fe0f": [
        "261e26",
        "ddaa89"
    ],
    "1f3c4-1f3fd": [
        "ab8063",
        "df6d09"
    ],
    "1f1e7-1f1e6": [
        "272785",
        "f0c822"
    ],
    "1f9db-1f3fb-200d-2642-fe0f": [
        "121111",
        "999290"
    ],
    "1f96f": [
        "f4bf80",
        "a16736"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe": [
        "8b593b",
        "472f24"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "4b3124",
        "d8b683"
    ],
    "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc": [
        "104d85",
        "83543e"
    ],
    "1f9a3": [
        "6e523c",
        "010000"
    ],
    "1f97b": [
        "bf2006",
        "d97e15"
    ],
    "1f948": [
        "cbcbcc",
        "838388"
    ],
    "1f960": [
        "caa365",
        "8c682f"
    ],
    "1f46c-1f3fe": [
        "114e86",
        "a31613"
    ],
    "1f9ae": [
        "e5e7e7",
        "8f6e46"
    ],
    "1f469-1f3fd-200d-2695-fe0f": [
        "84583b",
        "c9c9c9"
    ],
    "1f9d6-1f3fb-200d-2642-fe0f": [
        "ddedef",
        "413730"
    ],
    "1f6b6-1f3fc-200d-2640-fe0f-200d-27a1-fe0f": [
        "c044be",
        "32308d"
    ],
    "1f974": [
        "bb7018",
        "fef285"
    ],
    "1f477-200d-2640-fe0f": [
        "c58c22",
        "76a7d3"
    ],
    "1f645-1f3fc-200d-2642-fe0f": [
        "b5864d",
        "255da1"
    ],
    "1f6b6-1f3ff-200d-2640-fe0f": [
        "b837bc",
        "3b3f8c"
    ],
    "1f3d5-fe0f": [
        "3b5530",
        "e77641"
    ],
    "1f91e": [
        "ce860b",
        "ab6409"
    ],
    "1f9d1-1f3fb-200d-1f9b0": [
        "733813",
        "d09b76"
    ],
    "1f575-1f3ff": [
        "231d1a",
        "b7bcb6"
    ],
    "1f9f0": [
        "a41710",
        "b8aeb6"
    ],
    "1f3d4-fe0f": [
        "89a8bc",
        "36473f"
    ],
    "1f9d8": [
        "b67510",
        "bbb7ad"
    ],
    "1f481-1f3ff-200d-2642-fe0f": [
        "867f70",
        "2e2624"
    ],
    "1f913": [
        "bc7723",
        "f9d037"
    ],
    "1f9ff": [
        "132681",
        "d9e2ef"
    ],
    "1f9ce-1f3fe": [
        "3e2e25",
        "c3c0be"
    ],
    "1f3cc-1f3fd-200d-2642-fe0f": [
        "c4c8c4",
        "817771"
    ],
    "1f3cb-1f3fe": [
        "7c7774",
        "c5c3c2"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "4a3428",
        "fd91d8"
    ],
    "1f7e3": [
        "6b17a0",
        "aa2afc"
    ],
    "1f1ea-1f1ea": [
        "4370ac",
        "e7e7e7"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe": [
        "84614c",
        "f270be"
    ],
    "1f1f3-1f1ee": [
        "4b72c2",
        "e8e9e7"
    ],
    "26f9-1f3fd": [
        "9b7057",
        "523422"
    ],
    "1f46d-1f3ff": [
        "2a1c17",
        "c4372e"
    ],
    "1f477-1f3fc": [
        "c08b4a",
        "79aad6"
    ],
    "1f9db-1f3ff": [
        "0a0707",
        "a6a29e"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb": [
        "3d2e30",
        "e0be94"
    ],
    "1f64b-1f3fc-200d-2640-fe0f": [
        "e5c993",
        "8d309d"
    ],
    "1f449-1f3ff": [
        "44312b",
        "241912"
    ],
    "1f590-1f3fd": [
        "7e503b",
        "c0906a"
    ],
    "1f5dd-fe0f": [
        "504d50",
        "b2b0b0"
    ],
    "1f937-1f3ff-200d-2642-fe0f": [
        "0c090a",
        "2a4071"
    ],
    "1f6b6-200d-2640-fe0f-200d-27a1-fe0f": [
        "b852b6",
        "daa128"
    ],
    "1f647-200d-2642-fe0f": [
        "fae6a2",
        "141118"
    ],
    "1f5de-fe0f": [
        "e2e2e2",
        "959492"
    ],
    "1f6b6-1f3fd-200d-2642-fe0f-200d-27a1-fe0f": [
        "d52e51",
        "3d4785"
    ],
    "1faf4-1f3fc": [
        "cd976f",
        "000000"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe": [
        "805a45",
        "f2c2b8"
    ],
    "1f536": [
        "e67802",
        "fdb423"
    ],
    "1f468-1f3fb-200d-1f9bc": [
        "3f373c",
        "abaaa0"
    ],
    "1f937-1f3fb": [
        "e1cdb7",
        "282524"
    ],
    "1f3c3-1f3fc-200d-2640-fe0f-200d-27a1-fe0f": [
        "ca9d77",
        "241d51"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc": [
        "966842",
        "402d27"
    ],
    "1f250": [
        "cc0801",
        "e7a19e"
    ],
    "1f6b5-1f3ff-200d-2642-fe0f": [
        "737572",
        "c9d1cb"
    ],
    "1f1f0-1f1f7": [
        "a6a3a4",
        "030303"
    ],
    "26fd": [
        "c4242b",
        "d0d0d0"
    ],
    "1f522": [
        "65829d",
        "f7f8f9"
    ],
    "1f3c4-1f3fd-200d-2640-fe0f": [
        "a67459",
        "623140"
    ],
    "1f646-1f3fc-200d-2640-fe0f": [
        "9e46af",
        "551560"
    ],
    "1f9d3-1f3fd": [
        "b26406",
        "c2b292"
    ],
    "26f2": [
        "7cb4bc",
        "070402"
    ],
    "1f9d1-1f3fe-200d-1f9b3": [
        "918780",
        "4c2d1d"
    ],
    "1f482-1f3ff-200d-2640-fe0f": [
        "443b2d",
        "dbd9cb"
    ],
    "1f52d": [
        "adaaa9",
        "2c2c2c"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc": [
        "e3c89b",
        "662d5d"
    ],
    "1f450-1f3fe": [
        "5f3520",
        "99633c"
    ],
    "1f481": [
        "c08414",
        "919292"
    ],
    "1f17e-fe0f": [
        "d52111",
        "fcfafa"
    ],
    "1f468-1f3fd-200d-1f9bd": [
        "88302a",
        "342f30"
    ],
    "1f385-1f3fe": [
        "c8c3c0",
        "784b38"
    ],
    "1f6e9-fe0f": [
        "d9ddde",
        "8f98a0"
    ],
    "1f495": [
        "ce1872",
        "f79dd6"
    ],
    "1f1f5-1f1eb": [
        "b59191",
        "701f27"
    ],
    "1f1f5-1f1f8": [
        "1c1d1b",
        "e2e2e1"
    ],
    "1f91a-1f3ff": [
        "46322c",
        "5a463a"
    ],
    "1f468-1f3fd-200d-1f9b2": [
        "9f6d50",
        "c1906a"
    ],
    "26f9-1f3fe-200d-2642-fe0f": [
        "73482b",
        "145497"
    ],
    "1f49c": [
        "9f36e5",
        "000000"
    ],
    "1f328-fe0f": [
        "c5d3dd",
        "549ad7"
    ],
    "1f442": [
        "de960d",
        "fdcd48"
    ],
    "1f93e-1f3fd-200d-2642-fe0f": [
        "964337",
        "d9d6d1"
    ],
    "1f4bc": [
        "a98970",
        "462e22"
    ],
    "1f4a9": [
        "986c4f",
        "815032"
    ],
    "1faf1-1f3fb-200d-1faf2-1f3ff": [
        "503b32",
        "f2cdab"
    ],
    "1f9d4-1f3ff-200d-2642-fe0f": [
        "362e2b",
        "cccac9"
    ],
    "1f330": [
        "e9c894",
        "5b210d"
    ],
    "1f329-fe0f": [
        "c0cbd2",
        "fed12c"
    ],
    "1f1f8-1f1e7": [
        "174b32",
        "2f65a4"
    ],
    "1f456": [
        "5c6e99",
        "b5c3d4"
    ],
    "1f3ea": [
        "3b5556",
        "b0bab2"
    ],
    "2603-fe0f": [
        "5d4e48",
        "d3eefb"
    ],
    "1f44d": [
        "e49e12",
        "fed45c"
    ],
    "1f3d3": [
        "ef3633",
        "c8ad88"
    ],
    "1f4b5": [
        "5c5230",
        "dedccd"
    ],
    "1f318": [
        "78756c",
        "263143"
    ],
    "2602-fe0f": [
        "e3e3e0",
        "58595a"
    ],
    "1f4c1": [
        "a4adb4",
        "596671"
    ],
    "1f33f": [
        "316515",
        "5fa82a"
    ],
    "1f3e7": [
        "173964",
        "73b0dd"
    ],
    "1f1f8-1f1ea": [
        "0b466e",
        "e0bf2c"
    ],
    "1f1e8-1f1fc": [
        "09204c",
        "d6cb25"
    ],
    "1f1e8-1f1e9": [
        "2097be",
        "1e475a"
    ],
    "1f9d5-1f3fc": [
        "71451e",
        "523b8f"
    ],
    "1f683": [
        "a2ac36",
        "4a5e49"
    ],
    "1f468-1f3fb-200d-1f37c": [
        "e6b996",
        "603c67"
    ],
    "1f487-1f3fd-200d-2642-fe0f": [
        "c6c4c2",
        "8d5e43"
    ],
    "1f442-1f3fb": [
        "e1af8a",
        "000000"
    ],
    "1f3cb-fe0f-200d-2642-fe0f": [
        "4e5b67",
        "381616"
    ],
    "1f469-1f3fe-200d-1f9af-200d-27a1-fe0f": [
        "bc40bb",
        "e3d6dc"
    ],
    "1f9d1-1f3fe-200d-1f3a4": [
        "47aa3b",
        "2c2b1f"
    ],
    "1f64f-1f3ff": [
        "402f28",
        "5290d4"
    ],
    "1fa7c": [
        "707173",
        "303337"
    ],
    "1f697": [
        "4dacc1",
        "0c0808"
    ],
    "1f9d7-1f3ff-200d-2640-fe0f": [
        "2a1e1b",
        "91826e"
    ],
    "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd": [
        "9b928d",
        "564033"
    ],
    "1faa2": [
        "841415",
        "0f2f74"
    ],
    "1f1e8-1f1f5": [
        "c33c34",
        "7d8190"
    ],
    "1f931-1f3fe": [
        "3b2b2a",
        "6d9d83"
    ],
    "1f68e": [
        "79b0b5",
        "1f1d1b"
    ],
    "1fa75": [
        "6bd5f6",
        "ace2f6"
    ],
    "1f69a": [
        "7e9196",
        "0b0808"
    ],
    "1f9d1-1f3fb-200d-2696-fe0f": [
        "252222",
        "dba672"
    ],
    "1faad": [
        "a10726",
        "9a6157"
    ],
    "1f9d1-1f3fe-200d-1f373": [
        "dedcd6",
        "92603c"
    ],
    "1f9b9-1f3ff-200d-2640-fe0f": [
        "0d090a",
        "532181"
    ],
    "1f6ba": [
        "9237ae",
        "fcfbfc"
    ],
    "1f9d8-200d-2642-fe0f": [
        "c47b14",
        "e9ad28"
    ],
    "1f640": [
        "e8e2d8",
        "886926"
    ],
    "1f468-1f3fb-200d-2708-fe0f": [
        "9e8549",
        "2a2826"
    ],
    "1faf2-1f3fd": [
        "a96d4e",
        "211208"
    ],
    "1f468-1f3fc-200d-1f9b1": [
        "ab7d4e",
        "dfc293"
    ],
    "1f9dc-1f3ff-200d-2640-fe0f": [
        "412b2b",
        "8ccce8"
    ],
    "1f344-200d-1f7eb": [
        "5f2612",
        "c67c49"
    ],
    "1f6b7": [
        "e56037",
        "2f2b2a"
    ],
    "1f64f": [
        "cd810b",
        "050f38"
    ],
    "1f471-1f3fd": [
        "88603f",
        "c8a96c"
    ],
    "1f596-1f3fc": [
        "c68a60",
        "dfb994"
    ],
    "1fac4-1f3ff": [
        "2b221f",
        "bbbaba"
    ],
    "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb": [
        "114f87",
        "83523f"
    ],
    "1f6c3": [
        "0057b5",
        "f1f5f9"
    ],
    "1f647-1f3fd": [
        "b1805a",
        "0c0906"
    ],
    "1f9da-1f3fd-200d-2640-fe0f": [
        "9ee2ca",
        "804f3b"
    ],
    "1f596-1f3fb": [
        "daa27c",
        "fadec1"
    ],
    "1f647-1f3fe": [
        "6a4a34",
        "84817d"
    ],
    "1f6c2": [
        "0055ae",
        "f3f6f9"
    ],
    "1f6b6": [
        "cdcbc9",
        "1e1e4e"
    ],
    "1f471-1f3fe": [
        "794c2d",
        "ebe09c"
    ],
    "1f468-1f3fc-200d-1f9b0": [
        "eb9529",
        "c7936d"
    ],
    "2b05-fe0f": [
        "66839e",
        "fcfcfd"
    ],
    "1faf2-1f3fe": [
        "834825",
        "3c1d0c"
    ],
    "1f9d8-1f3fb-200d-2640-fe0f": [
        "a55171",
        "f1cdab"
    ],
    "1f64e-1f3fc-200d-2642-fe0f": [
        "dcc48a",
        "3864a0"
    ],
    "1f3da-fe0f": [
        "94745a",
        "664333"
    ],
    "1f641": [
        "be6321",
        "fdd136"
    ],
    "1f469-1f3fd-200d-1f9bc-200d-27a1-fe0f": [
        "c243be",
        "555e80"
    ],
    "1fa74": [
        "5a969c",
        "2e526a"
    ],
    "1f93d-1f3ff-200d-2640-fe0f": [
        "654840",
        "ebf1f1"
    ],
    "1faae": [
        "777777",
        "3b3c3d"
    ],
    "1f3cc-fe0f-200d-2640-fe0f": [
        "c1c0bb",
        "dba125"
    ],
    "1f1e8-1f1f4": [
        "bea222",
        "7d1622"
    ],
    "1f68d": [
        "2f2d27",
        "b2ab97"
    ],
    "1f931-1f3fd": [
        "664a3b",
        "99d1be"
    ],
    "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe": [
        "989695",
        "342a25"
    ],
    "1f696": [
        "6382a0",
        "ccdbca"
    ],
    "1fa7b": [
        "f1f3f4",
        "2592c1"
    ],
    "1f442-1f3fc": [
        "cb9269",
        "000000"
    ],
    "1faa3": [
        "8fa2ab",
        "225260"
    ],
    "1f1e8-1f1e8": [
        "196b1a",
        "9fad54"
    ],
    "1f1e8-1f1fb": [
        "0b2858",
        "c5c2c6"
    ],
    "1f9cd-1f3fe-200d-2642-fe0f": [
        "563427",
        "9c7052"
    ],
    "1f682": [
        "ad2d2a",
        "d2d2d1"
    ],
    "1f3c3-1f3fd-200d-2642-fe0f": [
        "a67256",
        "171a3a"
    ],
    "1f9d5-1f3fb": [
        "71451e",
        "ddbdb7"
    ],
    "1f4c0": [
        "ded8b5",
        "ad9c5c"
    ],
    "1f5d1-fe0f": [
        "9ca8b3",
        "5e5f61"
    ],
    "1f3e6": [
        "e7ebeb",
        "9aabae"
    ],
    "1f486-1f3ff-200d-2640-fe0f": [
        "312827",
        "523f37"
    ],
    "1f45a": [
        "b26898",
        "eba1d2"
    ],
    "1f1e6-1f1ee": [
        "1c1350",
        "d7c1bd"
    ],
    "1f3d2": [
        "c8675e",
        "8effff"
    ],
    "1f44e": [
        "cc7a0c",
        "fed357"
    ],
    "1f469-1f3fb-200d-2695-fe0f": [
        "625657",
        "ded1c5"
    ],
    "1f9d6-1f3fd-200d-2642-fe0f": [
        "dcedef",
        "ba9d85"
    ],
    "1f319": [
        "f7d157",
        "f6e3c5"
    ],
    "1f4b4": [
        "575d4e",
        "d4d5ca"
    ],
    "1f331": [
        "5b9521",
        "84b34f"
    ],
    "1f4cf": [
        "fdfbf7",
        "768290"
    ],
    "1f457": [
        "2c8584",
        "3ae0c9"
    ],
    "1f1f8-1f1e6": [
        "105e38",
        "7da792"
    ],
    "1f443": [
        "d39516",
        "f9c62f"
    ],
    "1f4a8": [
        "b1c2d4",
        "000000"
    ],
    "1f4bb": [
        "434141",
        "9b9b9b"
    ],
    "1f9b8-1f3fd-200d-2642-fe0f": [
        "6d3f2a",
        "6c3b88"
    ],
    "1f468-1f3fd-200d-1f9b3": [
        "c4c3c2",
        "774d38"
    ],
    "1f469-1f3ff-200d-1f9bc": [
        "413d42",
        "a4a5a6"
    ],
    "1f49b": [
        "ec851e",
        "fcdd6b"
    ],
    "1f48f": [
        "fae3af",
        "e451a5"
    ],
    "1f9db-1f3fd-200d-2642-fe0f": [
        "100f10",
        "919090"
    ],
    "1f9ce-200d-27a1-fe0f": [
        "b47e1d",
        "d4cfc9"
    ],
    "1f385-1f3fd": [
        "c7bfba",
        "b08c77"
    ],
    "1f1f5-1f1f9": [
        "9c1815",
        "2d3a07"
    ],
    "1f1f5-1f1ec": [
        "923234",
        "2a1717"
    ],
    "1f494": [
        "b40d05",
        "fc766c"
    ],
    "1f480": [
        "d1d2d2",
        "444443"
    ],
    "1f450-1f3fd": [
        "714834",
        "bd8d68"
    ],
    "1f9d1-1f3fc-200d-1f9bc": [
        "423c42",
        "c9b695"
    ],
    "1f9d1-1f3fe-200d-1f9b2": [
        "603720",
        "a8754c"
    ],
    "26f3": [
        "e9bc51",
        "74b53d"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f4d3c0",
        "a87a4a"
    ],
    "1f9d1-200d-1f9bc-200d-27a1-fe0f": [
        "d7d6d3",
        "4f5775"
    ],
    "1f52e": [
        "eecef3",
        "9e5ea2"
    ],
    "1f53a": [
        "c51200",
        "000000"
    ],
    "1f9d3-1f3fe": [
        "c77c06",
        "d5d4d2"
    ],
    "1f938-1f3fb-200d-2642-fe0f": [
        "292b2f",
        "daa37e"
    ],
    "1f468-200d-1f393": [
        "c1af86",
        "7b6b53"
    ],
    "1f469-200d-1f9af": [
        "c03bc5",
        "64566c"
    ],
    "21aa-fe0f": [
        "65829c",
        "fafbfb"
    ],
    "1f9d1-1f3fe-200d-1f9bd": [
        "825e44",
        "322d2c"
    ],
    "1f170-fe0f": [
        "ed2c19",
        "f79a8e"
    ],
    "1f523": [
        "65829d",
        "f3f5f6"
    ],
    "1f171-fe0f": [
        "db2212",
        "fbf8f8"
    ],
    "1f937-1f3fc": [
        "c29464",
        "b1afae"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd": [
        "bd8c6c",
        "2d1f16"
    ],
    "1f537": [
        "00408e",
        "066fce"
    ],
    "1f1eb-1f1f2": [
        "577a92",
        "000000"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb": [
        "cf9976",
        "382a25"
    ],
    "1f251": [
        "e87a00",
        "fbfaf9"
    ],
    "1f3cb-1f3ff-200d-2640-fe0f": [
        "473f40",
        "261c19"
    ],
    "1faf4-1f3fb": [
        "e1af8b",
        "000000"
    ],
    "1f58d-fe0f": [
        "ce7373",
        "995050"
    ],
    "1f44e-1f3ff": [
        "372720",
        "4f3b33"
    ],
    "1f590-1f3fe": [
        "633822",
        "9b643d"
    ],
    "1f935-1f3fd-200d-2642-fe0f": [
        "72492f",
        "b08161"
    ],
    "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff": [
        "9c9997",
        "362d28"
    ],
    "1f477-1f3fb": [
        "ce9641",
        "463b31"
    ],
    "1f9dd-1f3ff-200d-2642-fe0f": [
        "3f3428",
        "cac189"
    ],
    "26f9-1f3fe": [
        "72482d",
        "b4b1af"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd": [
        "b5886a",
        "684e41"
    ],
    "1f468-1f3ff": [
        "382e2c",
        "d1cbc3"
    ],
    "1f468-1f3fd-200d-1f373": [
        "dcdad5",
        "b4835f"
    ],
    "1f469-1f3ff-200d-1f37c": [
        "1b1819",
        "65396c"
    ],
    "1f3ca-1f3ff-200d-2642-fe0f": [
        "cae5f0",
        "3b2a24"
    ],
    "2734-fe0f": [
        "f58601",
        "fcfbf9"
    ],
    "1f7e2": [
        "018701",
        "2bdb2b"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb": [
        "f5ccbc",
        "ad7b4f"
    ],
    "1f468-1f3fd-200d-1f3a4": [
        "456194",
        "b27e65"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "86593d",
        "d94296"
    ],
    "27a1-fe0f": [
        "66849f",
        "b8cbda"
    ],
    "1f3cb-1f3fd": [
        "4f4f52",
        "c7bdb3"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff": [
        "2d201a",
        "834730"
    ],
    "1f1ea-1f1e6": [
        "a34f33",
        "64171b"
    ],
    "1f9d1-200d-1f9d2": [
        "526b80",
        "fcfcfc"
    ],
    "1f9ce-1f3fd": [
        "5e4330",
        "b9b6b5"
    ],
    "1f9d1-1f3fc-200d-1f37c": [
        "decb8b",
        "623864"
    ],
    "1f3c3-1f3ff": [
        "3f302c",
        "d2d0cd"
    ],
    "1f6b4-1f3fd-200d-2640-fe0f": [
        "47413d",
        "7a6883"
    ],
    "1f9d9": [
        "696844",
        "f2be2d"
    ],
    "1f9db-200d-2642-fe0f": [
        "121111",
        "f4c12d"
    ],
    "1f912": [
        "c06026",
        "fcd73f"
    ],
    "1f9d1-1f3fb-200d-1f9b1": [
        "695243",
        "f8e0c2"
    ],
    "1f9f1": [
        "a74122",
        "4d1a0c"
    ],
    "1f471-1f3fe-200d-2642-fe0f": [
        "c3aa62",
        "522f1c"
    ],
    "1f6a3-1f3fd-200d-2640-fe0f": [
        "9d6950",
        "aac5d1"
    ],
    "1f91d": [
        "d69206",
        "010000"
    ],
    "1f9f3": [
        "291b13",
        "574132"
    ],
    "1f9d1-1f3fb-200d-1f9b3": [
        "c99979",
        "efd5bb"
    ],
    "1f938": [
        "494847",
        "f2c64c"
    ],
    "1f575-1f3fe": [
        "221a15",
        "9f967e"
    ],
    "1f91f": [
        "b66007",
        "fecf4e"
    ],
    "1f9fe": [
        "d5d4d4",
        "8e8e8e"
    ],
    "1f3c3-1f3fd": [
        "ac795c",
        "0d0e27"
    ],
    "1f9b9-1f3fb-200d-2642-fe0f": [
        "141012",
        "d1a280"
    ],
    "1f910": [
        "fabb22",
        "8b8885"
    ],
    "1f468-1f3fe-200d-1f9bc": [
        "463c3d",
        "96a9a4"
    ],
    "1f9dc-1f3fb-200d-2642-fe0f": [
        "e4ba7d",
        "616d9a"
    ],
    "270a-1f3fb": [
        "cf8f69",
        "f8dbbb"
    ],
    "1f9d1-1f3ff-200d-2695-fe0f": [
        "201a18",
        "d5d7d7"
    ],
    "1f9cf-1f3fc-200d-2640-fe0f": [
        "c99c6a",
        "331134"
    ],
    "1f3cb-1f3ff": [
        "4a5563",
        "443732"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "4d3930",
        "d84297"
    ],
    "1f9ce-1f3ff": [
        "4e4847",
        "acaaa9"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd": [
        "a5714d",
        "2d4e7a"
    ],
    "1f46d-1f3fe": [
        "74432b",
        "cd3f30"
    ],
    "1f468-1f3fd": [
        "744a2f",
        "bb8c6a"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff": [
        "191411",
        "e849a6"
    ],
    "1f9d7-1f3fb-200d-2642-fe0f": [
        "e57338",
        "847969"
    ],
    "1f468-1f3fd-200d-2695-fe0f": [
        "b1805f",
        "c9cbcb"
    ],
    "1f7e0": [
        "db7a00",
        "fac368"
    ],
    "1f1ea-1f1f8": [
        "a34f33",
        "64171b"
    ],
    "1f449-1f3fe": [
        "804c2e",
        "472617"
    ],
    "1f3ca-200d-2642-fe0f": [
        "cae5f0",
        "000000"
    ],
    "1f44e-1f3fd": [
        "794e39",
        "bf8e68"
    ],
    "1f9ce-200d-2640-fe0f": [
        "deab2f",
        "252b54"
    ],
    "1f9db-1f3fe": [
        "0a0808",
        "555455"
    ],
    "1f9ce-1f3fc-200d-2642-fe0f": [
        "e1d7c9",
        "2c335a"
    ],
    "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd": [
        "9b9998",
        "4b382e"
    ],
    "1f9d4-1f3fb-200d-2640-fe0f": [
        "46403e",
        "f0d1b3"
    ],
    "1f9b6-1f3fc": [
        "af6a40",
        "cf9970"
    ],
    "0039-fe0f-20e3": [
        "66839e",
        "fbfbfc"
    ],
    "1f6e2-fe0f": [
        "f6f5f5",
        "8a2a29"
    ],
    "1f9d9-1f3fd-200d-2640-fe0f": [
        "413325",
        "a98558"
    ],
    "1f521": [
        "65829d",
        "f8f9f9"
    ],
    "303d-fe0f": [
        "fda500",
        "000000"
    ],
    "1f64d-1f3fe-200d-2642-fe0f": [
        "976941",
        "4473b1"
    ],
    "1f6e3-fe0f": [
        "3e6942",
        "010000"
    ],
    "1f535": [
        "0153c8",
        "71aff0"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff": [
        "564945",
        "eecaa9"
    ],
    "1f1eb-1f1f0": [
        "1c3e79",
        "906a7c"
    ],
    "1f9d1-1f3fe-200d-1f9b0": [
        "40291f",
        "96623b"
    ],
    "00a9-fe0f": [
        "474747",
        "c8c8c8"
    ],
    "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb": [
        "104e87",
        "81523f"
    ],
    "1f53c": [
        "65829d",
        "fdfdfd"
    ],
    "1f509": [
        "9de6f0",
        "616569"
    ],
    "1f496": [
        "e7349f",
        "f89ad4"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb": [
        "e8c0a3",
        "b87e54"
    ],
    "1f1f5-1f1ea": [
        "891b27",
        "f5f2f2"
    ],
    "1f46b-1f3fb": [
        "833f2f",
        "e4b693"
    ],
    "1f385-1f3ff": [
        "65463e",
        "e1e0de"
    ],
    "1f482-1f3fb-200d-2642-fe0f": [
        "4a4846",
        "b48e6e"
    ],
    "1f470-1f3fc-200d-2642-fe0f": [
        "d2cabf",
        "927b65"
    ],
    "1f450-1f3ff": [
        "31231b",
        "574338"
    ],
    "1f482": [
        "4e402d",
        "e2b335"
    ],
    "1f468-1f3fd-200d-1f9b1": [
        "482813",
        "b88663"
    ],
    "1f91a-1f3fe": [
        "8b5533",
        "9d663e"
    ],
    "1f6b5-1f3fb-200d-2640-fe0f": [
        "7e7970",
        "cfbba3"
    ],
    "1f48d": [
        "a4aaaf",
        "f7fafa"
    ],
    "1f9d1-1f3fb-200d-1f373": [
        "dca77e",
        "2d2017"
    ],
    "1f455": [
        "303e68",
        "87b6e1"
    ],
    "1f3eb": [
        "db8150",
        "6f7b7c"
    ],
    "1f3f8": [
        "a89a7b",
        "d3d0bd"
    ],
    "1f4cd": [
        "bb5c5e",
        "e0c5c0"
    ],
    "1f333": [
        "2b4517",
        "9bc831"
    ],
    "1f937-1f3fb-200d-2640-fe0f": [
        "d19f3c",
        "552a57"
    ],
    "1faf1-1f3fb-200d-1faf2-1f3fe": [
        "8d5734",
        "f2cdab"
    ],
    "1f45c": [
        "ebc8b3",
        "a86d47"
    ],
    "1f469": [
        "f6c130",
        "955907"
    ],
    "1f3e4": [
        "c3b6a5",
        "5e4c4b"
    ],
    "1f1f8-1f1f8": [
        "040404",
        "c75854"
    ],
    "1f4c2": [
        "909ba4",
        "667785"
    ],
    "1f33e": [
        "d6a73d",
        "679023"
    ],
    "1f9d1-1f3fb-200d-1f3a4": [
        "46aa3a",
        "e9caaa"
    ],
    "1f4b6": [
        "5b795d",
        "d9e5df"
    ],
    "1f468-1f3fe-200d-1f37c": [
        "6e4432",
        "92c2ad"
    ],
    "1f3d0": [
        "bdbdbd",
        "505050"
    ],
    "1faa1": [
        "1a71aa",
        "90887f"
    ],
    "1f64f-1f3fe": [
        "693c24",
        "134b8d"
    ],
    "1f694": [
        "745053",
        "b7cace"
    ],
    "1f680": [
        "232d41",
        "c51808"
    ],
    "1f1ed-1f1fa": [
        "b8363d",
        "ecebeb"
    ],
    "1f9d1-200d-1f9d2-200d-1f9d2": [
        "607c95",
        "fcfcfc"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb": [
        "901a17",
        "dbb191"
    ],
    "1f939-200d-2642-fe0f": [
        "3f342e",
        "cecfbf"
    ],
    "1f90c-1f3fb": [
        "e8bb98",
        "f8ddbe"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "473124",
        "c18a66"
    ],
    "1fa76": [
        "7a7a7a",
        "c0c0c0"
    ],
    "1f69b": [
        "859da5",
        "037503"
    ],
    "1f1ed-1f1f7": [
        "b82d2f",
        "e7e4e4"
    ],
    "1f931-1f3ff": [
        "493e43",
        "9edacc"
    ],
    "1f68f": [
        "5e5f5f",
        "d7d7d5"
    ],
    "1f481-1f3fb-200d-2640-fe0f": [
        "3f353a",
        "eac2a1"
    ],
    "1f473-1f3fc-200d-2640-fe0f": [
        "d9ba8c",
        "bf8e68"
    ],
    "1f468-1f3fc-200d-1f9b2": [
        "bf835a",
        "d6a981"
    ],
    "1f643": [
        "c7771c",
        "fef592"
    ],
    "1f6a8": [
        "f5d4d3",
        "e14230"
    ],
    "1f6bb": [
        "65829d",
        "fcfcfc"
    ],
    "1f44c-1f3fc": [
        "cf9970",
        "a25d35"
    ],
    "1fac4-1f3fe": [
        "392720",
        "babab9"
    ],
    "1f6c0": [
        "90968f",
        "c0c9b8"
    ],
    "1f473-200d-2642-fe0f": [
        "d1d0ce",
        "b37c0a"
    ],
    "1f486-1f3fb": [
        "252120",
        "f4d5b6"
    ],
    "1f468-1f3fc-200d-1f9bd": [
        "aa292c",
        "333134"
    ],
    "26f4-fe0f": [
        "445272",
        "a0a39d"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe": [
        "4d382f",
        "fd92d8"
    ],
    "1f6b6-1f3fb-200d-2642-fe0f": [
        "bf1543",
        "444f8b"
    ],
    "1f64e": [
        "b47a13",
        "bbb8b1"
    ],
    "1f9d8-1f3fc": [
        "ab6840",
        "ddbf8e"
    ],
    "1f575-1f3fc-200d-2642-fe0f": [
        "d3c7b3",
        "201c18"
    ],
    "1f9dd-1f3fb": [
        "374a2c",
        "c9ac85"
    ],
    "1f939-1f3fd-200d-2642-fe0f": [
        "463931",
        "ae6c54"
    ],
    "1f6b4": [
        "3e3d3b",
        "bebcb6"
    ],
    "1f471-1f3ff": [
        "8f7544",
        "281b14"
    ],
    "1f9d8-1f3fb": [
        "bc7b55",
        "302827"
    ],
    "1f64d": [
        "bf8515",
        "e3d8ba"
    ],
    "1f468-200d-2695-fe0f": [
        "e7ae1f",
        "dddacb"
    ],
    "1f6b5": [
        "7d7a72",
        "d9d1c2"
    ],
    "1f9d1-1f3fd-200d-1f9bc": [
        "655455",
        "a8a59f"
    ],
    "270d-fe0f": [
        "bc6e0c",
        "100a06"
    ],
    "1f9dd-1f3fc": [
        "a88358",
        "ccad85"
    ],
    "1f647-1f3ff": [
        "43362d",
        "898885"
    ],
    "1f6c1": [
        "919394",
        "b7c4ca"
    ],
    "1fac4-1f3fd": [
        "583624",
        "b3b3b2"
    ],
    "1f44c-1f3fb": [
        "dea983",
        "fde5ca"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd": [
        "b08260",
        "251d18"
    ],
    "1f486-1f3fc": [
        "c49261",
        "dbc295"
    ],
    "1f6b6-200d-2642-fe0f": [
        "bd1642",
        "404c8f"
    ],
    "1f642": [
        "c6781c",
        "fef691"
    ],
    "1f6bc": [
        "f89202",
        "e8dfcf"
    ],
    "1f6a9": [
        "ac6f70",
        "6a0e0e"
    ],
    "1f468-1f3fc-200d-1f9b3": [
        "c0c3c2",
        "a67b5e"
    ],
    "1f647-1f3fe-200d-2640-fe0f": [
        "563f37",
        "7e348f"
    ],
    "1faf2-1f3ff": [
        "473029",
        "1b0e0a"
    ],
    "1f9df-200d-2640-fe0f": [
        "2d2c2a",
        "b7bea2"
    ],
    "1fa88": [
        "d3ab70",
        "311e1d"
    ],
    "1f1e8-1f1f7": [
        "7d839b",
        "112757"
    ],
    "1faaf": [
        "722e83",
        "fcf9fc"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "e6b5a3",
        "825437"
    ],
    "1f90c-1f3fc": [
        "d6a780",
        "eee1c3"
    ],
    "2b50": [
        "edc34e",
        "fbfade"
    ],
    "1f69c": [
        "ddb303",
        "292827"
    ],
    "1fa77": [
        "d31991",
        "f396c9"
    ],
    "1f6b6-1f3ff-200d-27a1-fe0f": [
        "c5c4c7",
        "493a34"
    ],
    "1f681": [
        "cdd2d6",
        "765150"
    ],
    "1f469-200d-1f3a8": [
        "a87523",
        "63635c"
    ],
    "2197-fe0f": [
        "65839d",
        "fdfdfd"
    ],
    "1f1e8-1f1fa": [
        "888ea7",
        "080e25"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc": [
        "941916",
        "805942"
    ],
    "2196-fe0f": [
        "65839e",
        "fdfdfd"
    ],
    "1f3ca-1f3fb-200d-2640-fe0f": [
        "cae4ef",
        "030104"
    ],
    "1faa0": [
        "471e0e",
        "924a2e"
    ],
    "1f695": [
        "6f9097",
        "060503"
    ],
    "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff": [
        "9b9999",
        "271e1b"
    ],
    "1fa7a": [
        "404143",
        "d2d7e3"
    ],
    "1f64f-1f3fd": [
        "a37054",
        "0b0a20"
    ],
    "1f4b7": [
        "754b55",
        "e2dcdb"
    ],
    "1f3d1": [
        "13120f",
        "83827d"
    ],
    "1f44f": [
        "e8a415",
        "616160"
    ],
    "1f1f8-1f1f9": [
        "39a647",
        "dbba20"
    ],
    "1f1f8-1f1ec": [
        "ce3d44",
        "e9e8e8"
    ],
    "1f3e5": [
        "c7c7c3",
        "737c7f"
    ],
    "1f468": [
        "e3a71a",
        "221707"
    ],
    "1f45b": [
        "5f5f5e",
        "f0a7c7"
    ],
    "1f33d": [
        "91c24e",
        "5b7a2a"
    ],
    "1f4c3": [
        "dddddd",
        "a3a3a3"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb": [
        "3d3534",
        "c0895d"
    ],
    "1f9dd-1f3fb-200d-2640-fe0f": [
        "c4af79",
        "5a6937"
    ],
    "1f468-1f3fd-200d-1f9bd-200d-27a1-fe0f": [
        "c12433",
        "453b3a"
    ],
    "1faf1-1f3fb-200d-1faf2-1f3fd": [
        "ba7f5c",
        "000000"
    ],
    "1f4ba": [
        "444a59",
        "8a95b8"
    ],
    "1f440": [
        "7d7c7c",
        "fafafa"
    ],
    "1f3cb-1f3fb-200d-2642-fe0f": [
        "555d67",
        "221a19"
    ],
    "1f3f9": [
        "b8afad",
        "80655a"
    ],
    "1f3ec": [
        "a7a9a8",
        "574a52"
    ],
    "1f454": [
        "7499c4",
        "b7d0ed"
    ],
    "1f332": [
        "48864c",
        "19311a"
    ],
    "1f4ce": [
        "99a2a9",
        "4b4d4f"
    ],
    "1f91a-1f3fd": [
        "b1795c",
        "c2936d"
    ],
    "1f48e": [
        "5196de",
        "c2e3f4"
    ],
    "1f49a": [
        "1fb322",
        "9fe692"
    ],
    "1f1f5-1f1e6": [
        "b72540",
        "e2e0e1"
    ],
    "1f468-1f3fd-200d-1f9b0": [
        "ef9c2c",
        "794c36"
    ],
    "1f483": [
        "a72322",
        "f1d56c"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc": [
        "dfba94",
        "b67c50"
    ],
    "1f497": [
        "cd2f82",
        "f5abd6"
    ],
    "3030-fe0f": [
        "000000",
        "474747"
    ],
    "1f938-1f3ff-200d-2640-fe0f": [
        "1d1714",
        "766460"
    ],
    "1f46b-1f3fc": [
        "5e2724",
        "cda475"
    ],
    "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc": [
        "104d86",
        "ad8060"
    ],
    "1f508": [
        "c0c5ca",
        "46494b"
    ],
    "1f53b": [
        "fef9e5",
        "af1000"
    ],
    "1f9d3-1f3ff": [
        "b96f0f",
        "58453b"
    ],
    "1f52f": [
        "9337ae",
        "f9f7fa"
    ],
    "1f9d1-1f3fe-200d-1f9b1": [
        "412b20",
        "6f442c"
    ],
    "1f1f0-1f1fc": [
        "419d87",
        "e1e1e0"
    ],
    "1f534": [
        "9d1111",
        "f77a76"
    ],
    "1f520": [
        "65829d",
        "f8f9fa"
    ],
    "1f469-1f3fd-200d-2708-fe0f": [
        "73563f",
        "a5a096"
    ],
    "1f1f0-1f1f5": [
        "d04043",
        "1b345c"
    ],
    "1f9d1-1f3fd-200d-1f37c": [
        "5c3926",
        "add8c8"
    ],
    "1f468-1f3fc-200d-1f3a4": [
        "496393",
        "c49575"
    ],
    "1f9b6-1f3fb": [
        "c37b54",
        "f8d9ba"
    ],
    "1f469-1f3ff-200d-2696-fe0f": [
        "0b0908",
        "665244"
    ],
    "1f9db-1f3fd": [
        "0f0d0d",
        "706e6e"
    ],
    "1f486-1f3fb-200d-2642-fe0f": [
        "342e2e",
        "f2d0b0"
    ],
    "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe": [
        "bca385",
        "3b312c"
    ],
    "1f468-1f3fc-200d-1f373": [
        "dedbd5",
        "b88158"
    ],
    "1f590-1f3ff": [
        "35251f",
        "584439"
    ],
    "1f449-1f3fd": [
        "8f5d46",
        "432a18"
    ],
    "1f9d1-1f3fd-200d-1f9bd-200d-27a1-fe0f": [
        "b6b5af",
        "423832"
    ],
    "1f44e-1f3fe": [
        "603621",
        "9c653d"
    ],
    "1f1ea-1f1f9": [
        "176845",
        "cf8f2c"
    ],
    "1f1ea-1f1ec": [
        "b52433",
        "ebe9e6"
    ],
    "1f7e1": [
        "df9500",
        "fee12e"
    ],
    "1f46d-1f3fd": [
        "b98761",
        "3380b7"
    ],
    "26f9-1f3ff": [
        "433129",
        "c8c6c4"
    ],
    "1f468-1f3fe": [
        "5c4235",
        "905c39"
    ],
    "1f93d-1f3fb-200d-2642-fe0f": [
        "e4b890",
        "f2f5f2"
    ],
    "1f926-1f3fe-200d-2640-fe0f": [
        "654939",
        "332022"
    ],
    "1f9ce-1f3fd-200d-2642-fe0f-200d-27a1-fe0f": [
        "47445a",
        "a57252"
    ],
    "1f477-1f3fc-200d-2640-fe0f": [
        "c89950",
        "76a9d6"
    ],
    "1f93c-200d-2642-fe0f": [
        "3c5575",
        "f1c139"
    ],
    "1f481-200d-2640-fe0f": [
        "f4bf2e",
        "943ca2"
    ],
    "1f46e-1f3fd-200d-2642-fe0f": [
        "daceac",
        "744d37"
    ],
    "270a-1f3fc": [
        "9f532b",
        "e1be98"
    ],
    "1f911": [
        "c3791a",
        "f8f385"
    ],
    "1f9d8-1f3ff-200d-2642-fe0f": [
        "241912",
        "d86118"
    ],
    "1f3c3-1f3fe": [
        "7e4f33",
        "d1cdc9"
    ],
    "1f9fd": [
        "c3aa0d",
        "000000"
    ],
    "1f468-200d-2764-200d-1f48b-200d-1f468": [
        "fbc732",
        "dd459a"
    ],
    "1f9d1-1f3fb-200d-1f9bd": [
        "a19286",
        "302f31"
    ],
    "1f1fb-1f1ee": [
        "ada6a4",
        "010201"
    ],
    "1f9f2": [
        "e07178",
        "d92524"
    ],
    "1f575-1f3fd": [
        "413931",
        "a98c6f"
    ],
    "1f64d-200d-2640-fe0f": [
        "efb623",
        "802f93"
    ],
    "1f90c": [
        "efb547",
        "f8fdee"
    ],
    "1f939": [
        "434e3e",
        "cccbbb"
    ],
    "1f9d1-1f3fb-200d-1f9b2": [
        "c8885f",
        "f6d4b1"
    ],
    "1f915": [
        "b6742b",
        "c0c0bd"
    ],
    "1f5b1-fe0f": [
        "cacbcc",
        "f7f8f9"
    ],
    "1f935-1f3fc-200d-2640-fe0f": [
        "e2d290",
        "1d1d1d"
    ],
    "1f9f6": [
        "c94e0b",
        "722b12"
    ],
    "1f1fb-1f1ea": [
        "d8b82b",
        "852127"
    ],
    "1f468-1f3fe-200d-1f9b0": [
        "eb9529",
        "522c1b"
    ],
    "1f91c": [
        "e9a617",
        "000000"
    ],
    "1f929": [
        "1d0700",
        "f1cb47"
    ],
    "26f9-1f3fb": [
        "d8a06e",
        "362721"
    ],
    "1f1f3-1f1ec": [
        "096340",
        "f2f4f3"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc": [
        "bc8e5d",
        "724a51"
    ],
    "1f938-1f3fe-200d-2640-fe0f": [
        "332116",
        "956a4d"
    ],
    "1f7e5": [
        "d42211",
        "e06458"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe": [
        "a27149",
        "dfba95"
    ],
    "1f237-fe0f": [
        "f99302",
        "fbfaf7"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "936342",
        "3d2c22"
    ],
    "1f3cb-1f3fc": [
        "445b72",
        "7c7e80"
    ],
    "1f39f-fe0f": [
        "e3606f",
        "6b2c33"
    ],
    "1f9ce-1f3fc": [
        "d5b876",
        "000000"
    ],
    "1f9b6-1f3ff": [
        "2a1d16",
        "47332d"
    ],
    "1f6b4-1f3fc-200d-2642-fe0f": [
        "0c0d7b",
        "baa17e"
    ],
    "1f468-200d-1f3a8": [
        "a8becb",
        "1f1a18"
    ],
    "1f647-1f3ff-200d-2640-fe0f": [
        "483c3b",
        "783487"
    ],
    "1f1fa-1f1f3": [
        "0c92c8",
        "000000"
    ],
    "1faf4-1f3fe": [
        "663219",
        "000000"
    ],
    "1f9de-200d-2640-fe0f": [
        "4c7c92",
        "a8367f"
    ],
    "1f469-1f3fb-200d-1f9af-200d-27a1-fe0f": [
        "c345c0",
        "18152d"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd": [
        "961512",
        "b4805d"
    ],
    "1f471-1f3fb-200d-2640-fe0f": [
        "9f7d3d",
        "f0dcbc"
    ],
    "1f6b5-200d-2642-fe0f": [
        "888982",
        "c0c4bc"
    ],
    "1f6a3-1f3fc-200d-2642-fe0f": [
        "bf916f",
        "000000"
    ],
    "1f590-1f3fb": [
        "d59a73",
        "fadfc1"
    ],
    "1f1fa-1f1fe": [
        "aaadb6",
        "000000"
    ],
    "1f477-1f3fe": [
        "e2b33f",
        "4b3022"
    ],
    "1f43f-fe0f": [
        "331f0e",
        "8b6b4a"
    ],
    "1f518": [
        "2d2d2d",
        "d7d7d7"
    ],
    "1f52b": [
        "70d65a",
        "a8d598"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe": [
        "965f4d",
        "e3ca9e"
    ],
    "1f9d3-1f3fb": [
        "9a7948",
        "ccb69f"
    ],
    "1f6b6-1f3fe-200d-27a1-fe0f": [
        "c7c5c6",
        "434c89"
    ],
    "1f468-1f3fb-200d-1f9b3": [
        "c3c1bf",
        "b69179"
    ],
    "1f9d1-1f3fe-200d-1f9bc": [
        "41393c",
        "858085"
    ],
    "1f524": [
        "65839e",
        "f6f7f8"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc": [
        "f8cdc8",
        "24201f"
    ],
    "1f530": [
        "666664",
        "d7cb3e"
    ],
    "1f9ce-1f3ff-200d-2642-fe0f-200d-27a1-fe0f": [
        "030304",
        "8b6d3e"
    ],
    "1f937-1f3fd": [
        "65432b",
        "c9c7c6"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe": [
        "563b30",
        "e849a6"
    ],
    "1f469-1f3ff-200d-1f9bd": [
        "272427",
        "5d556a"
    ],
    "1f482-200d-2640-fe0f": [
        "453b2e",
        "ddb037"
    ],
    "1f49e": [
        "c71a70",
        "e950b0"
    ],
    "1f48a": [
        "eedc44",
        "d23e26"
    ],
    "1f9d1-1f3fc-200d-1f9b2": [
        "c88a62",
        "e8caa7"
    ],
    "1f926-1f3ff-200d-2640-fe0f": [
        "534842",
        "470657"
    ],
    "1f9cd-1f3fb-200d-2640-fe0f": [
        "e5b691",
        "3d3a3e"
    ],
    "1f469-1f3ff-200d-1f9b2": [
        "2b1e17",
        "cec2aa"
    ],
    "1f385-1f3fc": [
        "d0c3b7",
        "834537"
    ],
    "1f493": [
        "eb35a4",
        "000000"
    ],
    "1f3c3-1f3fc-200d-2640-fe0f": [
        "cea375",
        "0d092c"
    ],
    "1f1f5-1f1ed": [
        "2c519d",
        "c32f37"
    ],
    "1f9d1-1f3fc-200d-1f9bd": [
        "7d6b5c",
        "333337"
    ],
    "1f450-1f3fc": [
        "bf7e54",
        "000000"
    ],
    "1f487": [
        "dbd4c2",
        "eeb72b"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff": [
        "55433d",
        "e7bfa0"
    ],
    "1f4c7": [
        "7b6e66",
        "dddcdc"
    ],
    "1f3e1": [
        "52522c",
        "ac6e57"
    ],
    "1f45f": [
        "8b8886",
        "d1d0d0"
    ],
    "1f9da-1f3fc-200d-2642-fe0f": [
        "9fe4cd",
        "c99c72"
    ],
    "1f1e6-1f1eb": [
        "136716",
        "4e2824"
    ],
    "1f1e6-1f1f8": [
        "b3a69f",
        "12144a"
    ],
    "1f478": [
        "9e620c",
        "ebb322"
    ],
    "1f44b": [
        "be6c09",
        "fcca44"
    ],
    "1f32d": [
        "e6aa5c",
        "faf0e7"
    ],
    "1f4b3": [
        "0d0c0a",
        "b9b393"
    ],
    "1f4ca": [
        "dae2e9",
        "06b31a"
    ],
    "1f64e-1f3fd-200d-2640-fe0f": [
        "734b32",
        "af8362"
    ],
    "1f450": [
        "c67509",
        "000000"
    ],
    "1f9d8-1f3fe-200d-2642-fe0f": [
        "49291a",
        "8e5632"
    ],
    "1f444": [
        "81453f",
        "e896ad"
    ],
    "1f9ce-1f3fb-200d-2640-fe0f-200d-27a1-fe0f": [
        "333152",
        "5b5972"
    ],
    "1f4be": [
        "525252",
        "e6e7e8"
    ],
    "1fa73": [
        "b59970",
        "ea970f"
    ],
    "1faab": [
        "857878",
        "f4efef"
    ],
    "1fab8": [
        "e97a59",
        "9b4e43"
    ],
    "1f9db-1f3fc-200d-2640-fe0f": [
        "0e0d0d",
        "adaaab"
    ],
    "1f1e8-1f1f3": [
        "a41927",
        "610d15"
    ],
    "1f9b8-1f3fc-200d-2640-fe0f": [
        "a37c4a",
        "4c2852"
    ],
    "1f1ed-1f1f2": [
        "163167",
        "d23c50"
    ],
    "1f931-1f3fc": [
        "c3a66c",
        "6c3f6c"
    ],
    "1f468-1f3fb-200d-1f373": [
        "e3ded5",
        "d7a16d"
    ],
    "1f68c": [
        "e4deb4",
        "0e0e0f"
    ],
    "1f442-1f3fd": [
        "a06951",
        "000000"
    ],
    "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb": [
        "9a9694",
        "352d2a"
    ],
    "1f691": [
        "84a7b7",
        "484748"
    ],
    "1faa4": [
        "d5b087",
        "8d6646"
    ],
    "1f9d1-1f3fe-200d-1f37c": [
        "362321",
        "774b34"
    ],
    "1f9ce-1f3fd-200d-27a1-fe0f": [
        "5d4838",
        "d6d3cf"
    ],
    "1f468-1f3fb-200d-1f3a4": [
        "486292",
        "d4aa8d"
    ],
    "1f1e8-1f1fe": [
        "acaba6",
        "000000"
    ],
    "1f9d5-1f3fe": [
        "774821",
        "382760"
    ],
    "1f685": [
        "c0c7c1",
        "364061"
    ],
    "1f9d6-1f3fc-200d-2640-fe0f": [
        "e1eff1",
        "dcc1a3"
    ],
    "1f596-1f3fe": [
        "6c3d25",
        "9b653d"
    ],
    "1f44c-1f3ff": [
        "402e27",
        "634f43"
    ],
    "1f6c5": [
        "0057b5",
        "eef3f8"
    ],
    "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd": [
        "104d85",
        "a7795c"
    ],
    "1f647-1f3fb": [
        "45392d",
        "a39f9a"
    ],
    "1f469-1f3fe-200d-2696-fe0f": [
        "493830",
        "cd8d30"
    ],
    "1f6b1": [
        "e76136",
        "312c2b"
    ],
    "1f9d8-1f3ff": [
        "271c17",
        "b3b2b1"
    ],
    "1f471-1f3fb": [
        "9f723c",
        "f2d9ad"
    ],
    "1faf2-1f3fb": [
        "e0b18e",
        "000000"
    ],
    "1f6cc": [
        "d6dde4",
        "926246"
    ],
    "1f9d1-1f3fd-200d-1f9b1": [
        "663e23",
        "bf8e68"
    ],
    "1f646": [
        "c8c4bc",
        "81807f"
    ],
    "1fa98": [
        "43382a",
        "8f7961"
    ],
    "1f9d1-1f3fd-200d-1f9b0": [
        "613f29",
        "b78763"
    ],
    "1f6bf": [
        "959a98",
        "163e43"
    ],
    "1fa99": [
        "767c7f",
        "a7adb0"
    ],
    "1f647": [
        "c08517",
        "848380"
    ],
    "1f93e-1f3fc-200d-2640-fe0f": [
        "c19972",
        "dcddd7"
    ],
    "1faf2-1f3fc": [
        "cc9971",
        "000000"
    ],
    "1f6b0": [
        "8b8f92",
        "c7e2ee"
    ],
    "1f9dd-1f3ff": [
        "504534",
        "e1d9ab"
    ],
    "1f471-1f3fc": [
        "9e6f3e",
        "ead99e"
    ],
    "1f64a": [
        "9a7647",
        "e3c6a4"
    ],
    "1f596-1f3fd": [
        "8b5a44",
        "c0906a"
    ],
    "1f486-1f3ff": [
        "2a1f1b",
        "b2b2b2"
    ],
    "1f9cf-200d-2640-fe0f": [
        "ca8d12",
        "4f1560"
    ],
    "1f647-1f3fc": [
        "cca46b",
        "200604"
    ],
    "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe": [
        "114c83",
        "82533d"
    ],
    "1f6c4": [
        "0269e1",
        "fafbfc"
    ],
    "1f408-200d-2b1b": [
        "767574",
        "383837"
    ],
    "1f1e8-1f1fd": [
        "337e4c",
        "091852"
    ],
    "1f684": [
        "8d969a",
        "323f51"
    ],
    "1f9d5-1f3fd": [
        "6f431d",
        "392861"
    ],
    "1f690": [
        "dbdacc",
        "443637"
    ],
    "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc": [
        "999594",
        "3d2f2a"
    ],
    "1f442-1f3fe": [
        "724227",
        "925b37"
    ],
    "1faa5": [
        "107caf",
        "ced7da"
    ],
    "26f9-1f3fb-200d-2640-fe0f": [
        "c99673",
        "9f452f"
    ],
    "1f64d-1f3ff-200d-2642-fe0f": [
        "655442",
        "4472af"
    ],
    "1f1e8-1f1f2": [
        "caac2d",
        "4c461f"
    ],
    "1f68b": [
        "525e59",
        "d4d2cb"
    ],
    "1f931-1f3fb": [
        "2a272a",
        "70a68c"
    ],
    "1f1ed-1f1f3": [
        "1951ad",
        "e8e9eb"
    ],
    "2b55": [
        "d10000",
        "e80000"
    ],
    "1fa72": [
        "238e20",
        "000000"
    ],
    "1f69f": [
        "ced3cf",
        "20292d"
    ],
    "1fab9": [
        "b69a87",
        "744521"
    ],
    "1faac": [
        "678baf",
        "101012"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "38271d",
        "d84297"
    ],
    "1f90c-1f3ff": [
        "3c2c24",
        "59443a"
    ],
    "1f445": [
        "943646",
        "ef9aa8"
    ],
    "1f4bd": [
        "b3a47f",
        "3f3f3f"
    ],
    "1f337": [
        "f488a2",
        "90b455"
    ],
    "1f451": [
        "b2881f",
        "000000"
    ],
    "1f3ef": [
        "111122",
        "675c57"
    ],
    "1f44c": [
        "e5a00f",
        "2c0c0a"
    ],
    "1f479": [
        "3b1e0d",
        "ea4e3c"
    ],
    "1f1e6-1f1f9": [
        "d73934",
        "ecebeb"
    ],
    "1f1e6-1f1ec": [
        "aa1f2b",
        "f1e4b5"
    ],
    "1f4b2": [
        "656565",
        "464646"
    ],
    "1f32e": [
        "dcb64c",
        "b78535"
    ],
    "23fa-fe0f": [
        "66839e",
        "fdfefe"
    ],
    "1f4c6": [
        "5f5b5c",
        "edebeb"
    ],
    "1f33a": [
        "65131d",
        "f45878"
    ],
    "1f1f8-1f1ef": [
        "8e241f",
        "5f718e"
    ],
    "1f3e0": [
        "2b2520",
        "938667"
    ],
    "1f486": [
        "d3981c",
        "beb6a7"
    ],
    "1f450-1f3fb": [
        "d2946e",
        "000000"
    ],
    "1f385-1f3fb": [
        "dcccbc",
        "834236"
    ],
    "1f469-1f3ff-200d-1f9b3": [
        "c1c0c0",
        "3d2c24"
    ],
    "1f46b-1f3ff": [
        "981815",
        "2881bd"
    ],
    "1f468-1f3fd-200d-1f9bc": [
        "493d3e",
        "9eaea8"
    ],
    "1f487-1f3fc-200d-2640-fe0f": [
        "9d9187",
        "dece96"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff": [
        "3b2f2b",
        "e94ca7"
    ],
    "1f492": [
        "e5478a",
        "f0d1e4"
    ],
    "1f9d1-1f3fc-200d-1f9b3": [
        "ccc7b7",
        "efeeeb"
    ],
    "1f49d": [
        "b9165b",
        "edd12a"
    ],
    "1f9d1-1f3fe-200d-2695-fe0f": [
        "422e25",
        "d1d3d3"
    ],
    "1f468-1f3fb-200d-1f9bd": [
        "b31f2c",
        "302f32"
    ],
    "1f937-1f3fe": [
        "4c2f20",
        "8c8885"
    ],
    "1f1eb-1f1f4": [
        "929298",
        "30739b"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb": [
        "585150",
        "f2c7b3"
    ],
    "1f531": [
        "bd880d",
        "efd767"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd": [
        "b88a6b",
        "3d281d"
    ],
    "1f573-fe0f": [
        "000000",
        "b2b2b2"
    ],
    "1f525": [
        "ed3e25",
        "f5b79f"
    ],
    "1f469-1f3ff-200d-1f9bd-200d-27a1-fe0f": [
        "ab37ae",
        "4f464f"
    ],
    "1f3cc-1f3fc-200d-2640-fe0f": [
        "cabea9",
        "452220"
    ],
    "1f468-1f3fb-200d-1f9b2": [
        "dca580",
        "24140b"
    ],
    "1f469-1f3fc-200d-1f9bc-200d-27a1-fe0f": [
        "c145bc",
        "241d20"
    ],
    "25ab-fe0f": [
        "000000",
        "d9d9d9"
    ],
    "1f9d3-1f3fc": [
        "c56e06",
        "d4b38d"
    ],
    "1f1f0-1f1ff": [
        "0e8d9d",
        "0d545a"
    ],
    "26f5": [
        "e9dc2f",
        "c93126"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd": [
        "af7f54",
        "644759"
    ],
    "1f52c": [
        "3a3c3d",
        "98a8b1"
    ],
    "1f519": [
        "616161",
        "464646"
    ],
    "1f477-1f3fd": [
        "daa947",
        "86c5fc"
    ],
    "1f645-1f3fd-200d-2640-fe0f": [
        "ad8264",
        "f7f5f5"
    ],
    "1f470-200d-2642-fe0f": [
        "c5c3be",
        "f0b926"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe": [
        "4e2f29",
        "c29066"
    ],
    "1f590-1f3fc": [
        "c18158",
        "dfb993"
    ],
    "1faf4-1f3fd": [
        "8d543d",
        "000000"
    ],
    "1f1fa-1f1f2": [
        "386ba1",
        "771620"
    ],
    "1f9d1-1f3fc-200d-1f3a4": [
        "4ead41",
        "d4b08a"
    ],
    "1f7eb": [
        "75401d",
        "946b50"
    ],
    "1f3c4-1f3fc-200d-2642-fe0f": [
        "0d647b",
        "a3de81"
    ],
    "1f646-1f3fd-200d-2642-fe0f": [
        "508cce",
        "623f29"
    ],
    "1f9ce-1f3fb": [
        "2e2f35",
        "beb7b3"
    ],
    "1f3cb-1f3fb": [
        "4a5662",
        "dcb99f"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "3b2c25",
        "d49f7b"
    ],
    "1f469-1f3ff-200d-1f373": [
        "e2e1dc",
        "4e3d33"
    ],
    "270a-1f3ff": [
        "281b14",
        "5a453a"
    ],
    "1f468-1f3fd-200d-1f37c": [
        "694632",
        "371f16"
    ],
    "1f7e4": [
        "5a280f",
        "bb9c83"
    ],
    "1f9d1-1f3fc-200d-1f373": [
        "c18f61",
        "dddad4"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd": [
        "b38558",
        "5d3c26"
    ],
    "1f937-200d-2642-fe0f": [
        "eab62c",
        "373a6d"
    ],
    "1f469-1f3ff-200d-1f3a4": [
        "a34186",
        "4b3d42"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb": [
        "f0bfbb",
        "473c3a"
    ],
    "1f1f3-1f1eb": [
        "166434",
        "f1f2f1"
    ],
    "26f9-1f3fc": [
        "c28d57",
        "3f2a21"
    ],
    "1f468-1f3fe-200d-1f9b1": [
        "281b16",
        "935e38"
    ],
    "1f64b-1f3fd-200d-2642-fe0f": [
        "afb1b9",
        "70472e"
    ],
    "2663-fe0f": [
        "3d3d3d",
        "181818"
    ],
    "1f928": [
        "d17d16",
        "fdf490"
    ],
    "1f91b": [
        "fdce48",
        "8a420f"
    ],
    "1f90f": [
        "f8b41b",
        "000000"
    ],
    "1f9f7": [
        "38404c",
        "a7bfd9"
    ],
    "1f914": [
        "bb6d20",
        "fdd13a"
    ],
    "1f469-200d-1f9bd-200d-27a1-fe0f": [
        "b037b3",
        "393535"
    ],
    "1f4fd-fe0f": [
        "25211c",
        "788082"
    ],
    "1f426-200d-2b1b": [
        "2f2d35",
        "8c867e"
    ],
    "1f9fa": [
        "7a5736",
        "22180f"
    ],
    "1f1fb-1f1e6": [
        "a2a0a1",
        "6d6223"
    ],
    "1f916": [
        "9fbbba",
        "383e46"
    ],
    "1f3c3-1f3fb": [
        "e9c09e",
        "12101f"
    ],
    "1f9fc": [
        "9cddc3",
        "220706"
    ],
    "1f9e9": [
        "54663c",
        "ace67f"
    ],
    "1f9d1-1f3fb-200d-1f9bc": [
        "3d3a40",
        "8b8185"
    ],
    "1f468-1f3fe-200d-1f9b3": [
        "c1c0be",
        "59321e"
    ],
    "1f9f5": [
        "8bc7e5",
        "0d618d"
    ],
    "1f575-1f3fc": [
        "a78963",
        "221e1a"
    ],
    "1f486-1f3fe-200d-2640-fe0f": [
        "55382e",
        "905e3d"
    ],
    "1f90d": [
        "d7d7d7",
        "000000"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff": [
        "5b4840",
        "d1b8aa"
    ],
    "1f7e6": [
        "055df2",
        "4e8cf5"
    ],
    "1f1ea-1f1ed": [
        "010101",
        "dddbda"
    ],
    "1f6cf-fe0f": [
        "f2f3f4",
        "986b54"
    ],
    "1f46d-1f3fc": [
        "c89065",
        "263357"
    ],
    "1f468-1f3fb": [
        "2f2928",
        "e9be9c"
    ],
    "1f0cf": [
        "ebe3da",
        "343434"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb": [
        "deab87",
        "282427"
    ],
    "270a-1f3fd": [
        "593826",
        "bf8e68"
    ],
    "1f1f3-1f1e6": [
        "21715d",
        "c8c1c4"
    ],
    "002a-fe0f-20e3": [
        "65839e",
        "fbfbfc"
    ],
    "1faf4-1f3ff": [
        "33211c",
        "000000"
    ],
    "1f9b6-1f3fe": [
        "4d2a19",
        "7c492c"
    ],
    "1f5f3-fe0f": [
        "d6e9e9",
        "5795ae"
    ],
    "1f9db-1f3fc": [
        "060606",
        "abaaa9"
    ],
    "1f477-1f3ff": [
        "d69f37",
        "3d2f26"
    ],
    "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb": [
        "9b9796",
        "36312f"
    ],
    "1f449-1f3fc": [
        "d09c73",
        "000000"
    ],
    "1f1fa-1f1ff": [
        "1f8fa4",
        "e9e7e7"
    ],
    "1f44e-1f3fb": [
        "cd8d67",
        "f8d9b9"
    ],
    "1f9cd-1f3ff-200d-2642-fe0f": [
        "881d19",
        "9d7250"
    ],
    "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd": [
        "104c85",
        "795740"
    ],
    "1f468-1f3fb-200d-1f9b0": [
        "ee9b2d",
        "f2cfaf"
    ],
    "1f52a": [
        "606162",
        "ced0d0"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff": [
        "3e2e2b",
        "e6cba3"
    ],
    "1f46e-1f3fc-200d-2640-fe0f": [
        "cfab77",
        "132f55"
    ],
    "1f477-1f3fd-200d-2642-fe0f": [
        "d5a342",
        "65422d"
    ],
    "1f93d-200d-2640-fe0f": [
        "ebb949",
        "edf6f7"
    ],
    "1f486-200d-2642-fe0f": [
        "f1bc30",
        "2a73c3"
    ],
    "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff": [
        "1e1612",
        "e949a7"
    ],
    "1f533": [
        "dededd",
        "000000"
    ],
    "2614": [
        "a077e9",
        "346ccf"
    ],
    "1f926-1f3fb-200d-2642-fe0f": [
        "3d3b39",
        "cba27c"
    ],
    "1f93d-1f3fe-200d-2640-fe0f": [
        "87533d",
        "eef1f0"
    ],
    "1f527": [
        "615d5d",
        "070504"
    ],
    "1f1f0-1f1f2": [
        "dcdad1",
        "205e68"
    ],
    "26fa": [
        "d34022",
        "f39854"
    ],
    "1f91a-1f3fc": [
        "d4a37b",
        "e3c19c"
    ],
    "1f48b": [
        "cb1b1b",
        "010202"
    ],
    "23ee-fe0f": [
        "66839e",
        "b7cada"
    ],
    "1f9d1-1f3fc-200d-1f9b1": [
        "ad7946",
        "e5cc9f"
    ],
    "1f49f": [
        "9438b0",
        "fefdfe"
    ],
    "23ed-fe0f": [
        "66839e",
        "fcfcfc"
    ],
    "1f3ca-1f3fe-200d-2642-fe0f": [
        "cae5f0",
        "704127"
    ],
    "1f484": [
        "cc3a44",
        "0a0d0e"
    ],
    "1f490": [
        "c9c32b",
        "cd5293"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd": [
        "b37b54",
        "5c3f2c"
    ],
    "1f46b-1f3fd": [
        "572a21",
        "a67458"
    ],
    "1f469-1f3ff-200d-1f9b1": [
        "2f2927",
        "dbd6ca"
    ],
    "1f4b0": [
        "aa9476",
        "65513d"
    ],
    "1f471-1f3ff-200d-2642-fe0f": [
        "dacd8e",
        "281c16"
    ],
    "262e-fe0f": [
        "9237ae",
        "f9f8fa"
    ],
    "1f1e6-1f1ea": [
        "1f7341",
        "eeeded"
    ],
    "1f44a": [
        "d98e09",
        "fed04d"
    ],
    "1f468-1f3fe-200d-1f3a4": [
        "446295",
        "3e2924"
    ],
    "1f9d1-1f3fb-200d-1f37c": [
        "262327",
        "d39f7a"
    ],
    "1f3e2": [
        "c4c5c4",
        "2d4350"
    ],
    "1f45e": [
        "6b3220",
        "c4836d"
    ],
    "1f1f8-1f1ed": [
        "0d2551",
        "bb6243"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe": [
        "492f25",
        "c6a065"
    ],
    "1f309": [
        "f7f8f8",
        "734b3a"
    ],
    "1f33c": [
        "d3a025",
        "f4e150"
    ],
    "1f4c4": [
        "6f6f6f",
        "e5e5e5"
    ],
    "1faf1-1f3fb-200d-1faf2-1f3fc": [
        "d1976f",
        "000000"
    ],
    "1f4bf": [
        "f6f6f2",
        "b0afb4"
    ],
    "1f468-1f3fe-200d-1f373": [
        "dedcd7",
        "70452a"
    ],
    "1f9da-200d-2642-fe0f": [
        "9ee3cc",
        "ce9721"
    ],
    "1f447": [
        "d48508",
        "fcca44"
    ],
    "1f647-1f3fb-200d-2642-fe0f": [
        "564f51",
        "dfbea2"
    ],
    "1f3ed": [
        "9f8b7e",
        "7e544c"
    ],
    "1f453": [
        "2f3433",
        "b2c9c2"
    ],
    "1f335": [
        "529a28",
        "eef3e6"
    ],
    "1f4cb": [
        "b89a6c",
        "d4d4d4"
    ],
    "2716-fe0f": [
        "000000",
        "454545"
    ],
    "1f1e8-1f1f0": [
        "1d1451",
        "d7b6bd"
    ],
    "1f90c-1f3fd": [
        "b27d5e",
        "e3b883"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "895a3e",
        "ba8864"
    ],
    "1faaa": [
        "878786",
        "000000"
    ],
    "1f69d": [
        "2c3744",
        "c9cdcd"
    ],
    "1fa70": [
        "e2a28a",
        "bd7062"
    ],
    "1f9d5-1f3ff": [
        "644022",
        "382861"
    ],
    "1f686": [
        "4b5660",
        "dadadd"
    ],
    "1f1e8-1f1ff": [
        "b4b2b4",
        "8f1c21"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd": [
        "9b1512",
        "784d38"
    ],
    "1faa7": [
        "000000",
        "d4d4d4"
    ],
    "1f64f-1f3fc": [
        "cf9d75",
        "4c8acc"
    ],
    "1f692": [
        "ee0706",
        "dcdedf"
    ],
    "1f9d8-1f3fe": [
        "704a34",
        "a77457"
    ],
    "1f64c": [
        "dc920d",
        "605e5d"
    ],
    "1f9dd-1f3fd": [
        "574f32",
        "af8d68"
    ],
    "1f9d1-1f3fd-200d-1f9bd": [
        "a37d5f",
        "322c2b"
    ],
    "1f9dd-1f3fe-200d-2642-fe0f": [
        "895836",
        "dad19c"
    ],
    "1f6b2": [
        "3a3d41",
        "7b98b4"
    ],
    "1f44c-1f3fe": [
        "7b492c",
        "a16b43"
    ],
    "1fac4-1f3fc": [
        "7c6d5a",
        "d0c1a4"
    ],
    "1f486-1f3fd": [
        "613a21",
        "aaa7a7"
    ],
    "1f596-1f3ff": [
        "382821",
        "584439"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc": [
        "e8bca3",
        "50403b"
    ],
    "1f645": [
        "ad6818",
        "ccc4b1"
    ],
    "1f6bd": [
        "cbcac9",
        "ff0000"
    ],
    "1f9d1-1f3fd-200d-1f9b2": [
        "6d432f",
        "bb8962"
    ],
    "1f468-200d-1f9af": [
        "b71b3e",
        "ceafc9"
    ],
    "1f469-200d-1f393": [
        "f3bc29",
        "333230"
    ],
    "1f3cb-1f3fe-200d-2640-fe0f": [
        "5d676e",
        "2a1d19"
    ],
    "1f3c3-1f3fe-200d-2642-fe0f-200d-27a1-fe0f": [
        "7c4931",
        "f8f5ef"
    ],
    "1f644": [
        "b4763b",
        "edecd1"
    ],
    "1f9d1-1f3fd-200d-1f9b3": [
        "b38869",
        "b9b0a9"
    ],
    "1f937-1f3fe-200d-2642-fe0f": [
        "51322d",
        "2c3f71"
    ],
    "1f6be": [
        "0055ae",
        "f7f9fb"
    ],
    "2668-fe0f": [
        "f28f8f",
        "8e0101"
    ],
    "1f3f7-fe0f": [
        "f6ce9e",
        "000000"
    ],
    "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff": [
        "114d85",
        "816049"
    ],
    "1fac4-1f3fb": [
        "262323",
        "d1baa7"
    ],
    "1f44c-1f3fd": [
        "9e6850",
        "c59773"
    ],
    "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb": [
        "534440",
        "cf9272"
    ],
    "1f486-1f3fe": [
        "3b261c",
        "a8a7a7"
    ],
    "1f468-1f3fc-200d-1f9bc": [
        "3f3940",
        "8f8381"
    ],
    "1f64b": [
        "ce9419",
        "e2d0a4"
    ],
    "1f9d8-1f3fd": [
        "5e3b25",
        "b17f5f"
    ],
    "1f6b3": [
        "e76035",
        "ede2d9"
    ],
    "1f9dd-1f3fe": [
        "433921",
        "ded5a8"
    ],
    "1f482-1f3fe-200d-2640-fe0f": [
        "52422d",
        "ac9574"
    ],
    "1faa6": [
        "c8c7c3",
        "83827f"
    ],
    "1f470-1f3fd-200d-2640-fe0f": [
        "d1d0cf",
        "815a43"
    ],
    "1f693": [
        "d5d7d8",
        "090707"
    ],
    "1f64f-1f3fb": [
        "d59c77",
        "164c8d"
    ],
    "1f442-1f3ff": [
        "362620",
        "543f36"
    ],
    "1f687": [
        "858988",
        "0e0e0e"
    ],
    "1f9d1-1f3ff-200d-1f9bc-200d-27a1-fe0f": [
        "e6e6e6",
        "585b75"
    ],
    "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe": [
        "9b1613",
        "2480b5"
    ],
    "1f6b6-1f3fb-200d-2640-fe0f-200d-27a1-fe0f": [
        "c042bf",
        "3c3c7f"
    ],
    "1f6b5-1f3fe-200d-2642-fe0f": [
        "737878",
        "27343f"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "4c3020",
        "fd91d8"
    ],
    "1f9d1-1f3fc-200d-1f9bd-200d-27a1-fe0f": [
        "cecdca",
        "36363a"
    ],
    "1f90c-1f3fe": [
        "7d4b2e",
        "96613c"
    ],
    "1fa71": [
        "34b4ab",
        "023255"
    ],
    "1f69e": [
        "efd387",
        "424d52"
    ],
    "1f68a": [
        "161616",
        "79969c"
    ],
    "1f1ed-1f1f0": [
        "6a101a",
        "f1dadd"
    ],
    "1f1e8-1f1f1": [
        "204691",
        "6a1b16"
    ],
    "1f452": [
        "e1cc9c",
        "6cb052"
    ],
    "1f3ee": [
        "f35e14",
        "b5381c"
    ],
    "1f4cc": [
        "e5dddd",
        "c13234"
    ],
    "1f334": [
        "608a36",
        "e0f4ae"
    ],
    "1f320": [
        "f8f9f1",
        "1c435b"
    ],
    "1f446": [
        "edab18",
        "bd670d"
    ],
    "1f481-1f3fe-200d-2642-fe0f": [
        "231d1d",
        "5283c3"
    ],
    "1f473-1f3fd-200d-2642-fe0f": [
        "d2d1d1",
        "311d13"
    ],
    "1f575-1f3fd-200d-2640-fe0f": [
        "5d4f43",
        "bbbdb7"
    ],
    "1f1f8-1f1ee": [
        "d2d3d6",
        "811310"
    ],
    "1f45d": [
        "e4dcc7",
        "693e14"
    ],
    "1f3e3": [
        "f93d3d",
        "e5debf"
    ],
    "1f939-1f3fc-200d-2640-fe0f": [
        "3e4839",
        "cfa87f"
    ],
    "1f4c5": [
        "ab6262",
        "dbdada"
    ],
    "1f33b": [
        "d59a06",
        "3e2600"
    ],
    "1f308": [
        "217ee7",
        "f5b92b"
    ],
    "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd": [
        "ab714c",
        "bf9666"
    ],
    "1f4b1": [
        "464646",
        "747474"
    ],
    "1f32f": [
        "c4bdb3",
        "5c4b2c"
    ],
    "1f6b6-1f3fe-200d-2640-fe0f": [
        "b33abd",
        "373a88"
    ],
    "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe": [
        "ac7249",
        "4381c2"
    ],
    "1f491": [
        "e8af23",
        "b0ada8"
    ],
    "1f469-1f3ff-200d-1f9b0": [
        "ba6022",
        "58433f"
    ],
    "1f578-fe0f": [
        "949494",
        "6c6c6c"
    ],
    "1f46b-1f3fe": [
        "a21512",
        "865b40"
    ],
    "1f579-fe0f": [
        "070808",
        "3e3c40"
    ],
    "1f485": [
        "845170",
        "fccb47"
    ],
    "1f91a-1f3fb": [
        "ecc19d",
        "fce4c8"
    ],
    "1f9d1-1f3fc-200d-1f9b0": [
        "6a3a11",
        "d2a87c"
    ],
    "1f48c": [
        "dadada",
        "eb4041"
    ],
    "1f526": [
        "86888c",
        "f5f4ec"
    ],
    "1f1f0-1f1f3": [
        "761a22",
        "168f4c"
    ],
    "1f9b8-200d-2642-fe0f": [
        "bb7010",
        "502a61"
    ],
    "2615": [
        "f2f1ee",
        "928e88"
    ],
    "1f937-1f3ff": [
        "2d2522",
        "898888"
    ],
    "1f9cf-1f3fd-200d-2642-fe0f": [
        "38261a",
        "b38768"
    ],
    "1f532": [
        "262624",
        "dedede"
    ],
    "1f1eb-1f1f7": [
        "c33c34",
        "7d8190"
    ],
    "1f9d7-1f3fe-200d-2640-fe0f": [
        "432b24",
        "938472"
    ],
    "1f1f0-1f1fe": [
        "1c1350",
        "e12d2c"
    ],
    "1f468-1f3fc-200d-2696-fe0f": [
        "e7deb0",
        "734428"
    ],
    "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe": [
        "114c83",
        "7a563f"
    ],
    "1f468-1f3fb-200d-1f9b1": [
        "161312",
        "c59677"
    ],
    "1f53d": [
        "66849f",
        "fcfcfd"
    ],
    "1f3c3-1f3fc-200d-27a1-fe0f": [
        "b78b6a",
        "0f1027"
    ],
    "1f449-1f3fb": [
        "e7b994",
        "000000"
    ],
    "1f44e-1f3fc": [
        "bc7c53",
        "e1bf99"
    ],
    "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff": [
        "991613",
        "cfa779"
    ],
    "1f9d1-1f3fd-200d-1f373": [
        "e1dfda",
        "8c5f42"
    ],
    "1f9db-1f3fb": [
        "0f0c0c",
        "d4d4d5"
    ],
    "1f9d1-1f3fc-200d-2708-fe0f": [
        "b68a55",
        "242322"
    ],
    "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc": [
        "9a9694",
        "453532"
    ],
    "1f468-1f3fc-200d-1f37c": [
        "c28f5d",
        "643664"
    ],
    "2620-fe0f": [
        "e8eced",
        "494949"
    ],
    "1f9dc-1f3fe-200d-2640-fe0f": [
        "76482d",
        "d2aa48"
    ],
    "1f9b6-1f3fd": [
        "583825",
        "bb8965"
    ],
    "1f9b9-1f3fe-200d-2640-fe0f": [
        "100b0c",
        "50207d"
    ],
    "1f9d1-1f3fd-200d-1f3a4": [
        "49ae3c",
        "73684d"
    ],
    "1f64d-1f3fb-200d-2640-fe0f": [
        "5d5351",
        "b49981"
    ],
    "1f468-1f3fc-200d-1f9bd-200d-27a1-fe0f": [
        "bb3737",
        "3b383b"
    ],
    "1f399-fe0f": [
        "eef4f8",
        "665d5f"
    ],
    "26f9-1f3ff-200d-2642-fe0f": [
        "342927",
        "80868c"
    ],
    "1f5a5-fe0f": [
        "adaeb1",
        "353534"
    ],
    "270a-1f3fe": [
        "4e2a19",
        "9c663e"
    ],
    "1f9d9-1f3fc-200d-2642-fe0f": [
        "beb293",
        "3c3121"
    ],
    "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc": [
        "c68c60",
        "6d4130"
    ],
    "1f7ea": [
        "b931ff",
        "c85fff"
    ],
    "1f46d-1f3fb": [
        "e2b28e",
        "2a272b"
    ],
    "1f1f3-1f1ea": [
        "af9d8b",
        "13651e"
    ],
    "1f468-1f3fc": [
        "dec88e",
        "b87d50"
    ],
    "1f7e7": [
        "ff8a04",
        "ffab4c"
    ],
    "1f468-1f3ff-200d-1f9bc-200d-27a1-fe0f": [
        "cd2d42",
        "515b7b"
    ],
    "1f1fb-1f1ec": [
        "141453",
        "e32c26"
    ],
    "1f9ce-1f3fd-200d-2640-fe0f": [
        "453337",
        "e0dbd2"
    ],
    "1f9f4": [
        "e3d4c7",
        "ee916f"
    ],
    "1f90e": [
        "723e19",
        "b5815c"
    ],
    "1f575-1f3fb": [
        "1d1a17",
        "89806b"
    ],
    "1f91a": [
        "e6a22b",
        "fccf60"
    ],
    "1f202-fe0f": [
        "0057b4",
        "f3f6f9"
    ],
    "1f468-1f3fe-200d-1f9b2": [
        "7f4e2e",
        "9d673f"
    ],
    "1f9d6-200d-2642-fe0f": [
        "deedec",
        "b38b42"
    ],
    "1f9e8": [
        "0a0606",
        "8f050f"
    ],
    "1f9fb": [
        "c4c2b7",
        "a7a59c"
    ],
    "1f3c3-1f3fc": [
        "d0a97f",
        "12153d"
    ],
    "1f6b6-1f3ff-200d-2642-fe0f-200d-27a1-fe0f": [
        "cf294f",
        "443936"
    ],
    "1f917": [
        "e38215",
        "fff29b"
    ],
    "1f9d4-1f3fe-200d-2642-fe0f": [
        "47352c",
        "d3bda6"
    ],
    "1f468-1f3fe-200d-1f9bd": [
        "a71e2b",
        "666975"
    ],
    "1f9e5": [
        "e1b964",
        "b4863d"
    ],
    "1f1fb-1f1e8": [
        "1c7c5e",
        "e9c94a"
    ],
    "1f44f-1f3ff": [
        "46332d",
        "605f5e"
    ],
    "26f9-1f3fc-200d-2640-fe0f": [
        "c99a6c",
        "a52d10"
    ],
    "1f93d": [
        "e2ab35",
        "f1f6f5"
    ],
    "1f468-1f3ff-200d-1f527": [
        "3e3431",
        "396cde"
    ],
    "1f474-1f3fb": [
        "a09890",
        "dba782"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe": [
        "6c3b26",
        "a67255"
    ],
    "1f9d1": [
        "c68b14",
        "f1b925"
    ],
    "1f9d9-1f3ff-200d-2640-fe0f": [
        "413425",
        "999255"
    ],
    "1faf7-1f3fb": [
        "c07750",
        "f9cda8"
    ],
    "1f9f9": [
        "2b190c",
        "9a8147"
    ],
    "1f9ec": [
        "dd3acf",
        "1983a2"
    ],
    "1f932": [
        "b06800",
        "f3bb22"
    ],
    "1f926": [
        "f1ba25",
        "aeaeae"
    ],
    "1f9b8-1f3fb": [
        "71545f",
        "e5bc9d"
    ],
    "1f326-fe0f": [
        "d4dce1",
        "1f98d8"
    ],
    "1f327-fe0f": [
        "bccbd6",
        "0479be"
    ],
    "1f934-1f3fc": [
        "313d16",
        "ac9051"
    ],
    "1f447-1f3fd": [
        "8f5c46",
        "b47e5e"
    ],
    "1f426-200d-1f525": [
        "9a0708",
        "d41b09"
    ],
    "1f93e-1f3fb-200d-2640-fe0f": [
        "c3a18a",
        "588760"
    ],
    "1f3f3-fe0f-200d-26a7-fe0f": [
        "c491a0",
        "56717f"
    ],
    "1f466-1f3fe": [
        "604230",
        "e6ddd1"
    ],
    "1f9d1-1f3fd-200d-2695-fe0f": [
        "613b21",
        "cac8c6"
    ],
    "1f468-1f3ff-200d-2695-fe0f": [
        "443b37",
        "8d9696"
    ],
    "1f487-1f3fb-200d-2640-fe0f": [
        "9c8f87",
        "231d1e"
    ],
    "1f6b4-1f3fc": [
        "3c3b3a",
        "b59f84"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "3a281f",
        "f34daf"
    ],
    "1f517": [
        "524c4d",
        "ecf2f5"
    ],
    "1f926-1f3fd": [
        "603a21",
        "706c68"
    ],
    "26ea": [
        "e1deda",
        "764c49"
    ],
    "1f3ca-1f3fd": [
        "cbe5ef",
        "000000"
    ],
    "1f9cf-1f3fd": [
        "9e6b50",
        "4e3729"
    ],
    "1f5fb": [
        "000000",
        "2a3b57"
    ],
    "1f636-200d-1f32b-fe0f": [
        "dde3e5",
        "e6cf92"
    ],
    "1f503": [
        "65839d",
        "fbfcfc"
    ],
    "1f468-1f3fb-200d-1f9af": [
        "b8183c",
        "5d648b"
    ],
    "1f468-1f3fc-200d-1f393": [
        "f5f5f0",
        "9e7c61"
    ],
    "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe": [
        "a49a94",
        "6d4833"
    ],
    "1f51a": [
        "616161",
        "b6b6b6"
    ],
    "1f1f0-1f1ed": [
        "ae1214",
        "0d0b5e"
    ],
    "1f50e": [
        "c0d1e0",
        "1b1c1f"
    ],
    "1f9d6-1f3fb": [
        "ddedef",
        "81766a"
    ],
    "26f0-fe0f": [
        "919879",
        "000000"
    ],
    "1f939-1f3ff-200d-2642-fe0f": [
        "3d302a",
        "548857"
    ],
    "1f1f5-1f1f1": [
        "b9b5b5",
        "702520"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb": [
        "f6c3c0",
        "583b29"
    ],
    "1f9bb-1f3fd": [
        "6a6663",
        "93624a"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "3e291b",
        "bd8d6a"
    ],
    "1f932-1f3fd": [
        "84523f",
        "b88663"
    ],
    "26f1-fe0f": [
        "8e5d58",
        "020101"
    ],
    "1f488": [
        "7f6d68",
        "eeebee"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd": [
        "b68868",
        "291c14"
    ],
    "1f469-1f3fe-200d-1f52c": [
        "e1e0e1",
        "46352c"
    ],
    "1f471-200d-2642-fe0f": [
        "d3b355",
        "eeb725"
    ],
    "1f645-1f3fe-200d-2640-fe0f": [
        "5b4033",
        "f6f5f4"
    ],
    "1f1f8-1f1f2": [
        "9da199",
        "0f4767"
    ],
    "1f468-1f3ff-200d-1f692": [
        "ab856b",
        "442922"
    ],
    "1f6c0-1f3fc": [
        "9a9d98",
        "e6eae3"
    ],
    "1f463": [
        "464646",
        "000000"
    ],
    "1f3fd": [
        "000000",
        "be8e67"
    ],
    "1f4c8": [
        "cad5df",
        "ba0909"
    ],
    "1faf1-1f3fe": [
        "69351b",
        "a36133"
    ],
    "1f305": [
        "f6f7f8",
        "f3904a"
    ],
    "1f46f-200d-2642-fe0f": [
        "b4770e",
        "31312e"
    ],
    "1f4af": [
        "f74427",
        "d00501"
    ],
    "1f311": [
        "686c70",
        "2a384e"
    ],
    "1f468-1f3fe-200d-1f3a8": [
        "cfcbbc",
        "755d4b"
    ],
    "1f477": [
        "d49929",
        "e6dea7"
    ],
    "1f1e6-1f1f7": [
        "6388aa",
        "e5e4e2"
    ],
    "1f469-1f3fc-200d-1f4bc": [
        "e5daa6",
        "323a4f"
    ],
    "1f46e": [
        "cd951c",
        "3d6d9d"
    ],
    "1f1f8-1f1fd": [
        "c32b31",
        "14115a"
    ],
    "1f30c": [
        "f9fafa",
        "193959"
    ],
    "1f339": [
        "f2646a",
        "6da437"
    ],
    "1f9d1-1f3ff-200d-1f4bc": [
        "201b18",
        "adaca6"
    ],
    "1f595-1f3fb": [
        "d9a079",
        "fadec0"
    ],
    "1f4a0": [
        "7f818f",
        "8cc8e6"
    ],
    "1f3cc-1f3fb-200d-2640-fe0f": [
        "a4988c",
        "3b2827"
    ],
    "1f472-1f3fe": [
        "9d593e",
        "47261a"
    ],
    "1f469-1f3fd-200d-1f680": [
        "d1ccc5",
        "a47a4b"
    ],
    "1f47a": [
        "953932",
        "f7f6f6"
    ],
    "1f1e6-1f1fa": [
        "163167",
        "d23c50"
    ],
    "1fab7": [
        "ddaca7",
        "ba6f68"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb": [
        "efc3b2",
        "2d2828"
    ],
    "1f469-1f3fd-200d-1f33e": [
        "79531c",
        "9ba7bf"
    ],
    "1f468-1f3ff-200d-1f3ed": [
        "0a0505",
        "5c72b4"
    ],
    "1f57a-1f3fb": [
        "572263",
        "efc4a2"
    ],
    "1fac3": [
        "b67714",
        "517eb9"
    ],
    "1faba": [
        "ae9c8c",
        "754723"
    ],
    "1f64b-1f3fe-200d-2642-fe0f": [
        "cccccf",
        "9b6539"
    ],
    "261d-1f3fe": [
        "603620",
        "070000"
    ],
    "1f469-1f3fd-200d-1f3eb": [
        "d4baa6",
        "725139"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb": [
        "edbeb4",
        "a06b61"
    ],
    "1face": [
        "ba8f69",
        "5d3e34"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb": [
        "936b4c",
        "d8b47f"
    ],
    "1faf1-1f3fd-200d-1faf2-1f3fc": [
        "d8ab84",
        "000000"
    ],
    "1fa9a": [
        "0f0a05",
        "8c8f8f"
    ],
    "1f6ad": [
        "e46139",
        "373231"
    ],
    "1f3c4-1f3fb-200d-2642-fe0f": [
        "107a95",
        "87d05d"
    ],
    "1f646-1f3fe-200d-2642-fe0f": [
        "4d8acd",
        "8b5a3a"
    ],
    "1f468-200d-1f9b0": [
        "d6800e",
        "fac128"
    ],
    "1fa83": [
        "8e5d47",
        "050303"
    ],
    "1fa97": [
        "7c2a34",
        "201c1f"
    ],
    "1f649": [
        "c29b6b",
        "65492c"
    ],
    "1f6a2": [
        "d7d5c7",
        "783130"
    ],
    "1f648": [
        "977148",
        "ba9468"
    ],
    "1fa96": [
        "455a60",
        "36352e"
    ],
    "1f6a3": [
        "e0b046",
        "000000"
    ],
    "1f469-1f3fb-200d-1f527": [
        "403c3f",
        "e5c7ad"
    ],
    "1f468-200d-1f9b1": [
        "c9901b",
        "f3bc27"
    ],
    "1f9d1-1f3fe-200d-1f384": [
        "bcb8b7",
        "622f22"
    ],
    "1fa82": [
        "b73919",
        "999ea8"
    ],
    "1f469-1f3fe-200d-1f9bd-200d-27a1-fe0f": [
        "b037b3",
        "403635"
    ],
    "1f938-1f3fd-200d-2640-fe0f": [
        "2e2014",
        "a8785b"
    ],
    "1f6ae": [
        "66839e",
        "f9f9fa"
    ],
    "26a7-fe0f": [
        "66839e",
        "f6f7f8"
    ],
    "1f9d1-200d-1f680": [
        "aba8a6",
        "838281"
    ],
    "1faf1-1f3fd-200d-1faf2-1f3fb": [
        "eec4a2",
        "000000"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc": [
        "dab094",
        "9a6454"
    ],
    "1f91b-1f3ff": [
        "59453a",
        "1c110c"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc": [
        "f8cfd9",
        "c49b5d"
    ],
    "1f935-1f3fb-200d-2640-fe0f": [
        "484342",
        "eed6be"
    ],
    "1f469-200d-1f37c": [
        "daa325",
        "613868"
    ],
    "261d-1f3fd": [
        "8d5b45",
        "140502"
    ],
    "270d-1f3ff": [
        "2e201a",
        "48352e"
    ],
    "1f32c-fe0f": [
        "cbd2da",
        "040405"
    ],
    "1fac2": [
        "6d94b5",
        "000000"
    ],
    "1f32b-fe0f": [
        "e8e8eb",
        "000000"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc": [
        "c79669",
        "2c2828"
    ],
    "1fab6": [
        "66563d",
        "c4b9aa"
    ],
    "1f57a-1f3fc": [
        "572161",
        "b78050"
    ],
    "1f31f": [
        "f3cc4e",
        "fdf9d2"
    ],
    "1f472-1f3fd": [
        "98533d",
        "603525"
    ],
    "1f4a1": [
        "eacc82",
        "706e66"
    ],
    "274c": [
        "000000",
        "ec0000"
    ],
    "1f1f8-1f1fe": [
        "b52938",
        "e9e9e9"
    ],
    "1f46d": [
        "e6a92a",
        "3887bc"
    ],
    "1f595-1f3fc": [
        "c5875d",
        "dfb993"
    ],
    "1f9d1-1f3ff-200d-1f4bb": [
        "201b1a",
        "88898c"
    ],
    "1f338": [
        "fdbbe5",
        "b55268"
    ],
    "1f30b": [
        "dd926c",
        "39393a"
    ],
    "1f310": [
        "ebf6fb",
        "4e9fbf"
    ],
    "1f469-1f3fc-200d-1f4bb": [
        "e6d9a2",
        "a87c49"
    ],
    "1f1e6-1f1f6": [
        "3b6ca4",
        "f5f7f9"
    ],
    "1f476": [
        "e8ab18",
        "7e4816"
    ],
    "1f3fe": [
        "000000",
        "9a633c"
    ],
    "1f462": [
        "d8be9e",
        "f7f5f1"
    ],
    "1f6c0-1f3fb": [
        "9ca09c",
        "eaece6"
    ],
    "203c-fe0f": [
        "d21300",
        "490600"
    ],
    "1f1f8-1f1f3": [
        "b22429",
        "7d844f"
    ],
    "1f6b6-1f3fd-200d-27a1-fe0f": [
        "cbc9ca",
        "3d4591"
    ],
    "1faf1-1f3fd": [
        "90553e",
        "4f2819"
    ],
    "1f304": [
        "fafbfb",
        "8d6382"
    ],
    "1f4c9": [
        "d7dfe6",
        "1161c1"
    ],
    "1f6a3-1f3fb-200d-2642-fe0f": [
        "b19f8a",
        "000000"
    ],
    "1f6b4-200d-2642-fe0f": [
        "0a0c69",
        "d7aa22"
    ],
    "1f932-1f3fe": [
        "552d1c",
        "945c37"
    ],
    "1f471-1f3fc-200d-2640-fe0f": [
        "be9e59",
        "9e713b"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe": [
        "715140",
        "f34dae"
    ],
    "1f489": [
        "8b9ba3",
        "647682"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc": [
        "debf8d",
        "613d25"
    ],
    "1f9d1-200d-1f33e": [
        "766517",
        "bab7ad"
    ],
    "1f1f5-1f1f0": [
        "155715",
        "e2e3e2"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "bf9367",
        "583718"
    ],
    "1f9bb-1f3fe": [
        "666260",
        "683d26"
    ],
    "1f469-1f3ff-200d-1f9af": [
        "c037c5",
        "140f1d"
    ],
    "1f9dd-200d-2640-fe0f": [
        "e3ae2b",
        "cec07d"
    ],
    "1f9d6-1f3fc": [
        "d7eaec",
        "c39d76"
    ],
    "1f9d1-1f3fb-200d-1f393": [
        "242323",
        "f4d6b8"
    ],
    "1f6b4-1f3fb-200d-2642-fe0f": [
        "0c0d7e",
        "5e8bb3"
    ],
    "1f9d1-1f3fc-200d-1f9af": [
        "d4d2d0",
        "464c72"
    ],
    "1f47c-1f3ff": [
        "4a372f",
        "d3ceb6"
    ],
    "1f3c4-200d-2642-fe0f": [
        "0a5e73",
        "85d05a"
    ],
    "1f64e-1f3ff": [
        "171310",
        "9f9f9e"
    ],
    "1f9d1-200d-1f3eb": [
        "d1bfa4",
        "445e49"
    ],
    "1f469-200d-1f9bc": [
        "484047",
        "928d9a"
    ],
    "1f926-200d-2642-fe0f": [
        "eab52a",
        "406ca3"
    ],
    "1f64e-1f3fe-200d-2640-fe0f": [
        "1b1212",
        "722380"
    ],
    "1f50d": [
        "eeeff1",
        "7e7e81"
    ],
    "1f1f0-1f1ee": [
        "ca373a",
        "1a355d"
    ],
    "1f9d8-1f3fd-200d-2642-fe0f": [
        "5c3b25",
        "b67f5b"
    ],
    "1f5fc": [
        "b6ada0",
        "9a1913"
    ],
    "1f9cf-1f3fe": [
        "724931",
        "b8b6b2"
    ],
    "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd": [
        "a59992",
        "43342d"
    ],
    "1f502": [
        "7191af",
        "bccedc"
    ],
    "1f516": [
        "e6e0d9",
        "e67070"
    ],
    "1f3ca-1f3fe": [
        "cce6f0",
        "000000"
    ],
    "1f9da-1f3fb-200d-2642-fe0f": [
        "9ee3cc",
        "bf9363"
    ],
    "1f926-1f3fe": [
        "453025",
        "7f7f7f"
    ],
    "1f469-1f3fb-200d-1f692": [
        "a3826e",
        "ad2c25"
    ],
    "1f3c3-1f3fb-200d-2640-fe0f": [
        "ebd0b7",
        "1b1825"
    ],
    "1f6b4-1f3fb": [
        "3c3b3a",
        "b7a690"
    ],
    "1f9cd-1f3fc-200d-2640-fe0f": [
        "cf9b71",
        "2c85c8"
    ],
    "1f46e-1f3ff-200d-2642-fe0f": [
        "8d9595",
        "302623"
    ],
    "1f9d1-1f3fd-200d-1f3a8": [
        "635446",
        "c5c2b1"
    ],
    "1f466-1f3fd": [
        "926142",
        "b48361"
    ],
    "1f3c3-1f3fc-200d-2642-fe0f-200d-27a1-fe0f": [
        "bc2561",
        "13183c"
    ],
    "1f469-1f3fb-200d-1f3ed": [
        "171719",
        "5275cb"
    ],
    "1f447-1f3fe": [
        "6b3c24",
        "9a633c"
    ],
    "1f1f3-1f1fa": [
        "bb7226",
        "02030c"
    ],
    "1f934-1f3fb": [
        "63b37a",
        "ad733c"
    ],
    "1f9d6-1f3fb-200d-2640-fe0f": [
        "e2eff0",
        "9d836a"
    ],
    "1f469-1f3fd-200d-2696-fe0f": [
        "8d5f3e",
        "241c17"
    ],
    "1f90f-1f3ff": [
        "4f3b32",
        "000000"
    ],
    "1f1f3-1f1f7": [
        "143063",
        "cfa947"
    ],
    "1f9b8-1f3fc": [
        "c59e65",
        "552d68"
    ],
    "1f927": [
        "d28215",
        "efebbe"
    ],
    "1f9ce-1f3fe-200d-27a1-fe0f": [
        "382923",
        "d0cecb"
    ],
    "25c0-fe0f": [
        "66839e",
        "fdfefe"
    ],
    "1f9df": [
        "33332f",
        "899683"
    ],
    "1f9eb": [
        "010001",
        "cca8b5"
    ],
    "1f9f8": [
        "d1a764",
        "6d451c"
    ],
    "1faf7-1f3fc": [
        "ae653b",
        "ce986f"
    ],
    "1f933": [
        "e7ad2c",
        "7a7979"
    ],
    "1f9db-1f3fb-200d-2640-fe0f": [
        "080708",
        "cac8ca"
    ],
    "1f9da-1f3ff": [
        "9ce2cb",
        "342219"
    ],
    "1f92a": [
        "c17132",
        "eddac1"
    ],
    "1f469-1f3ff-200d-2708-fe0f": [
        "433a36",
        "a3a08f"
    ],
    "1f9d0": [
        "c87b1d",
        "fbba23"
    ],
    "1f6b6-200d-2642-fe0f-200d-27a1-fe0f": [
        "d7344f",
        "3f4984"
    ],
    "1f474-1f3fc": [
        "cfc5ba",
        "bf8258"
    ],
    "1f6b6-1f3fd-200d-2640-fe0f-200d-27a1-fe0f": [
        "c15dc2",
        "6f442f"
    ],
    "1f483-1f3ff": [
        "ac0f1e",
        "4b3530"
    ],
    "1f9e4": [
        "2ead70",
        "10744e"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff": [
        "554541",
        "d29873"
    ],
    "1f9b8-1f3fb-200d-2640-fe0f": [
        "2a2328",
        "e7c3aa"
    ],
    "1f93e": [
        "8b5e16",
        "afafae"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff": [
        "2d1f19",
        "a37156"
    ],
    "1f3c4-1f3ff-200d-2640-fe0f": [
        "5aa917",
        "e3c1c5"
    ],
    "1f9d2": [
        "e5ab1d",
        "1b1408"
    ],
    "1f919": [
        "eba918",
        "fdce49"
    ],
    "1f92c": [
        "e54e0a",
        "2d1e18"
    ],
    "1f9da-1f3fd": [
        "9de3cb",
        "996341"
    ],
    "1f6b5-1f3fd-200d-2642-fe0f": [
        "847b71",
        "cad2cc"
    ],
    "1f44f-1f3fe": [
        "834f30",
        "5c5b5a"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd": [
        "6c4836",
        "c18d6a"
    ],
    "1f9e6": [
        "463728",
        "af9d89"
    ],
    "1f483-1f3fd": [
        "5f291f",
        "bf8c6f"
    ],
    "1f1fb-1f1fa": [
        "ba2843",
        "0f4222"
    ],
    "1f9dd": [
        "9f7f3e",
        "e3d499"
    ],
    "1f468-1f3fe-200d-1f9af": [
        "b91b3f",
        "495282"
    ],
    "1f939-1f3fc": [
        "3d473b",
        "b18e67"
    ],
    "1f468-1f3fd-200d-1f393": [
        "c3b9b1",
        "6d4e3d"
    ],
    "1f93e-1f3fb": [
        "dba985",
        "e8d5c3"
    ],
    "1f470-1f3fe-200d-2640-fe0f": [
        "c9c8c8",
        "8a5c3d"
    ],
    "1f482-1f3fd-200d-2640-fe0f": [
        "695538",
        "a48661"
    ],
    "1f9d1-200d-2695-fe0f": [
        "b07c1b",
        "d0ccbe"
    ],
    "1f925": [
        "c27416",
        "fdf28d"
    ],
    "1f9b5-1f3fb": [
        "fadcbe",
        "d2946d"
    ],
    "1f931": [
        "8f632c",
        "623c6b"
    ],
    "1f7e9": [
        "01b101",
        "3cc33a"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc": [
        "e4b8a1",
        "62402b"
    ],
    "1f1f3-1f1f5": [
        "7b7f9f",
        "310d22"
    ],
    "2747-fe0f": [
        "00900c",
        "fafcfa"
    ],
    "1f90f-1f3fd": [
        "b78462",
        "000000"
    ],
    "1f645-200d-2642-fe0f": [
        "a25e1a",
        "1f4d87"
    ],
    "1f937-1f3fd-200d-2642-fe0f": [
        "774932",
        "2e3b6d"
    ],
    "1f64c-1f3fc": [
        "c79069",
        "5e5b59"
    ],
    "1f491-1f3fc": [
        "dbbd87",
        "322615"
    ],
    "267e-fe0f": [
        "909090",
        "202020"
    ],
    "1f466-1f3ff": [
        "3c2e26",
        "e7e2d9"
    ],
    "1f3cc-1f3ff-200d-2642-fe0f": [
        "bdcac6",
        "7d7976"
    ],
    "1f468-200d-1f3a4": [
        "476293",
        "dea520"
    ],
    "1f468-200d-1f373": [
        "dfddd7",
        "e6ad22"
    ],
    "1f500": [
        "64819c",
        "fbfbfb"
    ],
    "1f91d-1f3fc": [
        "d19d75",
        "000000"
    ],
    "1f939-1f3fb-200d-2640-fe0f": [
        "312e2a",
        "e8caae"
    ],
    "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff": [
        "a19892",
        "2a221f"
    ],
    "1f918-1f3fb": [
        "e5b793",
        "be744d"
    ],
    "1f9d1-1f3fd-200d-1f9af-200d-27a1-fe0f": [
        "c1baba",
        "25274e"
    ],
    "1f575-1f3fe-200d-2640-fe0f": [
        "795840",
        "998f78"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc": [
        "931916",
        "d5a981"
    ],
    "1f6b6-1f3fd-200d-2640-fe0f": [
        "b13bbc",
        "373a86"
    ],
    "270b-1f3fc": [
        "c6895f",
        "dfb994"
    ],
    "1f514": [
        "6c5730",
        "f0d44c"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "41291d",
        "fd91d8"
    ],
    "1f50f": [
        "a7aca6",
        "52514d"
    ],
    "1f9ce-1f3fd-200d-2640-fe0f-200d-27a1-fe0f": [
        "443444",
        "9e2fa2"
    ],
    "1f473-1f3fe-200d-2642-fe0f": [
        "d1d1d1",
        "472b1e"
    ],
    "1f481-1f3fd-200d-2642-fe0f": [
        "1f100d",
        "385a93"
    ],
    "1f51b": [
        "d8d8d8",
        "464646"
    ],
    "1f528": [
        "5b5b5e",
        "353433"
    ],
    "1f47c-1f3fd": [
        "ac7c5d",
        "a29d92"
    ],
    "1f9dc-1f3fd-200d-2640-fe0f": [
        "af7b51",
        "7082a5"
    ],
    "1f9d1-200d-1f4bb": [
        "efb92c",
        "bf8314"
    ],
    "1f64e-1f3fd": [
        "53321b",
        "9f9e9d"
    ],
    "1f9b9-1f3fd-200d-2640-fe0f": [
        "472b19",
        "996e4f"
    ],
    "1f468-1f3fd-200d-1f9af-200d-27a1-fe0f": [
        "c52d43",
        "d9d5d4"
    ],
    "1f3c3-1f3fb-200d-27a1-fe0f": [
        "e9bf9c",
        "07081b"
    ],
    "1f9d1-1f3fb-200d-2708-fe0f": [
        "201f1e",
        "cea88a"
    ],
    "1f1f5-1f1f2": [
        "285161",
        "9a572d"
    ],
    "1f474": [
        "e4a818",
        "bc7e0d"
    ],
    "1f1e6-1f1f4": [
        "802227",
        "0a0909"
    ],
    "2753": [
        "e84c4c",
        "d00808"
    ],
    "1f9d7-1f3fd-200d-2640-fe0f": [
        "3e2c32",
        "c20302"
    ],
    "1f5c2-fe0f": [
        "efd9c1",
        "ff0000"
    ],
    "1f9d1-1f3ff-200d-1f33e": [
        "6b4e20",
        "9c9b9f"
    ],
    "1f4ae": [
        "fd0404",
        "fefafa"
    ],
    "1f312": [
        "f8eba9",
        "283548"
    ],
    "1f1fd-1f1f0": [
        "2c4989",
        "cdb180"
    ],
    "1f306": [
        "fcfcfc",
        "d96652"
    ],
    "1faf1-1f3ff": [
        "31201a",
        "4f372f"
    ],
    "1f487-1f3ff-200d-2642-fe0f": [
        "c0bfbf",
        "7b7270"
    ],
    "27bf": [
        "929292",
        "000000"
    ],
    "1f469-1f3fc-200d-1f3eb": [
        "dbc699",
        "485642"
    ],
    "1f1f8-1f1f1": [
        "41a654",
        "dde0df"
    ],
    "1f5c3-fe0f": [
        "666567",
        "eaeaeb"
    ],
    "1f460": [
        "af6c5f",
        "543932"
    ],
    "1f468-1f3fb-200d-2696-fe0f": [
        "986540",
        "110f0e"
    ],
    "1f9d1-1f3ff-200d-1f3eb": [
        "bfb3a9",
        "475445"
    ],
    "1f47b": [
        "9d969a",
        "0f0c0c"
    ],
    "1f448": [
        "f5b925",
        "000000"
    ],
    "1f1e6-1f1e8": [
        "0d2551",
        "bb6243"
    ],
    "1f4a3": [
        "f8f6f4",
        "554d51"
    ],
    "1f472-1f3ff": [
        "a4503b",
        "34211a"
    ],
    "1f31d": [
        "f7ec9e",
        "a28849"
    ],
    "27b0": [
        "626262",
        "b1b1b1"
    ],
    "1f485-1f3fc": [
        "4a303d",
        "deb690"
    ],
    "1f9cf-1f3fe-200d-2642-fe0f": [
        "432a1f",
        "797775"
    ],
    "1f9b9-200d-2642-fe0f": [
        "e1a119",
        "20151b"
    ],
    "1f46f": [
        "c18510",
        "312d29"
    ],
    "1f469-1f3fc-200d-1f33e": [
        "785016",
        "c8b8a5"
    ],
    "2694-fe0f": [
        "7f787c",
        "d4e9f6"
    ],
    "1f469-1f3fc-200d-1f680": [
        "d4cabc",
        "776246"
    ],
    "1fac0": [
        "a92a32",
        "c94b52"
    ],
    "1f1e8-1f1ee": [
        "108154",
        "7d9680"
    ],
    "1f9d4-1f3fd-200d-2642-fe0f": [
        "714729",
        "b98865"
    ],
    "1f93e-1f3ff-200d-2642-fe0f": [
        "2e1c16",
        "dcdcd8"
    ],
    "1fab4": [
        "051205",
        "905e39"
    ],
    "1facf": [
        "999896",
        "30302e"
    ],
    "1f468-1f3fb-200d-1f3a8": [
        "e0d0bb",
        "468bd7"
    ],
    "1f469-1f3fd-200d-1f4bc": [
        "7d5336",
        "dcdddf"
    ],
    "1f91b-1f3fd": [
        "b98764",
        "442b1a"
    ],
    "1f9ce-1f3fe-200d-2640-fe0f": [
        "614947",
        "ddd8cf"
    ],
    "1f689": [
        "40474b",
        "f5f5f5"
    ],
    "270d-1f3fd": [
        "845844",
        "0d0805"
    ],
    "1f9d1-1f3ff-200d-1f680": [
        "d1ccc5",
        "615447"
    ],
    "261d-1f3ff": [
        "33241d",
        "59443a"
    ],
    "1f9d7-200d-2642-fe0f": [
        "e0922d",
        "575c61"
    ],
    "1f1f6-1f1e6": [
        "4f1b2a",
        "d9d8d8"
    ],
    "1faa8": [
        "6a6a65",
        "000000"
    ],
    "1fabb": [
        "a090cb",
        "406836"
    ],
    "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc": [
        "104d86",
        "b38362"
    ],
    "1f469-1f3fb-200d-1f52c": [
        "e1dcd7",
        "121111"
    ],
    "1fa9b": [
        "030401",
        "42951b"
    ],
    "1f3cc-fe0f": [
        "ecedec",
        "423e3c"
    ],
    "1f6a1": [
        "d5ceb3",
        "3a3f44"
    ],
    "1fa94": [
        "7e2c1e",
        "9a635c"
    ],
    "1f64d-1f3fc-200d-2640-fe0f": [
        "e3cf9b",
        "712580"
    ],
    "1fa80": [
        "114e0f",
        "b5b48d"
    ],
    "1f3cb-fe0f": [
        "596779",
        "b3750f"
    ],
    "1f9d9-1f3fb-200d-2642-fe0f": [
        "e4d1b1",
        "1c1710"
    ],
    "1f468-200d-1f9b3": [
        "e6cf95",
        "eeb624"
    ],
    "1fa81": [
        "6f53a4",
        "4c8fd0"
    ],
    "1f9db-1f3ff-200d-2642-fe0f": [
        "121111",
        "3f3b3c"
    ],
    "1f468-200d-1f9b2": [
        "eab221",
        "171005"
    ],
    "1f6a0": [
        "7f7c81",
        "32404e"
    ],
    "1f9d1-1f3fe-200d-1f393": [
        "2c2726",
        "6d6a67"
    ],
    "1f9d1-1f3fd-200d-1f9af": [
        "d2d0d0",
        "724230"
    ],
    "1f9b8-1f3ff-200d-2642-fe0f": [
        "261e1f",
        "c22139"
    ],
    "1fa95": [
        "473831",
        "ffffe9"
    ],
    "1f468-200d-1f9bd": [
        "b03f23",
        "343134"
    ],
    "1f6af": [
        "e56036",
        "2f2b2a"
    ],
    "1fa9c": [
        "f8f1e8",
        "7c5f41"
    ],
    "270d-1f3fe": [
        "603823",
        "0f0907"
    ],
    "1f9d6-1f3ff-200d-2642-fe0f": [
        "dcecee",
        "625750"
    ],
    "1fabc": [
        "0097fe",
        "002fb6"
    ],
    "1faa9": [
        "888785",
        "575859"
    ],
    "1f486-1f3fd-200d-2640-fe0f": [
        "7d5239",
        "ba8b6a"
    ],
    "1f469-1f3fd-200d-1f4bb": [
        "8a5e3f",
        "958e8b"
    ],
    "1f688": [
        "6a8394",
        "111946"
    ],
    "1f91b-1f3fe": [
        "98623b",
        "402214"
    ],
    "1fab5": [
        "6a5141",
        "c49971"
    ],
    "1f1e8-1f1ed": [
        "bc1313",
        "f9efef"
    ],
    "1fac1": [
        "da5752",
        "cfa195"
    ],
    "1f30a": [
        "9dbfc6",
        "2368a7"
    ],
    "1f468-1f3fe-200d-1f9bc-200d-27a1-fe0f": [
        "cc2d3f",
        "352b2e"
    ],
    "24c2-fe0f": [
        "0053c8",
        "f9fbfd"
    ],
    "1f485-1f3fb": [
        "653b52",
        "f3c5bc"
    ],
    "1f487-200d-2642-fe0f": [
        "e3ded2",
        "bf8415"
    ],
    "1f93e-200d-2640-fe0f": [
        "654c21",
        "6b9870"
    ],
    "1f1f8-1f1ff": [
        "921d18",
        "2a3962"
    ],
    "1f477-1f3fe-200d-2642-fe0f": [
        "e1b23c",
        "492a1a"
    ],
    "1f3f0": [
        "464845",
        "bec1b7"
    ],
    "1f46e-1f3fb-200d-2640-fe0f": [
        "263852",
        "f2d3ac"
    ],
    "1f1e6-1f1fc": [
        "4e6c94",
        "2f4059"
    ],
    "1f1e6-1f1e9": [
        "ba2730",
        "886f4e"
    ],
    "1f449": [
        "f5b826",
        "000000"
    ],
    "1f47c": [
        "eeb625",
        "888379"
    ],
    "1f93d-1f3fd-200d-2640-fe0f": [
        "cba162",
        "eff3f3"
    ],
    "1f31e": [
        "fbe494",
        "fbbe27"
    ],
    "1f926-1f3fc-200d-2642-fe0f": [
        "d9bc83",
        "3e70af"
    ],
    "1f4a2": [
        "8f0000",
        "da0909"
    ],
    "1f3c3-1f3ff-200d-2642-fe0f": [
        "3d2e2f",
        "c6c0b8"
    ],
    "1f307": [
        "f8f8ee",
        "732228"
    ],
    "1f3ff": [
        "000000",
        "efefef"
    ],
    "1f461": [
        "ceb090",
        "000000"
    ],
    "1f1f8-1f1f0": [
        "b1a2ab",
        "871723"
    ],
    "1f475": [
        "f9c431",
        "9d630b"
    ],
    "1f313": [
        "fbdf54",
        "2b384c"
    ],
    "1f4ad": [
        "959696",
        "f8f8f9"
    ],
    "1f64b-200d-2642-fe0f": [
        "ece6b8",
        "3c64a0"
    ],
    "1f9bb-1f3ff": [
        "6d6b69",
        "2d211a"
    ],
    "1f1f5-1f1f3": [
        "0d244c",
        "9f6346"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff": [
        "5c4e48",
        "fd92d8"
    ],
    "1f9da-1f3ff-200d-2640-fe0f": [
        "9ee3cc",
        "433028"
    ],
    "1f932-1f3ff": [
        "241911",
        "533e35"
    ],
    "1f64e-1f3fe": [
        "3a2922",
        "b4b2b0"
    ],
    "1f1f5-1f1fe": [
        "b52736",
        "e5e3e4"
    ],
    "1f9d1-1f3fb-200d-1f384": [
        "eeecea",
        "78362c"
    ],
    "1f3dd-fe0f": [
        "484f32",
        "96f6eb"
    ],
    "1f9d1-200d-1f4bc": [
        "bd8416",
        "ece2c9"
    ],
    "1f469-1f3fe-200d-1f527": [
        "916e57",
        "211715"
    ],
    "1f47c-1f3fe": [
        "845435",
        "e6be47"
    ],
    "1f3de-fe0f": [
        "edfaf9",
        "5c7a3b"
    ],
    "1f647-1f3fc-200d-2642-fe0f": [
        "ece2a5",
        "8b8d90"
    ],
    "1f529": [
        "ededea",
        "7e7b7f"
    ],
    "1f51c": [
        "c4c4c4",
        "484848"
    ],
    "1f6b4-1f3ff-200d-2640-fe0f": [
        "423a3a",
        "7a7372"
    ],
    "1f3ca-1f3ff": [
        "cce5f0",
        "000000"
    ],
    "1f926-1f3ff": [
        "29201c",
        "736f69"
    ],
    "1f6a3-1f3ff-200d-2640-fe0f": [
        "483831",
        "a67158"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "73492e",
        "d94296"
    ],
    "1f515": [
        "735c2f",
        "d6b03b"
    ],
    "270b-1f3fb": [
        "d9a07a",
        "fadec1"
    ],
    "1f468-200d-2764-200d-1f468": [
        "fac735",
        "4281c4"
    ],
    "1f91d-1f3fb": [
        "e0ac87",
        "000000"
    ],
    "1f501": [
        "65839e",
        "b9cbda"
    ],
    "1f9cf-1f3ff": [
        "2b1f19",
        "a1a19f"
    ],
    "1f918-1f3fc": [
        "cd956c",
        "964923"
    ],
    "1f3ca-1f3fd-200d-2642-fe0f": [
        "dff8fb",
        "000000"
    ],
    "1f9d1-1f3fe-200d-1f9bc-200d-27a1-fe0f": [
        "e5e5e5",
        "515874"
    ],
    "2199-fe0f": [
        "66839f",
        "fefefe"
    ],
    "1f469-1f3fe-200d-1f3ed": [
        "1c1817",
        "4f6ebf"
    ],
    "1f491-1f3fb": [
        "f5c8b9",
        "372e2d"
    ],
    "2198-fe0f": [
        "66839e",
        "fefefe"
    ],
    "1f1f3-1f1e8": [
        "325099",
        "b74835"
    ],
    "1f58a-fe0f": [
        "77787a",
        "292b2e"
    ],
    "1f64c-1f3fb": [
        "e0ad88",
        "615d5b"
    ],
    "1f447-1f3ff": [
        "3a2923",
        "584338"
    ],
    "1f3cb-1f3fd-200d-2640-fe0f": [
        "723a40",
        "291e1b"
    ],
    "1f9d1-1f3fc-200d-1f3a8": [
        "b28d65",
        "5d5a4f"
    ],
    "1f9dd-1f3fd-200d-2642-fe0f": [
        "9b7656",
        "e2d9a7"
    ],
    "1f469-1f3ff-200d-1f3a8": [
        "453c36",
        "ab9679"
    ],
    "1f90f-1f3fe": [
        "8f5834",
        "000000"
    ],
    "1f468-200d-2764-fe0f-200d-1f468": [
        "fac735",
        "4281c4"
    ],
    "1f1f3-1f1f4": [
        "8e241f",
        "5f718e"
    ],
    "1f935-1f3ff-200d-2642-fe0f": [
        "292320",
        "e0e0df"
    ],
    "1f7e8": [
        "fbc806",
        "fedb4e"
    ],
    "1f6f3-fe0f": [
        "d5dbdd",
        "305161"
    ],
    "1f469-1f3fe-200d-1f692": [
        "af866d",
        "563026"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f3c2bb",
        "5b3d2d"
    ],
    "1f468-1f3ff-200d-1f52c": [
        "dadbda",
        "443a36"
    ],
    "1f930": [
        "eab433",
        "7a3d78"
    ],
    "1f9b5-1f3fc": [
        "dcb38d",
        "c3845a"
    ],
    "2639-fe0f": [
        "bd7325",
        "fdd137"
    ],
    "1f9ea": [
        "85a68a",
        "25cb2d"
    ],
    "1f939-1f3fb": [
        "3d493c",
        "dec4aa"
    ],
    "1f9de": [
        "514585",
        "c1700e"
    ],
    "1f924": [
        "c37416",
        "f9f599"
    ],
    "2638-fe0f": [
        "742c89",
        "faf8fa"
    ],
    "1f93e-1f3fc": [
        "353330",
        "b3aea4"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe": [
        "3b2a25",
        "e4b592"
    ],
    "1f93f": [
        "595654",
        "fdfdfd"
    ],
    "1f44f-1f3fd": [
        "ad765a",
        "5a5856"
    ],
    "1f483-1f3fe": [
        "eee8db",
        "361311"
    ],
    "1f9e7": [
        "c82928",
        "deb160"
    ],
    "1f9d3": [
        "b17913",
        "f6c230"
    ],
    "1f9da-1f3fe": [
        "9fe6cf",
        "733f1e"
    ],
    "1f92b": [
        "c96f15",
        "feee8f"
    ],
    "1f918": [
        "e39c0f",
        "45140d"
    ],
    "1f9d1-1f3fc-200d-1f384": [
        "c1bebd",
        "7c3b2f"
    ],
    "1f920": [
        "57422b",
        "f9b41c"
    ],
    "1f939-1f3ff": [
        "3c302a",
        "cec9c4"
    ],
    "1f9da": [
        "9de2c9",
        "c58917"
    ],
    "1faf7-1f3fd": [
        "774530",
        "b47554"
    ],
    "1f3c3-1f3fe-200d-2642-fe0f": [
        "854635",
        "c9c5bd"
    ],
    "1f9ee": [
        "9c6223",
        "771c0b"
    ],
    "1f934": [
        "80bc85",
        "cf9e1d"
    ],
    "1f9cd-1f3fd-200d-2642-fe0f": [
        "5a2e24",
        "ad7b5d"
    ],
    "1f469-1f3fd-200d-1f527": [
        "c0a28b",
        "523526"
    ],
    "1f92f": [
        "deb376",
        "ca7417"
    ],
    "1f474-1f3fd": [
        "c0b7ae",
        "90644f"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc": [
        "b57d58",
        "3483bb"
    ],
    "1f9d7": [
        "aea79d",
        "c10401"
    ],
    "1f9e3": [
        "a7211d",
        "c93c37"
    ],
    "1f477-1f3ff-200d-2642-fe0f": [
        "dead3a",
        "33241b"
    ],
    "1f9d8-1f3fc-200d-2640-fe0f": [
        "9e5d38",
        "ddb78a"
    ],
    "1f7f0": [
        "000000",
        "434343"
    ],
    "1f1ea-1f1e8": [
        "a65736",
        "68101a"
    ],
    "1f447-1f3fb": [
        "d89f79",
        "f9dcbd"
    ],
    "1f64c-1f3ff": [
        "3d2c26",
        "606060"
    ],
    "1f1f3-1f1ff": [
        "0c0c45",
        "a18b9e"
    ],
    "1f469-200d-1f9af-200d-27a1-fe0f": [
        "c143bb",
        "e5deca"
    ],
    "1f64e-1f3fb-200d-2642-fe0f": [
        "433b37",
        "f1cead"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff": [
        "68442f",
        "b07a62"
    ],
    "1f934-1f3fe": [
        "9dc8a1",
        "4b311d"
    ],
    "1f9da-1f3fe-200d-2640-fe0f": [
        "9ee4cd",
        "734229"
    ],
    "1f9b8-1f3fd": [
        "5b3536",
        "9f6a55"
    ],
    "1f6b4-1f3fe": [
        "3e3a38",
        "d8d8d7"
    ],
    "1f1fa-1f1e6": [
        "39659f",
        "7d7016"
    ],
    "1f6cb-fe0f": [
        "dcdedc",
        "7ba7d7"
    ],
    "1f491-1f3ff": [
        "56443f",
        "afadac"
    ],
    "1f9b8-1f3fe-200d-2642-fe0f": [
        "3e2629",
        "c62239"
    ],
    "1f469-1f3ff-200d-1f9af-200d-27a1-fe0f": [
        "c043c3",
        "e2dddb"
    ],
    "1f9db-1f3fe-200d-2642-fe0f": [
        "161516",
        "646262"
    ],
    "1f466-1f3fc": [
        "ab854b",
        "311c0d"
    ],
    "1f469-1f3fe-200d-1f4bb": [
        "503d35",
        "8d8f91"
    ],
    "1f469-200d-1f9bd": [
        "865f5b",
        "363337"
    ],
    "1f1eb-1f1ef": [
        "22add2",
        "195e77"
    ],
    "1f539": [
        "00539d",
        "000000"
    ],
    "1f50c": [
        "acaaab",
        "2a2a2a"
    ],
    "1f9cf-1f3fb": [
        "ddb99c",
        "76726f"
    ],
    "1f5fd": [
        "578a88",
        "e3f8f5"
    ],
    "1f469-200d-1f9b2": [
        "d79b17",
        "f7c332"
    ],
    "1f505": [
        "f9b018",
        "000000"
    ],
    "1f91d-1f3ff": [
        "412f28",
        "000000"
    ],
    "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc": [
        "9a9694",
        "3c302e"
    ],
    "270b-1f3ff": [
        "392821",
        "584439"
    ],
    "1f511": [
        "e4b92b",
        "cdc2ba"
    ],
    "1f469-1f3fc-200d-2695-fe0f": [
        "e4deb6",
        "a47a47"
    ],
    "1f9d1-1f3fe-200d-1f9af": [
        "d1cdcb",
        "312d50"
    ],
    "1f9d6-1f3fe-200d-2642-fe0f": [
        "bec0bd",
        "916d55"
    ],
    "1f926-1f3fb": [
        "221f1f",
        "f3d0af"
    ],
    "1f9d1-1f3fd-200d-1f393": [
        "524034",
        "ebd4c0"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff": [
        "991613",
        "dfb290"
    ],
    "1f3ca-1f3fb": [
        "cbe5ef",
        "000000"
    ],
    "1f932-1f3fb": [
        "c7835d",
        "f2ccaa"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb": [
        "665751",
        "f3beb9"
    ],
    "1f1f5-1f1f7": [
        "ded7d9",
        "691226"
    ],
    "1f9bb-1f3fb": [
        "6f6661",
        "f2cdab"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "5b381a",
        "ba8a67"
    ],
    "1f935-1f3fe-200d-2642-fe0f": [
        "4b3428",
        "e7e7e6"
    ],
    "1f9d6-1f3fd": [
        "dfedee",
        "937058"
    ],
    "2795": [
        "000000",
        "b9b9b9"
    ],
    "1f31a": [
        "1c1f29",
        "686e82"
    ],
    "1f472-1f3fc": [
        "8e3e2d",
        "d4bb92"
    ],
    "1f4a6": [
        "34c0fa",
        "0262a2"
    ],
    "2712-fe0f": [
        "7a7c80",
        "bdc1c5"
    ],
    "1f3f4": [
        "1f2020",
        "585857"
    ],
    "1f459": [
        "7a1e49",
        "1b0c0c"
    ],
    "1f46c": [
        "114e86",
        "d89121"
    ],
    "1f469-1f3fd-200d-1f692": [
        "b2856b",
        "552f25"
    ],
    "1f1f8-1f1e8": [
        "b84040",
        "11433b"
    ],
    "1f1f8-1f1fb": [
        "0d1c5f",
        "e7e7e5"
    ],
    "1f485-1f3ff": [
        "5e4048",
        "e488d2"
    ],
    "1f30e": [
        "767c4a",
        "3769c2"
    ],
    "1f595-1f3fd": [
        "875741",
        "bf8f6a"
    ],
    "1f317": [
        "747169",
        "f0ca47"
    ],
    "1f468-1f3ff-200d-1f680": [
        "9c9994",
        "7d7466"
    ],
    "1f1e6-1f1f1": [
        "9e232a",
        "62191d"
    ],
    "1f471": [
        "9e6f1f",
        "f8c22c"
    ],
    "1f1f8-1f1f4": [
        "3c71af",
        "28486d"
    ],
    "1f6c0-1f3fe": [
        "969c94",
        "e9ebe8"
    ],
    "1f3e8": [
        "e9dac5",
        "767e7c"
    ],
    "1f3fb": [
        "000000",
        "f9dbbb"
    ],
    "1f465": [
        "6e95b6",
        "000000"
    ],
    "1f938-1f3fc-200d-2642-fe0f": [
        "282f35",
        "bf8558"
    ],
    "1faf1-1f3fc": [
        "c3845a",
        "000000"
    ],
    "1f303": [
        "f6f8f6",
        "143d65"
    ],
    "1f9d1-1f3fb-200d-1f3a8": [
        "373735",
        "d4ba9c"
    ],
    "262a-fe0f": [
        "762d8c",
        "d39fdd"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd": [
        "af8061",
        "67402c"
    ],
    "1f1e8-1f1e6": [
        "a01010",
        "efeaea"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd": [
        "966843",
        "cfab78"
    ],
    "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff": [
        "114d85",
        "82624b"
    ],
    "1f6a3-1f3fe-200d-2640-fe0f": [
        "774531",
        "9a6d54"
    ],
    "1f468-1f3ff-200d-1f33e": [
        "7b6d1c",
        "9baca3"
    ],
    "1f471-1f3fd-200d-2642-fe0f": [
        "dccd91",
        "593b2b"
    ],
    "1f698": [
        "3c7a93",
        "e41a13"
    ],
    "1f469-1f3fd-200d-1f3ed": [
        "1a1819",
        "525e8a"
    ],
    "261d-1f3fc": [
        "c4875e",
        "6d0b00"
    ],
    "1fac5": [
        "d69e17",
        "f6e274"
    ],
    "1fab1": [
        "ba6278",
        "7b0000"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd": [
        "be8d6c",
        "352720"
    ],
    "1f9dc-200d-2642-fe0f": [
        "eec43e",
        "616d9a"
    ],
    "1f3c3-200d-2640-fe0f": [
        "f2b426",
        "bdced1"
    ],
    "1f57a-1f3fd": [
        "6c3277",
        "141323"
    ],
    "1f6b4-1f3fe-200d-2640-fe0f": [
        "1c151a",
        "9c3f33"
    ],
    "1f468-1f3ff-200d-1f3eb": [
        "d3baa3",
        "4a5342"
    ],
    "1fa91": [
        "ac6a47",
        "5e3824"
    ],
    "1f6a4": [
        "000000",
        "8f6329"
    ],
    "1fa85": [
        "9bbe91",
        "b14c92"
    ],
    "1f6ab": [
        "e16e56",
        "ce3414"
    ],
    "1f6b8": [
        "f6be38",
        "0e0c01"
    ],
    "1faf1-1f3fd-200d-1faf2-1f3fe": [
        "835135",
        "b98763"
    ],
    "1f9d1-200d-1f692": [
        "a47d68",
        "c4bfb8"
    ],
    "1fa9f": [
        "aa6a47",
        "94bbda"
    ],
    "1f6b9": [
        "0061e1",
        "fbfbfc"
    ],
    "1f6ac": [
        "969493",
        "f9f8f7"
    ],
    "1f3cc-1f3fe-200d-2642-fe0f": [
        "bac8c5",
        "7f766f"
    ],
    "1f5e8-fe0f": [
        "6d6d6d",
        "353535"
    ],
    "1fa84": [
        "deb856",
        "33312e"
    ],
    "1fa90": [
        "453d27",
        "e6dea7"
    ],
    "1f6a5": [
        "b8bfb4",
        "000000"
    ],
    "1f9ce-1f3fb-200d-2642-fe0f-200d-27a1-fe0f": [
        "010103",
        "e0b895"
    ],
    "1f473-1f3ff-200d-2642-fe0f": [
        "dbdbdb",
        "150f0d"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe": [
        "7f5c48",
        "f2c0bf"
    ],
    "1fab0": [
        "4c3a2a",
        "cf975d"
    ],
    "1f57a-1f3fe": [
        "61296d",
        "231b24"
    ],
    "2764-fe0f": [
        "b70d04",
        "fc7369"
    ],
    "1f469-200d-1f373": [
        "dddbd5",
        "ecb73d"
    ],
    "1fac4": [
        "c07f12",
        "8d8d8c"
    ],
    "1fabf": [
        "bbb2a3",
        "847869"
    ],
    "1f645-1f3fb-200d-2642-fe0f": [
        "a97a59",
        "2e384a"
    ],
    "261d-1f3fb": [
        "d69b75",
        "881c03"
    ],
    "1f699": [
        "6f96a5",
        "080808"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe": [
        "956250",
        "533423"
    ],
    "1f469-200d-1f3a4": [
        "a14484",
        "2c2527"
    ],
    "25b6-fe0f": [
        "66839e",
        "fdfefe"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe": [
        "5c3e30",
        "e3bc9b"
    ],
    "1f575-1f3ff-200d-2640-fe0f": [
        "49413c",
        "bcc1bd"
    ],
    "1f464": [
        "6e97b7",
        "99d2e8"
    ],
    "1f3fc": [
        "000000",
        "dfba94"
    ],
    "1f3e9": [
        "e4cbd7",
        "e24175"
    ],
    "1f6c0-1f3fd": [
        "a09d91",
        "e7e9e5"
    ],
    "265f-fe0f": [
        "555555",
        "313131"
    ],
    "1faf1-1f3fb": [
        "d49772",
        "922a06"
    ],
    "1f302": [
        "3b2d55",
        "8266a5"
    ],
    "1f4aa": [
        "c07915",
        "f9c437"
    ],
    "1f316": [
        "777468",
        "f9d93b"
    ],
    "2757": [
        "000000",
        "de0101"
    ],
    "1f470-1f3ff-200d-2640-fe0f": [
        "c5c5c4",
        "1c1714"
    ],
    "1f470": [
        "c7c4be",
        "efb725"
    ],
    "274e": [
        "00a703",
        "eeecee"
    ],
    "1f1f8-1f1e9": [
        "bb2b46",
        "0a0a0a"
    ],
    "1f46b": [
        "901c16",
        "f4c238"
    ],
    "1f458": [
        "d4791b",
        "f8b827"
    ],
    "1f595-1f3fe": [
        "693b24",
        "7d4a2c"
    ],
    "1f30d": [
        "7e8fa2",
        "afb751"
    ],
    "1f3c4-1f3fe-200d-2640-fe0f": [
        "776f33",
        "e3c3c5"
    ],
    "1f646-1f3fb-200d-2640-fe0f": [
        "963da9",
        "5c1d67"
    ],
    "1f4a7": [
        "0367a7",
        "32bdf8"
    ],
    "1f472-1f3fb": [
        "974c3b",
        "d5b089"
    ],
    "1f47f": [
        "560f64",
        "ce8add"
    ],
    "1f1e6-1f1ff": [
        "1b9496",
        "ca1a42"
    ],
    "1f646-200d-2642-fe0f": [
        "518bcd",
        "f0bb2c"
    ],
    "1f468-1f3fe-200d-1f393": [
        "e3dfd2",
        "533c2f"
    ],
    "1f9d1-200d-1f3ed": [
        "212021",
        "555f7c"
    ],
    "1f468-1f3fd-200d-1f9af": [
        "b61b3d",
        "776c7d"
    ],
    "1f3f3-fe0f": [
        "aaabac",
        "545552"
    ],
    "1f9d6-1f3fe": [
        "e1f0f1",
        "8f684c"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe": [
        "865a41",
        "ae8c72"
    ],
    "1f575-fe0f-200d-2642-fe0f": [
        "e5ae23",
        "24201c"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "462b1a",
        "b98a68"
    ],
    "1f9bb-1f3fc": [
        "6d625d",
        "c68c63"
    ],
    "1f932-1f3fc": [
        "a45e35",
        "daaf89"
    ],
    "1f64b-1f3fb-200d-2640-fe0f": [
        "564b4c",
        "f3cda2"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc": [
        "f9bdd9",
        "785c40"
    ],
    "1f510": [
        "bc973f",
        "675f49"
    ],
    "1f9d4-200d-2642-fe0f": [
        "f5be2a",
        "8f5604"
    ],
    "1f3ca-1f3fc": [
        "cce5ef",
        "000000"
    ],
    "1f926-1f3fc": [
        "bd945e",
        "ddc78b"
    ],
    "1f469-200d-1f9b3": [
        "e2cf9a",
        "b78c2c"
    ],
    "1f5fe": [
        "f6f8f9",
        "578fde"
    ],
    "1f9cf-1f3fc": [
        "c68e63",
        "735744"
    ],
    "1f918-1f3ff": [
        "36261f",
        "59443a"
    ],
    "1f9ce-1f3ff-200d-2640-fe0f": [
        "252128",
        "d2cec6"
    ],
    "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb": [
        "9c9794",
        "312d2b"
    ],
    "1f9d1-1f3ff-200d-1f52c": [
        "e0e0e1",
        "574e4a"
    ],
    "1f504": [
        "65829d",
        "fbfcfc"
    ],
    "1f51f": [
        "65829d",
        "b5c8d9"
    ],
    "1f1f0-1f1ec": [
        "bc1a2e",
        "6f0f1b"
    ],
    "1f93e-1f3fe-200d-2642-fe0f": [
        "41221b",
        "d7e0dc"
    ],
    "1f469-1f3fc-200d-1f52c": [
        "e3e0c8",
        "191a1b"
    ],
    "26d4": [
        "e5623b",
        "f1eae8"
    ],
    "1f50b": [
        "6ea257",
        "a3c09f"
    ],
    "1f538": [
        "e67502",
        "000000"
    ],
    "1f469-1f3fb-200d-1f9bd-200d-27a1-fe0f": [
        "b137b4",
        "383539"
    ],
    "1f9d1-200d-1f527": [
        "be8314",
        "4d6ab3"
    ],
    "1f469-1f3fe-200d-1f4bc": [
        "504545",
        "d8d9da"
    ],
    "1f466-1f3fb": [
        "4e4440",
        "f1ceae"
    ],
    "1f468-1f3fc-200d-1f3a8": [
        "d1c8b5",
        "666257"
    ],
    "26f9-1f3fd-200d-2642-fe0f": [
        "9f7359",
        "17569a"
    ],
    "1f469-1f3fb-200d-1f680": [
        "dccfc0",
        "4e4841"
    ],
    "1f6b4-1f3fd": [
        "3c3a38",
        "c3c4b8"
    ],
    "1f9b8-1f3fe": [
        "2a1b1b",
        "c52339"
    ],
    "1f1f3-1f1f1": [
        "9d2e37",
        "ebeaeb"
    ],
    "26f9-fe0f-200d-2640-fe0f": [
        "eeb63c",
        "9b2f1a"
    ],
    "1f469-1f3fb-200d-1f33e": [
        "765115",
        "d8c5b3"
    ],
    "1f934-1f3fd": [
        "8dcba3",
        "67462d"
    ],
    "1f9d9-200d-2642-fe0f": [
        "6d653e",
        "3c3126"
    ],
    "1f447-1f3fc": [
        "c5885e",
        "dfb892"
    ],
    "1f9ce-1f3ff-200d-2640-fe0f-200d-27a1-fe0f": [
        "342a2c",
        "9f30a3"
    ],
    "1f469-1f3fb-200d-1f3eb": [
        "e0bea2",
        "40453e"
    ],
    "1f468-1f3fc-200d-2708-fe0f": [
        "f5f3eb",
        "252322"
    ],
    "1f9cf-1f3ff-200d-2642-fe0f": [
        "261b16",
        "7c7a77"
    ],
    "1f9e2": [
        "5a9efb",
        "000000"
    ],
    "1f93c": [
        "79736b",
        "ba721e"
    ],
    "1f9d1-1f3fc-200d-2696-fe0f": [
        "bf8b4f",
        "3f352c"
    ],
    "1f9d6": [
        "deedee",
        "563d19"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb": [
        "dfab87",
        "c1302b"
    ],
    "1f474-1f3fe": [
        "bdbcba",
        "905b38"
    ],
    "1f487-1f3fe-200d-2642-fe0f": [
        "c5c5c4",
        "754f39"
    ],
    "1f9ed": [
        "717883",
        "eaeaea"
    ],
    "1f1fb-1f1f3": [
        "b42130",
        "620e15"
    ],
    "1faf7-1f3fe": [
        "522814",
        "95552d"
    ],
    "1f935": [
        "ca8d14",
        "2b2a27"
    ],
    "1f9b5-1f3ff": [
        "554137",
        "2e2019"
    ],
    "1f921": [
        "e23021",
        "dcb689"
    ],
    "1f468-200d-1f9bc-200d-27a1-fe0f": [
        "cb3341",
        "555871"
    ],
    "1f93e-1f3ff": [
        "2e221c",
        "8e8e8c"
    ],
    "1f9b5-1f3fd": [
        "bc8b66",
        "754b36"
    ],
    "1f9d1-1f3fb-200d-1f9af": [
        "d2c9c3",
        "323151"
    ],
    "1f937": [
        "e2ab22",
        "8f8e8d"
    ],
    "1f9d1-1f3fc-200d-1f393": [
        "c0915b",
        "2a2a2a"
    ],
    "1f9ef": [
        "957b7c",
        "eff9fa"
    ],
    "1f939-1f3fe": [
        "423329",
        "cbcac0"
    ],
    "1f9db": [
        "0f0f0f",
        "ecb325"
    ],
    "1f93e-1f3fd": [
        "563b2b",
        "8c8985"
    ],
    "1f3ca-1f3fc-200d-2640-fe0f": [
        "cde6ee",
        "512659"
    ],
    "2611-fe0f": [
        "393939",
        "d3d3d3"
    ],
    "1f923": [
        "4e96cb",
        "f8b71f"
    ],
    "1f44f-1f3fc": [
        "d5a57e",
        "474645"
    ],
    "1f93a": [
        "97908b",
        "e3dedd"
    ],
    "1f483-1f3fb": [
        "ad141f",
        "e6c8a8"
    ],
    "1f9e0": [
        "f7b7cc",
        "a34b61"
    ],
    "1f468-1f3fc-200d-1f9af-200d-27a1-fe0f": [
        "c93d48",
        "474e79"
    ],
    "1f9d4": [
        "c28613",
        "f7e0a7"
    ],
    "1f469-1f3ff-200d-1f393": [
        "4a4340",
        "16110f"
    ],
    "1f9da-1f3fb": [
        "8bbf91",
        "e0ad84"
    ],
    "1f92e": [
        "c17b23",
        "65bf0f"
    ],
    "1f469-1f3fb-200d-1f4bb": [
        "3f3a3c",
        "898888"
    ],
    "1f64c-1f3fe": [
        "744329",
        "99623b"
    ],
    "1f647-1f3fd-200d-2640-fe0f": [
        "86593b",
        "7f348e"
    ],
    "1f1ea-1f1fa": [
        "11367d",
        "0d234d"
    ],
    "23f1-fe0f": [
        "b1b5ba",
        "eeeff0"
    ],
    "1f90f-1f3fb": [
        "f0c8a4",
        "000000"
    ],
    "1f469-200d-2695-fe0f": [
        "f6c332",
        "b4a8b5"
    ],
    "2122-fe0f": [
        "000000",
        "464646"
    ],
    "1f934-1f3ff": [
        "8fc09d",
        "291e19"
    ],
    "1f1ea-1f1f7": [
        "2e993e",
        "d32a40"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe": [
        "885639",
        "4181c3"
    ],
    "1f9d1-200d-1f52c": [
        "e6e3dd",
        "848736"
    ],
    "1f6b4-1f3ff": [
        "373330",
        "d3d3d2"
    ],
    "1f468-200d-1f37c": [
        "d39819",
        "623b67"
    ],
    "1f39b-fe0f": [
        "7c8186",
        "bfc4c6"
    ],
    "1f1fa-1f1ec": [
        "b6aeac",
        "69301b"
    ],
    "1f6b6-1f3ff-200d-2640-fe0f-200d-27a1-fe0f": [
        "b34cb6",
        "453a3b"
    ],
    "1f491-1f3fe": [
        "8e6145",
        "c4adbb"
    ],
    "1f3cb-1f3fc-200d-2642-fe0f": [
        "3f4f61",
        "c99973"
    ],
    "1f1f0-1f1ea": [
        "6a6a5f",
        "d6c4c3"
    ],
    "1f51d": [
        "5f5f5f",
        "858585"
    ],
    "1f1eb-1f1ee": [
        "a6a9ac",
        "294c7b"
    ],
    "1f9d1-1f3ff-200d-1f527": [
        "282221",
        "3a64cb"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe": [
        "9a1613",
        "dfb290"
    ],
    "1f469-1f3fc-200d-1f527": [
        "e0ce9f",
        "3d4e8c"
    ],
    "270b-1f3fe": [
        "6b3d24",
        "9b643d"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "d7b484",
        "492f21"
    ],
    "1f512": [
        "625e52",
        "c2c29a"
    ],
    "1f91d-1f3fe": [
        "6f3f25",
        "000000"
    ],
    "1f506": [
        "f8b51f",
        "f68202"
    ],
    "1f9dd-1f3fc-200d-2640-fe0f": [
        "b29366",
        "d6c489"
    ],
    "1f9d1-1f3fd-200d-1f384": [
        "bfbcbb",
        "713a2c"
    ],
    "1f918-1f3fd": [
        "a16a52",
        "482d1c"
    ],
    "1f469-200d-1f9b1": [
        "d5af5b",
        "d69a17"
    ],
    "1f486-1f3fc-200d-2642-fe0f": [
        "dbba8a",
        "3582c8"
    ],
    "1f499": [
        "0054e9",
        "4a92f9"
    ],
    "2935-fe0f": [
        "65829d",
        "fdfdfd"
    ],
    "1f6b6-1f3fb-200d-2642-fe0f-200d-27a1-fe0f": [
        "d63152",
        "414c88"
    ],
    "1f64e-1f3fb": [
        "211e1e",
        "bb9d89"
    ],
    "2796": [
        "000000",
        "464646"
    ],
    "1f47c-1f3fb": [
        "ebcdac",
        "746b61"
    ],
    "2934-fe0f": [
        "66839e",
        "fbfcfc"
    ],
    "1f441-fe0f": [
        "504545",
        "9e9295"
    ],
    "1f485-1f3fe": [
        "63393d",
        "e589d2"
    ],
    "1f30f": [
        "a7ac4a",
        "dff19f"
    ],
    "1f3c3-1f3fe-200d-2640-fe0f-200d-27a1-fe0f": [
        "754a33",
        "e9e3df"
    ],
    "1f1e6-1f1fd": [
        "0e4881",
        "a06741"
    ],
    "1f47d": [
        "cee1e2",
        "1d292a"
    ],
    "1f9d1-1f3ff-200d-1f3ed": [
        "181515",
        "bac7d6"
    ],
    "1f31b": [
        "d7a023",
        "f1d058"
    ],
    "1f4a5": [
        "f07648",
        "883023"
    ],
    "1f469-1f3fe-200d-2708-fe0f": [
        "6e523d",
        "c6c1a9"
    ],
    "1f300": [
        "0109d9",
        "003ee0"
    ],
    "1f469-1f3fc-200d-1f3ed": [
        "58596a",
        "b08a51"
    ],
    "1f1f8-1f1f7": [
        "bc263e",
        "0c4520"
    ],
    "1f6c0-1f3ff": [
        "bbc1b5",
        "e5e9e2"
    ],
    "1f3fa": [
        "d3b19a",
        "d87433"
    ],
    "1f466": [
        "ecb11c",
        "271c09"
    ],
    "1f9ce-1f3ff-200d-27a1-fe0f": [
        "403532",
        "c8c6c5"
    ],
    "1f1e6-1f1f2": [
        "da1819",
        "17159b"
    ],
    "1f472": [
        "994b38",
        "c18004"
    ],
    "2755": [
        "000000",
        "e6e6e6"
    ],
    "1f314": [
        "f6e8ae",
        "2f3a49"
    ],
    "1f4b9": [
        "00900c",
        "f5f9f5"
    ],
    "1f4ac": [
        "a7a7a7",
        "f9f9f9"
    ],
    "1f9d1-1f3fe-200d-1f3a8": [
        "43362d",
        "bdb49c"
    ],
    "270d-1f3fb": [
        "d99a73",
        "120a08"
    ],
    "1fabd": [
        "84a5b0",
        "ebf0f2"
    ],
    "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe": [
        "114c83",
        "82533d"
    ],
    "1f64e-200d-2640-fe0f": [
        "f8e2a1",
        "822f90"
    ],
    "1f91b-1f3fb": [
        "f8d9b8",
        "000000"
    ],
    "1f9d1-1f3ff-200d-1f692": [
        "997d6b",
        "523c34"
    ],
    "1fa79": [
        "bcbcbc",
        "e2e2e2"
    ],
    "1fab2": [
        "031a00",
        "3e7501"
    ],
    "1f469-1f3fc-200d-1f692": [
        "a4836c",
        "cabcae"
    ],
    "1f549-fe0f": [
        "9337af",
        "f9f7f9"
    ],
    "1f1e8-1f1ec": [
        "c03e38",
        "2c9357"
    ],
    "1f468-1f3ff-200d-1f4bc": [
        "413632",
        "b2cde3"
    ],
    "1f64e-1f3ff-200d-2640-fe0f": [
        "594e48",
        "a65aa6"
    ],
    "1fa86": [
        "c68086",
        "c23d52"
    ],
    "1f926-1f3fd-200d-2640-fe0f": [
        "bd916f",
        "49261c"
    ],
    "1f93d-1f3fc-200d-2642-fe0f": [
        "d1a178",
        "f1f4f2"
    ],
    "1f9d1-1f3fc-200d-1f9af-200d-27a1-fe0f": [
        "c2bdbb",
        "272951"
    ],
    "1f6a7": [
        "e8b32e",
        "746932"
    ],
    "1fa92": [
        "282c2d",
        "c0cbd4"
    ],
    "1f5ef-fe0f": [
        "868788",
        "f5f6f7"
    ],
    "1f46e-1f3fe-200d-2642-fe0f": [
        "c7c398",
        "482d21"
    ],
    "1f477-1f3fb-200d-2640-fe0f": [
        "e7bc44",
        "37312f"
    ],
    "1faf1-1f3fd-200d-1faf2-1f3ff": [
        "4e3930",
        "b68461"
    ],
    "1f468-200d-1f9bc": [
        "464249",
        "9c9899"
    ],
    "1f6aa": [
        "a6a8ad",
        "955a39"
    ],
    "1fa9d": [
        "7a6228",
        "513c15"
    ],
    "1fa9e": [
        "d8a641",
        "d0e5f8"
    ],
    "1f9d7-1f3fc-200d-2642-fe0f": [
        "d28758",
        "676561"
    ],
    "1f468-1f3fe-200d-2695-fe0f": [
        "8e5e3f",
        "c8caca"
    ],
    "1f6a6": [
        "aba9a9",
        "333229"
    ],
    "1f9cf-1f3fb-200d-2640-fe0f": [
        "d39c78",
        "692078"
    ],
    "1fa93": [
        "634b34",
        "c61f18"
    ],
    "1fa87": [
        "1b0b05",
        "b69e55"
    ],
    "1f468-1f3fb-200d-1f393": [
        "a8a19d",
        "353333"
    ],
    "261d-fe0f": [
        "da900b",
        "832805"
    ],
    "1f468-1f3fc-200d-1f9af": [
        "ad1d37",
        "4e5682"
    ],
    "1f468-1f3ff-200d-1f4bb": [
        "87898b",
        "201a17"
    ],
    "1f1e8-1f1eb": [
        "d9d9d9",
        "4e6052"
    ],
    "1f9b9-1f3fc-200d-2642-fe0f": [
        "a37442",
        "39243b"
    ],
    "1f1ed-1f1f9": [
        "1a3191",
        "c1213f"
    ],
    "1fa78": [
        "650504",
        "c40404"
    ],
    "1f9dc-1f3fc-200d-2642-fe0f": [
        "e0b66c",
        "636c99"
    ],
    "1f57a-1f3ff": [
        "5f296b",
        "1a181b"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff": [
        "2e2624",
        "7f4c73"
    ],
    "1fab3": [
        "d4937d",
        "8e4a4a"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff": [
        "745941",
        "d4b279"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff": [
        "4a3227",
        "cd409b"
    ],
    "1f91b-1f3fc": [
        "e1bd97",
        "000000"
    ],
    "270d-1f3fc": [
        "bd8159",
        "0e0907"
    ],
    "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd": [
        "104c85",
        "aa7d61"
    ],
    "1f9d1-1f3fb-200d-1f9bc-200d-27a1-fe0f": [
        "e6d3c0",
        "505774"
    ],
    "2754": [
        "f2f1f1",
        "020202"
    ],
    "1f473": [
        "d4d2cc",
        "f1b923"
    ],
    "1f4ab": [
        "f8f637",
        "f7e591"
    ],
    "1f4b8": [
        "acaa9b",
        "ff0000"
    ],
    "1f315": [
        "e7c870",
        "e3ad1e"
    ],
    "1f397-fe0f": [
        "fade51",
        "daa30f"
    ],
    "1f301": [
        "e0e3e5",
        "577274"
    ],
    "1f467": [
        "fdce3e",
        "a86e0f"
    ],
    "1f396-fe0f": [
        "ce3334",
        "edc94a"
    ],
    "1f47e": [
        "2d2527",
        "5a4555"
    ],
    "1f9d9-1f3fe-200d-2640-fe0f": [
        "423526",
        "b3be84"
    ],
    "1f4a4": [
        "001d4b",
        "003483"
    ],
    "1f31c": [
        "fcf2a0",
        "e2b53a"
    ],
    "1f595-1f3ff": [
        "36261f",
        "584338"
    ],
    "1f485-1f3fd": [
        "6e4448",
        "b88463"
    ],
    "1f64d-1f3fd-200d-2642-fe0f": [
        "b4845c",
        "4473b1"
    ],
    "1f46a": [
        "64819b",
        "fdfdfd"
    ],
    "1f47c-1f3fc": [
        "dab076",
        "77634f"
    ],
    "1f9d4-1f3fc-200d-2640-fe0f": [
        "e3d193",
        "9c723d"
    ],
    "2797": [
        "000000",
        "464646"
    ],
    "1f9d6-1f3ff": [
        "deedef",
        "5f5147"
    ],
    "1f64e-1f3fc": [
        "b68754",
        "d9d6c3"
    ],
    "1f1f5-1f1fc": [
        "0e9ab8",
        "f6da35"
    ],
    "1f9cd-200d-2640-fe0f": [
        "f5be2d",
        "3985ba"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "36251a",
        "d84297"
    ],
    "1f6a3-200d-2640-fe0f": [
        "daa22e",
        "000000"
    ],
    "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff": [
        "654431",
        "b09a8a"
    ],
    "1f498": [
        "e02d92",
        "4d76a6"
    ],
    "1f9ce-1f3fb-200d-2642-fe0f": [
        "4a5277",
        "9b152a"
    ],
    "1f507": [
        "bfc1c5",
        "636467"
    ],
    "1f91d-1f3fd": [
        "aa7458",
        "010000"
    ],
    "1f469-200d-1f9b0": [
        "e88c11",
        "fddda2"
    ],
    "1f5ff": [
        "6e6e69",
        "e6e6e4"
    ],
    "1f918-1f3fe": [
        "78462a",
        "9b653d"
    ],
    "2666-fe0f": [
        "bb0000",
        "ed3535"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd": [
        "372a2c",
        "a6775b"
    ],
    "0038-fe0f-20e3": [
        "66839e",
        "fbfbfc"
    ],
    "1f64b-1f3ff-200d-2642-fe0f": [
        "b6aa8c",
        "2f2624"
    ],
    "1f513": [
        "535048",
        "c9c17f"
    ],
    "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "493126",
        "a86f4c"
    ],
    "270b-1f3fd": [
        "875741",
        "c0906a"
    ],
    "1f937-1f3fc-200d-2640-fe0f": [
        "c99841",
        "52195e"
    ],
    "26d3-fe0f": [
        "a6abaf",
        "e9ebeb"
    ],
    "1f50a": [
        "93e9f5",
        "54595d"
    ],
    "1f51e": [
        "dc421d",
        "ebb88d"
    ],
    "1f469-1f3fe-200d-1f3eb": [
        "cba687",
        "4d4639"
    ],
    "1f491-1f3fd": [
        "b28868",
        "5d3922"
    ],
    "1f646-1f3ff-200d-2642-fe0f": [
        "4f8ccf",
        "265892"
    ],
    "1f6b5-1f3fc-200d-2640-fe0f": [
        "726f68",
        "dbcbb0"
    ],
    "1f1fa-1f1f8": [
        "386ba1",
        "771620"
    ],
    "1f469-1f3fe-200d-1f33e": [
        "7e5520",
        "9aa5bd"
    ],
    "1f935-200d-2642-fe0f": [
        "d39512",
        "2c2b28"
    ],
    "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": [
        "fbc732",
        "dd459a"
    ],
    "1f470-1f3fb-200d-2642-fe0f": [
        "d2d2d1",
        "1a1614"
    ],
    "1f482-1f3fc-200d-2642-fe0f": [
        "4b4946",
        "af8969"
    ],
    "1f6b6-1f3fc-200d-2642-fe0f": [
        "c11242",
        "09071e"
    ],
    "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd": [
        "b88466",
        "573926"
    ],
    "1f645-1f3ff-200d-2640-fe0f": [
        "281f1f",
        "f5f4f4"
    ],
    "1f939-1f3fe-200d-2642-fe0f": [
        "4a382e",
        "c7c9bf"
    ],
    "1f90f-1f3fc": [
        "d9ad86",
        "000000"
    ],
    "1f469-1f3fe-200d-1f680": [
        "d2cdc5",
        "787879"
    ],
    "1f9b8-1f3ff": [
        "1b1515",
        "c22338"
    ],
    "1f575-1f3fb-200d-2642-fe0f": [
        "5e5850",
        "e3d3c2"
    ],
    "1f468-1f3fb-200d-1f9bc-200d-27a1-fe0f": [
        "cf2e41",
        "292125"
    ],
    "1f473-1f3fb-200d-2640-fe0f": [
        "a9a7a3",
        "a06641"
    ],
    "1f481-1f3fc-200d-2640-fe0f": [
        "e2c997",
        "611d71"
    ],
    "1f469-1f3fb-200d-1f4bc": [
        "9c7b69",
        "e9d0b9"
    ],
    "1f468-1f3fd-200d-1f3a8": [
        "cccabf",
        "ab8d6f"
    ],
    "1f64c-1f3fd": [
        "936149",
        "bc8d69"
    ],
    "1f576-fe0f": [
        "1b1a19",
        "505351"
    ],
    "1f9d5": [
        "704518",
        "46327a"
    ],
    "1f474-1f3ff": [
        "b9b8b7",
        "59453a"
    ],
    "1f92d": [
        "984506",
        "fbcf3a"
    ],
    "1f9da-1f3fc": [
        "9fe5ce",
        "cb9466"
    ],
    "1f938-200d-2642-fe0f": [
        "2d2c2f",
        "db9f1b"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc": [
        "eaca9f",
        "3a3232"
    ],
    "1f3c3-200d-27a1-fe0f": [
        "bc8126",
        "b5b3b3"
    ],
    "1f44f-1f3fb": [
        "f8dab9",
        "5c5c5b"
    ],
    "1f577-fe0f": [
        "767374",
        "2c2a2c"
    ],
    "1f469-1f3fd-200d-1f52c": [
        "dcdbda",
        "654126"
    ],
    "1f9e1": [
        "d45b00",
        "ffe7c0"
    ],
    "1f483-1f3fc": [
        "b10d1d",
        "dec095"
    ],
    "1f46e-200d-2642-fe0f": [
        "d9d2a9",
        "2d639d"
    ],
    "1f9dc": [
        "e1b338",
        "606a94"
    ],
    "1f939-1f3fd": [
        "434032",
        "a17e61"
    ],
    "1f922": [
        "739800",
        "d7e586"
    ],
    "1f93e-1f3fe": [
        "533322",
        "aeadaa"
    ],
    "1f5e3-fe0f": [
        "f5fbfc",
        "233a5f"
    ],
    "1f936": [
        "9a5341",
        "e6e0dc"
    ],
    "1f9b5-1f3fe": [
        "97603a",
        "59311d"
    ],
    "1faf7-1f3ff": [
        "2b1b14",
        "573d34"
    ],
    "1f6cd-fe0f": [
        "f1d9d9",
        "d7a22a"
    ],
    "1f9c6": [
        "483118",
        "e5e1d2"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb": [
        "71513c",
        "f7c2c0"
    ],
    "1f468-1f3fb-200d-1f52c": [
        "e5e4e3",
        "332d2b"
    ],
    "1f9b2": [
        "eab220",
        "000000"
    ],
    "1f933-1f3fd": [
        "aa795c",
        "785d51"
    ],
    "1f1ef-1f1f5": [
        "b3b0b1",
        "000000"
    ],
    "1f6ce-fe0f": [
        "f7f7f9",
        "966f38"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "5e4639",
        "fd91d8"
    ],
    "1f94c": [
        "f96970",
        "383533"
    ],
    "1f979": [
        "904d0c",
        "f9e15b"
    ],
    "1f951": [
        "454136",
        "eae584"
    ],
    "1f9bd": [
        "313131",
        "000000"
    ],
    "1f9d7-1f3fb": [
        "caab95",
        "c10201"
    ],
    "1f945": [
        "c82827",
        "020000"
    ],
    "1f469-1f3fc-200d-2708-fe0f": [
        "d3ba8b",
        "1f1e1d"
    ],
    "1f9d1-1f3fd-200d-1f692": [
        "aa8668",
        "a62922"
    ],
    "1f645-1f3fe": [
        "935d35",
        "93908b"
    ],
    "1f99d": [
        "000000",
        "756957"
    ],
    "1f468-200d-1f468-200d-1f467": [
        "64819b",
        "fdfdfd"
    ],
    "1f468-1f3fc-200d-1f680": [
        "dab689",
        "959495"
    ],
    "1f473-1f3fe": [
        "a5a4a1",
        "5c3d2d"
    ],
    "1f004": [
        "d9d2c6",
        "982b2c"
    ],
    "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe": [
        "114c83",
        "7c563d"
    ],
    "1f992": [
        "7c4a11",
        "d19846"
    ],
    "1f486-1f3fe-200d-2642-fe0f": [
        "543526",
        "558dc0"
    ],
    "1f1f9-1f1f2": [
        "23765f",
        "0f4738"
    ],
    "1f468-1f3fd-200d-1f4bc": [
        "754a2f",
        "bdd6e9"
    ],
    "1faf0-1f3fe": [
        "7f4424",
        "421f0f"
    ],
    "1f469-1f3fb-200d-1f3a8": [
        "07070b",
        "e9d3b7"
    ],
    "1f9d1-1f3fd-200d-1f9bc-200d-27a1-fe0f": [
        "dfdede",
        "50414a"
    ],
    "1f986": [
        "b9b2a9",
        "291715"
    ],
    "1f1e7-1f1f7": [
        "0a5933",
        "ebc741"
    ],
    "1f9d1-1f3fd-200d-1f3ed": [
        "1b191b",
        "b38768"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb": [
        "f5c2c4",
        "342219"
    ],
    "1f468-1f3fc-200d-1f3eb": [
        "d9c092",
        "915d3f"
    ],
    "1f9cd-1f3ff-200d-2640-fe0f": [
        "3f312b",
        "2b75a7"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "393230",
        "d6b26e"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f2c5b5",
        "6e4b62"
    ],
    "1f93d-1f3fe-200d-2642-fe0f": [
        "8f6244",
        "eef1f0"
    ],
    "1f926-1f3fb-200d-2640-fe0f": [
        "524a47",
        "eeccab"
    ],
    "1f469-200d-2764-fe0f-200d-1f468": [
        "efb726",
        "ce439d"
    ],
    "1f468-1f3fc-200d-1f33e": [
        "724f18",
        "c88b44"
    ],
    "1f1e9-1f1ef": [
        "75a3c5",
        "0b4a12"
    ],
    "1f477-1f3fd-200d-2640-fe0f": [
        "e3b43f",
        "77a8d7"
    ],
    "1f486-200d-2640-fe0f": [
        "fbcf4c",
        "6a2978"
    ],
    "1f93d-200d-2642-fe0f": [
        "eebd46",
        "f1f5f4"
    ],
    "1f46e-1f3fc-200d-2642-fe0f": [
        "e7e2c8",
        "306aa5"
    ],
    "2653": [
        "9437b0",
        "fbfafb"
    ],
    "1f560": [
        "adb1b4",
        "f8f9f9"
    ],
    "1f43b-200d-2744-fe0f": [
        "b9bbbf",
        "43474a"
    ],
    "26c4": [
        "5f5450",
        "b8c8d1"
    ],
    "264a": [
        "762d8c",
        "d7ace0"
    ],
    "262f-fe0f": [
        "9136ad",
        "fbf9fb"
    ],
    "1faf6-1f3fb": [
        "cb7347",
        "040000"
    ],
    "1f9d1-1f3fd-200d-1f527": [
        "68442e",
        "c8c2c4"
    ],
    "1f471-1f3ff-200d-2640-fe0f": [
        "9e7e3b",
        "34241c"
    ],
    "1f9d1-1f3ff-200d-1f384": [
        "bbb7b6",
        "57332a"
    ],
    "1f647-1f3fb-200d-2640-fe0f": [
        "4c4143",
        "e4be9f"
    ],
    "1f9da-200d-2640-fe0f": [
        "9ee1ca",
        "bc9237"
    ],
    "1f475-1f3fb": [
        "a9a4a0",
        "67615c"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe": [
        "9c1613",
        "7a4d35"
    ],
    "1f4fa": [
        "725b50",
        "d8e9e7"
    ],
    "1f366": [
        "b48e57",
        "dbcaa7"
    ],
    "23ef-fe0f": [
        "65839d",
        "fdfdfd"
    ],
    "1f446-1f3fd": [
        "9f6850",
        "623e2b"
    ],
    "1f400": [
        "695e58",
        "000000"
    ],
    "1f414": [
        "e1d4c4",
        "d54d48"
    ],
    "1f3b9": [
        "1e1f20",
        "e6e6e6"
    ],
    "1f3ac": [
        "757576",
        "2d2c2c"
    ],
    "1f372": [
        "eeefee",
        "7c7c72"
    ],
    "1f9d1-1f3fe": [
        "3b271e",
        "95603a"
    ],
    "1f4f7": [
        "d3d4d3",
        "39393a"
    ],
    "1f336-fe0f": [
        "5b8b26",
        "7b1c17"
    ],
    "1f9b9-1f3fb": [
        "110d0e",
        "e9c4a3"
    ],
    "1f1f2-1f1f6": [
        "020202",
        "5c2827"
    ],
    "1f40f": [
        "aaa89f",
        "51493c"
    ],
    "1f428": [
        "bcaba5",
        "030303"
    ],
    "1f41b": [
        "e4e9d1",
        "68622e"
    ],
    "1f3a5": [
        "868a8e",
        "3a3a3d"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "3d302b",
        "cb8f69"
    ],
    "1f935-1f3fc": [
        "ba8a55",
        "222120"
    ],
    "26c8-fe0f": [
        "b4c7d0",
        "1f9ad7"
    ],
    "1f3ca-1f3fe-200d-2640-fe0f": [
        "cce6f0",
        "522e31"
    ],
    "1fad4": [
        "ce9a37",
        "000000"
    ],
    "1fae0": [
        "ea8e0e",
        "fef49d"
    ],
    "1f9dd-1f3fe-200d-2640-fe0f": [
        "7d5732",
        "eae0a9"
    ],
    "1f468-1f3fd-200d-1f9bc-200d-27a1-fe0f": [
        "ce2e42",
        "603e3e"
    ],
    "1f6b5-1f3fc": [
        "7f7a71",
        "ddd5c6"
    ],
    "1f3cb-1f3fe-200d-2642-fe0f": [
        "45515f",
        "1c1817"
    ],
    "1fadb": [
        "466231",
        "5f8344"
    ],
    "1f9d1-1f3fe-200d-1f4bb": [
        "422e26",
        "8e9091"
    ],
    "1f467-1f3fe": [
        "382921",
        "8f5a37"
    ],
    "1f468-200d-1f469-200d-1f467-200d-1f466": [
        "4f677b",
        "c0cdd8"
    ],
    "1f602": [
        "b66f1d",
        "efefb1"
    ],
    "1f6fc": [
        "53a2a4",
        "755e5c"
    ],
    "1f616": [
        "b86e1f",
        "fdf48c"
    ],
    "2714-fe0f": [
        "868686",
        "474747"
    ],
    "1f60d": [
        "d07917",
        "fef19e"
    ],
    "0032-fe0f-20e3": [
        "65839e",
        "fbfbfb"
    ],
    "1f469-1f3fd-200d-1f393": [
        "796354",
        "37302b"
    ],
    "1f469-1f3fe-200d-1f9af": [
        "bf38c1",
        "464877"
    ],
    "1f6f5": [
        "8a7c73",
        "2d2722"
    ],
    "1f1ec-1f1e6": [
        "1b9261",
        "dabb27"
    ],
    "1f61a": [
        "ca6918",
        "fdd53b"
    ],
    "1f1ec-1f1e7": [
        "29407a",
        "cfc9cd"
    ],
    "1f469-1f3ff-200d-1f52c": [
        "dbdcdb",
        "332d2c"
    ],
    "1f3c3-1f3fb-200d-2642-fe0f-200d-27a1-fe0f": [
        "e6ba98",
        "bc2f62"
    ],
    "1f60e": [
        "c6781b",
        "766875"
    ],
    "1f6f4": [
        "757b80",
        "1d2329"
    ],
    "1f482-1f3fe-200d-2642-fe0f": [
        "41362f",
        "9e8568"
    ],
    "1f470-1f3fd-200d-2642-fe0f": [
        "c6c5c4",
        "633f28"
    ],
    "1f617": [
        "c87819",
        "fcf391"
    ],
    "1f1ec-1f1ea": [
        "b79fa2",
        "716163"
    ],
    "1f603": [
        "b06c22",
        "fdd93d"
    ],
    "1f468-200d-1f469-200d-1f467-200d-1f467": [
        "4f677b",
        "c0cdd8"
    ],
    "1f468-1f3fe-200d-1f9af-200d-27a1-fe0f": [
        "c82b47",
        "d7d3d2"
    ],
    "1f9d1-1f3fc-200d-1f52c": [
        "e0ded8",
        "b7895e"
    ],
    "1f6fb": [
        "4f8a92",
        "1e1d1d"
    ],
    "1f1f1-1f1ee": [
        "183877",
        "69111b"
    ],
    "1f6b5-1f3fe-200d-2640-fe0f": [
        "6a6157",
        "412222"
    ],
    "1f3f5-fe0f": [
        "f1d456",
        "ca6e28"
    ],
    "1f937-1f3fe-200d-2640-fe0f": [
        "7a553b",
        "9a43ab"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff": [
        "4f382d",
        "d94196"
    ],
    "1f467-1f3fd": [
        "643c1f",
        "b58361"
    ],
    "1f9d1-1f3fe-200d-1f4bc": [
        "3b2a22",
        "aaa8a2"
    ],
    "1f6b6-1f3fe-200d-2640-fe0f-200d-27a1-fe0f": [
        "b74ab8",
        "815842"
    ],
    "1fae1": [
        "fef8b1",
        "da860d"
    ],
    "1f468-1f3ff-200d-1f3a8": [
        "bbb4a2",
        "362a23"
    ],
    "1f6b5-1f3fb": [
        "7c7870",
        "ded1bf"
    ],
    "1f468-1f3fe-200d-1f692": [
        "a27f6d",
        "6e4635"
    ],
    "1f9d1-1f3fb-200d-1f680": [
        "ded1c0",
        "a6a098"
    ],
    "1fad5": [
        "030202",
        "b82123"
    ],
    "1f3a4": [
        "616262",
        "1d1e1d"
    ],
    "1f41c": [
        "b19b94",
        "2c2321"
    ],
    "1f429": [
        "4b4b4b",
        "a6a6a6"
    ],
    "1f9d1-1f3fb-200d-1f33e": [
        "7c5e1b",
        "e6ccb2"
    ],
    "1f37e": [
        "c0bca9",
        "92906c"
    ],
    "1f935-1f3fb": [
        "272424",
        "f1d7bd"
    ],
    "1f36a": [
        "daa65f",
        "885729"
    ],
    "1f4f6": [
        "64819c",
        "fafbfb"
    ],
    "1f1f2-1f1f7": [
        "169653",
        "47050a"
    ],
    "1f9b9-1f3fc": [
        "af884e",
        "1f151d"
    ],
    "1f3ab": [
        "c3bc61",
        "010100"
    ],
    "1f3b8": [
        "737071",
        "a44b42"
    ],
    "1f415": [
        "7b583c",
        "a1764e"
    ],
    "1f9d1-1f3fd": [
        "5e391f",
        "bd8f69"
    ],
    "1f9d1-1f3fb-200d-1f3eb": [
        "d2bba7",
        "2e2c28"
    ],
    "1f373": [
        "7a7673",
        "d3d5c3"
    ],
    "1f446-1f3fe": [
        "7e4b2d",
        "512d1b"
    ],
    "1f367": [
        "2b80ca",
        "d2c5c1"
    ],
    "3299-fe0f": [
        "d10801",
        "f9f1f0"
    ],
    "1f468-1f3fe-200d-1f3ed": [
        "765e54",
        "5771ba"
    ],
    "1f401": [
        "b2a6a6",
        "000000"
    ],
    "1f1f2-1f1fa": [
        "2f3268",
        "dcbe3d"
    ],
    "1f9d1-200d-1f393": [
        "b47a1a",
        "31302f"
    ],
    "1f481-1f3fe-200d-2640-fe0f": [
        "875b3f",
        "a452a3"
    ],
    "1f473-1f3fd-200d-2640-fe0f": [
        "d8d7d7",
        "84583e"
    ],
    "1f475-1f3fc": [
        "dcdcdb",
        "5a4f48"
    ],
    "1f482-1f3ff": [
        "4a4132",
        "dad1cf"
    ],
    "2763-fe0f": [
        "b80d03",
        "fc4638"
    ],
    "1f54a-fe0f": [
        "abaca1",
        "719755"
    ],
    "1f6b6-1f3fe-200d-2642-fe0f": [
        "be143f",
        "424f8b"
    ],
    "1faf6-1f3fc": [
        "b86637",
        "040000"
    ],
    "1f939-1f3fc-200d-2642-fe0f": [
        "363430",
        "d6bda0"
    ],
    "1f575-1f3fd-200d-2642-fe0f": [
        "634d40",
        "b7b3a6"
    ],
    "0036-fe0f-20e3": [
        "66839e",
        "fbfcfc"
    ],
    "26c5": [
        "bacad0",
        "dfa220"
    ],
    "1f1ff-1f1e6": [
        "c1623d",
        "0f224b"
    ],
    "1f561": [
        "afb2b6",
        "f8f9f8"
    ],
    "2623-fe0f": [
        "e97a00",
        "f7f3ed"
    ],
    "1f9b9-1f3fe-200d-2642-fe0f": [
        "31202b",
        "612898"
    ],
    "1f9dc-1f3fe-200d-2642-fe0f": [
        "eecd4f",
        "616d96"
    ],
    "2622-fe0f": [
        "e97a00",
        "fbfbfa"
    ],
    "2652": [
        "9136ad",
        "f7f4f8"
    ],
    "1f468-1f3fe-200d-1f527": [
        "654533",
        "adaba5"
    ],
    "1f9cf-1f3fd-200d-2640-fe0f": [
        "956f58",
        "2b1515"
    ],
    "1f469-200d-2764-fe0f-200d-1f469": [
        "f5bd2b",
        "c3419c"
    ],
    "1f9b8-200d-2640-fe0f": [
        "aa6e15",
        "4b2858"
    ],
    "1f1f7-1f1f8": [
        "bf3739",
        "b48f89"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc": [
        "be895e",
        "352f2f"
    ],
    "1f91c-1f3ff": [
        "45312b",
        "1f140e"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc": [
        "b78962",
        "694329"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "ceaa63",
        "fd92d8"
    ],
    "1f9d7-1f3fe-200d-2642-fe0f": [
        "e77638",
        "523424"
    ],
    "1f468-1f3fc-200d-2695-fe0f": [
        "d2d2ca",
        "b98155"
    ],
    "1f9d6-200d-2640-fe0f": [
        "d1e2e3",
        "e8bd48"
    ],
    "1f1e7-1f1f6": [
        "152d62",
        "c7c6c5"
    ],
    "1f987": [
        "ad9f9b",
        "7e6b5e"
    ],
    "1f1f9-1f1f3": [
        "770c14",
        "fceef0"
    ],
    "1f993": [
        "2c2827",
        "98938b"
    ],
    "1f9ce-1f3fd-200d-2642-fe0f": [
        "563d37",
        "9d1428"
    ],
    "1faf0-1f3fd": [
        "a9694d",
        "5e3423"
    ],
    "1f3c3-1f3ff-200d-2640-fe0f-200d-27a1-fe0f": [
        "423331",
        "e0e0dc"
    ],
    "1f468-1f3fd-200d-1f4bb": [
        "d9ccc5",
        "7b7e8d"
    ],
    "1f9d4-1f3fe-200d-2640-fe0f": [
        "5d473c",
        "1e1612"
    ],
    "1f473-1f3fd": [
        "b0aead",
        "80553a"
    ],
    "1f98a": [
        "c7560d",
        "705945"
    ],
    "1f468-200d-1f468-200d-1f466": [
        "64819b",
        "fdfdfd"
    ],
    "1f99e": [
        "9c1b0e",
        "b14941"
    ],
    "1f645-1f3fd": [
        "7c675a",
        "bd8f65"
    ],
    "1f9d7-1f3fc": [
        "bdac9c",
        "69635b"
    ],
    "1f9be": [
        "272727",
        "6b6b6b"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc": [
        "dfc1b0",
        "25211f"
    ],
    "1f9d9-1f3fc-200d-2640-fe0f": [
        "413426",
        "af935d"
    ],
    "1f944": [
        "afc2d2",
        "2c3743"
    ],
    "1f950": [
        "d28620",
        "eaac2d"
    ],
    "26f9-1f3ff-200d-2640-fe0f": [
        "48342c",
        "d5d6d4"
    ],
    "1f9d1-1f3fe-200d-1f9af-200d-27a1-fe0f": [
        "c3b8b6",
        "855538"
    ],
    "1f64d-1f3fb-200d-2642-fe0f": [
        "463e38",
        "d9af8b"
    ],
    "1f64d-1f3ff": [
        "211b19",
        "9f9e9d"
    ],
    "1f9ca": [
        "d2f1fa",
        "0c2c4f"
    ],
    "1f1ef-1f1f4": [
        "090a09",
        "dcdbdb"
    ],
    "1f933-1f3fe": [
        "805133",
        "959495"
    ],
    "1f9b3": [
        "e5cf9b",
        "000000"
    ],
    "1f978": [
        "5e3812",
        "f2b324"
    ],
    "1f94b": [
        "a8a6a4",
        "171716"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "2d231d",
        "f34daf"
    ],
    "1f95f": [
        "f5e0b4",
        "a9784e"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc": [
        "ecc2b3",
        "4f2f16"
    ],
    "1f9c7": [
        "ca8737",
        "fad16d"
    ],
    "1f9d1-200d-1f9bd-200d-27a1-fe0f": [
        "cccbca",
        "3f3a37"
    ],
    "1f9b1": [
        "eec348",
        "000000"
    ],
    "1faf1-1f3fe-200d-1faf2-1f3fc": [
        "d8aa83",
        "643821"
    ],
    "1f938-1f3fe-200d-2642-fe0f": [
        "4c2f1a",
        "a58566"
    ],
    "1f9c5": [
        "222112",
        "daa674"
    ],
    "1f95d": [
        "705535",
        "acbd4c"
    ],
    "1f1f4-1f1f2": [
        "c1afae",
        "275932"
    ],
    "1f39e-fe0f": [
        "a8927a",
        "342713"
    ],
    "1f9cc": [
        "979d88",
        "50422b"
    ],
    "1f64d-1f3fd": [
        "53321b",
        "a09f9e"
    ],
    "1f952": [
        "80ad5f",
        "2b6121"
    ],
    "1f98c": [
        "a5876c",
        "ebeae6"
    ],
    "1f469-1f3ff-200d-1f3ed": [
        "181617",
        "5c637f"
    ],
    "1f1e7-1f1fb": [
        "8e241f",
        "5f718e"
    ],
    "1f468-1f3fd-200d-1f33e": [
        "71611b",
        "b6c3b0"
    ],
    "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff": [
        "114d85",
        "7a5841"
    ],
    "1f473-1f3ff": [
        "bcbbbb",
        "261c16"
    ],
    "1f645-1f3ff": [
        "29201b",
        "93918d"
    ],
    "1f44a-1f3fb": [
        "dda782",
        "000000"
    ],
    "1f468-1f3fd-200d-1f3eb": [
        "d5bba4",
        "7c4c30"
    ],
    "1f985": [
        "53473f",
        "bdb4aa"
    ],
    "1f1e7-1f1f4": [
        "b52633",
        "11502e"
    ],
    "1f5b2-fe0f": [
        "15171b",
        "485675"
    ],
    "1f469-200d-2764-200d-1f48b-200d-1f468": [
        "fbcd33",
        "fdc6ca"
    ],
    "1f9d1-1f3fc-200d-1f3ed": [
        "19191c",
        "b58762"
    ],
    "1faf0-1f3ff": [
        "3c2822",
        "4b332c"
    ],
    "1f991": [
        "7f6f80",
        "ec6a4a"
    ],
    "1f935-1f3fc-200d-2642-fe0f": [
        "d8bf83",
        "232120"
    ],
    "1f1f9-1f1f1": [
        "b53833",
        "020202"
    ],
    "1f469-1f3ff-200d-1f692": [
        "977d69",
        "4d3b32"
    ],
    "1f91c-1f3fd": [
        "a26c53",
        "010000"
    ],
    "2693": [
        "333337",
        "a3a5a8"
    ],
    "1f468-1f3fc-200d-1f4bc": [
        "d8bf82",
        "b87f51"
    ],
    "1f469-1f3fe-200d-1f3a8": [
        "2d79cb",
        "302722"
    ],
    "1f62e-200d-1f4a8": [
        "d87710",
        "f9f3ba"
    ],
    "1f468-200d-1f467-200d-1f466": [
        "607c95",
        "fcfcfc"
    ],
    "1f469-200d-2708-fe0f": [
        "e1af2e",
        "211f1d"
    ],
    "1f977-1f3fb": [
        "010101",
        "434648"
    ],
    "1f468-1f3fd-200d-1f680": [
        "bbb7b2",
        "443b35"
    ],
    "1f9d1-1f3fc-200d-1f692": [
        "a9856a",
        "cbbfb2"
    ],
    "26be": [
        "e1e1de",
        "9d928e"
    ],
    "1f563": [
        "b0b3b7",
        "fafaf9"
    ],
    "1f9de-200d-2642-fe0f": [
        "259ecc",
        "25778b"
    ],
    "2650": [
        "9237ad",
        "fbfafb"
    ],
    "1f647-1f3ff-200d-2642-fe0f": [
        "595459",
        "0c0c18"
    ],
    "1f6b4-1f3fc-200d-2640-fe0f": [
        "4c4744",
        "a9293a"
    ],
    "1f239": [
        "ea2e1c",
        "fdfdfd"
    ],
    "264b": [
        "762c8b",
        "d7aee0"
    ],
    "1f6b5-200d-2640-fe0f": [
        "7d7972",
        "9b111b"
    ],
    "1f6a3-1f3fc-200d-2640-fe0f": [
        "d3b28d",
        "000000"
    ],
    "1f3c7-1f3fb": [
        "3b271c",
        "d6c2b4"
    ],
    "1f468-1f3fe-200d-1f52c": [
        "e4e4e4",
        "8cac61"
    ],
    "1f57a": [
        "582264",
        "e0b735"
    ],
    "1f471-1f3fb-200d-2642-fe0f": [
        "ca9d66",
        "f3d4b3"
    ],
    "1f938-1f3fc": [
        "1a1919",
        "cb996e"
    ],
    "1f9da-1f3fc-200d-2640-fe0f": [
        "9de3cc",
        "bf895e"
    ],
    "1f93d-1f3fb": [
        "ddb491",
        "857f79"
    ],
    "1f469-1f3fc-200d-1f393": [
        "dcc687",
        "363535"
    ],
    "1f469-1f3fb-200d-1f9af": [
        "bf38c0",
        "2e284d"
    ],
    "1f9d1-1f3ff-200d-1f393": [
        "201b1a",
        "6e6b68"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff": [
        "9a1613",
        "7a513b"
    ],
    "1f9d8-1f3fe-200d-2640-fe0f": [
        "261a16",
        "865332"
    ],
    "1f469-1f3fd-200d-1f9bd-200d-27a1-fe0f": [
        "ad38af",
        "3a3435"
    ],
    "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc": [
        "999695",
        "4f372d"
    ],
    "1f64e-1f3fd-200d-2642-fe0f": [
        "8e6448",
        "4472b1"
    ],
    "1f482-1f3fd": [
        "695439",
        "d9ccc6"
    ],
    "1f371": [
        "c62c13",
        "827356"
    ],
    "1f478-1f3fb": [
        "905d21",
        "37312f"
    ],
    "1f9d1-1f3ff": [
        "201a17",
        "372e2b"
    ],
    "1f926-1f3ff-200d-2642-fe0f": [
        "362d2b",
        "3f6ca2"
    ],
    "1f417": [
        "917766",
        "41342b"
    ],
    "1f9d1-1f3fb-200d-1f4bb": [
        "1e1b1c",
        "88898a"
    ],
    "1f1f2-1f1fc": [
        "1d1d19",
        "b42433"
    ],
    "1f1f2-1f1e9": [
        "af261b",
        "e8ce28"
    ],
    "1f403": [
        "433a3a",
        "a09a9a"
    ],
    "1f64b-1f3fc": [
        "d1a866",
        "989796"
    ],
    "1f4e8": [
        "ebebea",
        "226095"
    ],
    "1f4fb": [
        "99938b",
        "766649"
    ],
    "1f482-200d-2642-fe0f": [
        "4d3e2a",
        "d9af3a"
    ],
    "1f365": [
        "a2a6a2",
        "dad9d1"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc": [
        "ecc4ac",
        "393232"
    ],
    "1f41a": [
        "c7bebf",
        "847574"
    ],
    "1f3a6": [
        "64809b",
        "fdfdfd"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "402e26",
        "ce906a"
    ],
    "1f1f2-1f1f5": [
        "1368a0",
        "e0d9cd"
    ],
    "1f3c3-1f3fc-200d-2642-fe0f": [
        "d19876",
        "191d41"
    ],
    "1f40e": [
        "432d1f",
        "f5fafb"
    ],
    "1f4f4": [
        "f99503",
        "faf8f4"
    ],
    "1f359": [
        "a69e94",
        "1b220e"
    ],
    "1f36c": [
        "e3e5e6",
        "000000"
    ],
    "1f9ce-1f3fe-200d-2640-fe0f-200d-27a1-fe0f": [
        "392c3f",
        "a032a4"
    ],
    "1f9cd-1f3fb-200d-2642-fe0f": [
        "941c18",
        "e2b592"
    ],
    "1fae3": [
        "9f5209",
        "f8d031"
    ],
    "1fad7": [
        "e0dcdd",
        "c4626d"
    ],
    "1f469-200d-1f466": [
        "526b80",
        "fcfcfc"
    ],
    "1f469-1f3fe-200d-2695-fe0f": [
        "48352c",
        "c8c9c9"
    ],
    "1f9d6-1f3fc-200d-2642-fe0f": [
        "deedee",
        "bc9776"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd": [
        "8b5d40",
        "d94297"
    ],
    "1fada": [
        "e4a743",
        "a67045"
    ],
    "1f198": [
        "dc2312",
        "faf5f4"
    ],
    "1f467-1f3ff": [
        "231e1c",
        "53413a"
    ],
    "1f469-200d-1f469-200d-1f466-200d-1f466": [
        "4f677b",
        "c0cdd8"
    ],
    "1f469-1f3ff-200d-1f527": [
        "453d3d",
        "16110f"
    ],
    "1f1ec-1f1ec": [
        "c6a986",
        "c82d3f"
    ],
    "1f1ec-1f1f9": [
        "5a7d88",
        "f0f1f1"
    ],
    "1f615": [
        "be7322",
        "fdf592"
    ],
    "1f9b8-1f3fc-200d-2642-fe0f": [
        "ad7c47",
        "45254a"
    ],
    "1f9db-1f3fc-200d-2642-fe0f": [
        "121111",
        "aaa9a9"
    ],
    "1f601": [
        "ab6b2c",
        "fedc42"
    ],
    "1f91e-1f3fc": [
        "cd9870",
        "9d5e38"
    ],
    "1f61c": [
        "f8b51e",
        "f6f2ae"
    ],
    "1f629": [
        "b76f1a",
        "faef8c"
    ],
    "1f919-1f3fb": [
        "ecc29f",
        "c7825c"
    ],
    "1f9d1-1f3fc-200d-1f527": [
        "b88957",
        "535c82"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc": [
        "c88f65",
        "284a67"
    ],
    "1f6f6": [
        "9c1f1d",
        "0a9033"
    ],
    "270c-1f3fc": [
        "ca9269",
        "974d25"
    ],
    "1f6f7": [
        "8b2626",
        "012120"
    ],
    "270c-1f3fb": [
        "dda883",
        "ae5b33"
    ],
    "1f60f": [
        "cc6a18",
        "fdd539"
    ],
    "1f91e-1f3fb": [
        "deab87",
        "b46b46"
    ],
    "1f628": [
        "5d7e8a",
        "f1ae20"
    ],
    "1f61b": [
        "b9691d",
        "fef48a"
    ],
    "1f919-1f3fc": [
        "d7aa83",
        "ca9067"
    ],
    "1f6fa": [
        "c69419",
        "0a8a3d"
    ],
    "1f600": [
        "bc721a",
        "fab81d"
    ],
    "1f1ec-1f1f8": [
        "132d5d",
        "a74541"
    ],
    "1f1ec-1f1eb": [
        "1b7c39",
        "e1c81d"
    ],
    "1f614": [
        "ba7021",
        "fdf58f"
    ],
    "1f64d-1f3ff-200d-2640-fe0f": [
        "62544c",
        "a359a5"
    ],
    "26f9-1f3fb-200d-2642-fe0f": [
        "e3c2a7",
        "3f3737"
    ],
    "1f468-1f3fb-200d-1f3ed": [
        "5b5f70",
        "e9cfb6"
    ],
    "1f199": [
        "66839f",
        "fbfbfb"
    ],
    "1f93e-1f3fc-200d-2642-fe0f": [
        "bf8f68",
        "cec6b9"
    ],
    "1f9d1-1f3fe-200d-1f3eb": [
        "bfaea1",
        "445a48"
    ],
    "1fad6": [
        "e3ecf2",
        "636062"
    ],
    "1f9cf-200d-2642-fe0f": [
        "8b550c",
        "ce9214"
    ],
    "2721-fe0f": [
        "9237ae",
        "f9f7fa"
    ],
    "1f469-200d-1f467": [
        "526b80",
        "fcfcfc"
    ],
    "1f9d1-1f3fe-200d-1f33e": [
        "7d5523",
        "df9d38"
    ],
    "1fae2": [
        "db7a0f",
        "fcc231"
    ],
    "1f40d": [
        "626a35",
        "b7ca6a"
    ],
    "26cf-fe0f": [
        "0a0501",
        "3e3c3b"
    ],
    "1f1f2-1f1f4": [
        "136755",
        "e3eeec"
    ],
    "1f9d1-1f3fe-200d-1f680": [
        "d1ccc4",
        "787879"
    ],
    "1f487-1f3fc-200d-2642-fe0f": [
        "cbcac4",
        "45699a"
    ],
    "1f468-1f3fb-200d-1f692": [
        "957967",
        "d08f6c"
    ],
    "1f36b": [
        "d7d3d1",
        "e52128"
    ],
    "1f358": [
        "98611d",
        "dca13d"
    ],
    "1f4f5": [
        "881e08",
        "dfc5bf"
    ],
    "1f37f": [
        "d6b294",
        "d23635"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "6b462f",
        "f5c2bb"
    ],
    "1f3a7": [
        "d2d2d2",
        "a2a2a2"
    ],
    "1f402": [
        "8a5e42",
        "5c3e2a"
    ],
    "1f1f2-1f1e8": [
        "b52939",
        "e9e9e9"
    ],
    "1f1f2-1f1fb": [
        "6e1324",
        "1e834b"
    ],
    "1f9d1-1f3fb-200d-1f4bc": [
        "221e1e",
        "cfae96"
    ],
    "1f446-1f3ff": [
        "43302a",
        "281b14"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb": [
        "f4c9b9",
        "e84ba6"
    ],
    "1f364": [
        "edbe84",
        "d95d3d"
    ],
    "1f4fc": [
        "3f4040",
        "999996"
    ],
    "1f4e9": [
        "d4d2d3",
        "cb4948"
    ],
    "1f64b-1f3fb": [
        "292524",
        "9a9794"
    ],
    "1f478-1f3fc": [
        "905f28",
        "c9ab68"
    ],
    "1f9d1-1f3fe-200d-2696-fe0f": [
        "312520",
        "d69a50"
    ],
    "1f370": [
        "eee1c6",
        "000000"
    ],
    "1f3aa": [
        "c9be94",
        "bb2a14"
    ],
    "1f416": [
        "f5d4c2",
        "000000"
    ],
    "1f9d1-200d-1f384": [
        "d2cfcc",
        "52231b"
    ],
    "1f9d1-1f3fd-200d-1f52c": [
        "e5e5e5",
        "6d4a30"
    ],
    "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb": [
        "a19085",
        "3e332c"
    ],
    "1f482-1f3fe": [
        "4d3d29",
        "ab9377"
    ],
    "1f468-1f3fe-200d-2708-fe0f": [
        "b0a792",
        "4f3729"
    ],
    "1f938-1f3fb": [
        "3e3a37",
        "e4bb9b"
    ],
    "1f93d-1f3fc": [
        "d6a669",
        "5c4729"
    ],
    "1f3c7-1f3fc": [
        "372419",
        "d3ab93"
    ],
    "1f470-200d-2640-fe0f": [
        "c4c1ba",
        "f4c136"
    ],
    "1f645-1f3fd-200d-2642-fe0f": [
        "b38361",
        "1d4e8b"
    ],
    "1f468-1f3ff-200d-1f9af": [
        "b9173c",
        "46496e"
    ],
    "1f238": [
        "f99302",
        "fbfaf8"
    ],
    "264c": [
        "9237ae",
        "faf8fa"
    ],
    "2651": [
        "9237ae",
        "faf8fb"
    ],
    "26bd": [
        "eaeaea",
        "4f4f4f"
    ],
    "1f562": [
        "adb0b4",
        "f8f8f8"
    ],
    "1f977-1f3fc": [
        "020203",
        "474849"
    ],
    "1f3cc-1f3fc-200d-2642-fe0f": [
        "c7c5b7",
        "7a7776"
    ],
    "1f1f7-1f1ea": [
        "1c1bdc",
        "3d0404"
    ],
    "1f570-fe0f": [
        "744837",
        "ebe4d4"
    ],
    "1f468-200d-1f467-200d-1f467": [
        "607c95",
        "fcfcfc"
    ],
    "1f468-1f3fc-200d-1f4bb": [
        "e5ddb5",
        "8f8883"
    ],
    "25aa-fe0f": [
        "000000",
        "535353"
    ],
    "1f91c-1f3fe": [
        "7d4a2d",
        "000000"
    ],
    "2660-fe0f": [
        "3c3c3c",
        "171717"
    ],
    "1f469-200d-2764-200d-1f48b-200d-1f469": [
        "fdcbc7",
        "a1640d"
    ],
    "1f1f9-1f1f0": [
        "0e2454",
        "f2cc47"
    ],
    "1f990": [
        "e9733e",
        "d9a496"
    ],
    "1f984": [
        "d8c7e7",
        "dc1512"
    ],
    "1f64b-1f3fd-200d-2640-fe0f": [
        "835638",
        "842b94"
    ],
    "1f44a-1f3fc": [
        "cd956c",
        "000000"
    ],
    "1f99f": [
        "dbc9ae",
        "44372f"
    ],
    "1f1f9-1f1ff": [
        "126989",
        "0a0a0a"
    ],
    "1f1e7-1f1e9": [
        "226652",
        "d84c25"
    ],
    "1f1e7-1f1fc": [
        "6185a6",
        "060606"
    ],
    "1f98b": [
        "151313",
        "3fc5fb"
    ],
    "1f468-1f3fb-200d-1f527": [
        "746e6d",
        "f0d3b7"
    ],
    "1f64d-1f3fe": [
        "32241d",
        "cbcac9"
    ],
    "1f9cb": [
        "8c6b4e",
        "bdaea1"
    ],
    "1f953": [
        "bc492c",
        "8b1d10"
    ],
    "1f947": [
        "f4c710",
        "fa4f4a"
    ],
    "1f3c4-1f3fc-200d-2640-fe0f": [
        "d8b389",
        "6c2e54"
    ],
    "1f646-1f3fd-200d-2640-fe0f": [
        "943ca6",
        "5b1867"
    ],
    "1f9bf": [
        "747373",
        "2e2b2c"
    ],
    "1f9c4": [
        "caab95",
        "614436"
    ],
    "1f937-200d-2640-fe0f": [
        "9e6511",
        "702780"
    ],
    "1f95e": [
        "f4e5c0",
        "967354"
    ],
    "1f94a": [
        "a99295",
        "9b2627"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "302722",
        "d84297"
    ],
    "1faf1-1f3fe-200d-1faf2-1f3fb": [
        "eec5a2",
        "643821"
    ],
    "1f933-1f3ff": [
        "45362f",
        "868485"
    ],
    "1f9b0": [
        "df8810",
        "000000"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd": [
        "be9071",
        "735242"
    ],
    "1f9d1-1f3ff-200d-2696-fe0f": [
        "241f1d",
        "da9d50"
    ],
    "1f9a8": [
        "55514a",
        "ddd4c8"
    ],
    "1f9bb": [
        "696865",
        "ce820c"
    ],
    "1f9d7-1f3fd": [
        "adacaa",
        "938370"
    ],
    "1f943": [
        "a99f9b",
        "965530"
    ],
    "1f9cf-1f3fc-200d-2642-fe0f": [
        "846756",
        "c18a62"
    ],
    "1f957": [
        "c9cebf",
        "689333"
    ],
    "1f9cf": [
        "c18613",
        "777674"
    ],
    "1f9b4": [
        "555555",
        "c9cacb"
    ],
    "1f933-1f3fb": [
        "eabf9c",
        "727172"
    ],
    "1f9ce-200d-2642-fe0f-200d-27a1-fe0f": [
        "af242e",
        "edbc37"
    ],
    "1faf1-1f3fe-200d-1faf2-1f3ff": [
        "513529",
        "945d38"
    ],
    "1f9d7-1f3fb-200d-2640-fe0f": [
        "261f29",
        "887a65"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "241e1a",
        "f3c7b7"
    ],
    "1f94e": [
        "c6e02f",
        "97481b"
    ],
    "1f9d1-1f3fe-200d-1f52c": [
        "e0e0e0",
        "7b5d4a"
    ],
    "1f95a": [
        "f2efea",
        "d4cec6"
    ],
    "1f468-1f3fd-200d-2696-fe0f": [
        "d2baa7",
        "473427"
    ],
    "2699-fe0f": [
        "c3ced7",
        "66696e"
    ],
    "1f9c0": [
        "fed43d",
        "000000"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd": [
        "b88a6a",
        "784e33"
    ],
    "1f9d1-1f3fc-200d-1f4bc": [
        "b78854",
        "f0edd8"
    ],
    "1f3c3-1f3fd-200d-27a1-fe0f": [
        "9e7056",
        "c0bcb9"
    ],
    "1f980": [
        "542620",
        "e66c35"
    ],
    "1f1e7-1f1f1": [
        "aea793",
        "000000"
    ],
    "1f994": [
        "d8c8b5",
        "563721"
    ],
    "1f9d1-1f3fd-200d-2708-fe0f": [
        "523c2b",
        "b2977c"
    ],
    "1f1f9-1f1f4": [
        "6d0e0e",
        "b78282"
    ],
    "1faf0-1f3fc": [
        "ce966e",
        "914624"
    ],
    "1f9dc-1f3fb-200d-2640-fe0f": [
        "e4bd91",
        "657ba2"
    ],
    "1f468-1f3fc-200d-1f692": [
        "927562",
        "c6beb6"
    ],
    "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc": [
        "104d86",
        "ae7d5d"
    ],
    "1f473-1f3fc": [
        "aba9a7",
        "b17d57"
    ],
    "1f98f": [
        "74726f",
        "000000"
    ],
    "1f468-1f3ff-200d-2708-fe0f": [
        "767061",
        "221b18"
    ],
    "1f9d1-1f3fd-200d-1f680": [
        "cdc9c5",
        "8c8b8c"
    ],
    "2702-fe0f": [
        "f06469",
        "a9bcc8"
    ],
    "1f1f9-1f1fb": [
        "567e91",
        "2e4757"
    ],
    "1f1f9-1f1e8": [
        "180f47",
        "dc4d26"
    ],
    "1f645-1f3fc": [
        "a77040",
        "cac4b4"
    ],
    "1f99b": [
        "000000",
        "63605f"
    ],
    "1f469-1f3ff-200d-1f4bc": [
        "434044",
        "d8dbdc"
    ],
    "1f9b9-1f3fb-200d-2640-fe0f": [
        "3a2c3a",
        "ecc9a9"
    ],
    "1f1ee-1f1ea": [
        "c16c11",
        "f5f4f2"
    ],
    "1f468-200d-1f467": [
        "526b80",
        "fcfcfc"
    ],
    "1f635-200d-1f4ab": [
        "cf7309",
        "fef79e"
    ],
    "1f64d-1f3fe-200d-2640-fe0f": [
        "825e44",
        "32231c"
    ],
    "1f468-1f3fc-200d-1f9bc-200d-27a1-fe0f": [
        "cb3743",
        "515874"
    ],
    "1f6e1-fe0f": [
        "757475",
        "dee0e2"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd": [
        "f3bebf",
        "3a312d"
    ],
    "1f9d1-1f3fd-200d-1f33e": [
        "896822",
        "e4a138"
    ],
    "2139-fe0f": [
        "66849f",
        "fcfcfc"
    ],
    "1f6e0-fe0f": [
        "10100e",
        "bac9d5"
    ],
    "1f9d9-1f3fd-200d-2642-fe0f": [
        "aec9b2",
        "3b2f25"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd": [
        "b88a6c",
        "432614"
    ],
    "263a-fe0f": [
        "b56d22",
        "fdf48f"
    ],
    "1f469-200d-1f469-200d-1f467-200d-1f467": [
        "4f677b",
        "c0cdd8"
    ],
    "1f468-1f3fc-200d-1f3ed": [
        "585d73",
        "d6b89a"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd": [
        "754c2d",
        "f9bed9"
    ],
    "1f468-1f3ff-200d-1f9bd-200d-27a1-fe0f": [
        "c52233",
        "4a3f42"
    ],
    "1f9d1-1f3fd-200d-1f3eb": [
        "c1b4a9",
        "405f4c"
    ],
    "1f321-fe0f": [
        "c4cacc",
        "bc292d"
    ],
    "1f9ce-1f3fc-200d-2640-fe0f": [
        "d3ba82",
        "30304e"
    ],
    "1f9ce-200d-2642-fe0f": [
        "ebb62f",
        "9d1b28"
    ],
    "1f3ca-200d-2640-fe0f": [
        "cce5ef",
        "010002"
    ],
    "1f566": [
        "c3c7ca",
        "f4f5f5"
    ],
    "1f9d4-1f3fb-200d-2642-fe0f": [
        "282524",
        "ecc5a3"
    ],
    "1f475-1f3fd": [
        "cececd",
        "959594"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc": [
        "4b2e2d",
        "caa073"
    ],
    "1f937-1f3fb-200d-2642-fe0f": [
        "e6bd97",
        "2b4073"
    ],
    "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff": [
        "9e9997",
        "3b2f28"
    ],
    "1f468-1f3fc-200d-1f527": [
        "e4e1c2",
        "a48064"
    ],
    "1f938-1f3ff": [
        "473831",
        "dddad9"
    ],
    "1f9d1-200d-1f3a8": [
        "dfa823",
        "696557"
    ],
    "1faf6-1f3fd": [
        "814b34",
        "010000"
    ],
    "1f3a3": [
        "3f6fa7",
        "706b68"
    ],
    "1f41d": [
        "9a8c6a",
        "e4cb05"
    ],
    "1f37b": [
        "bbaea0",
        "8f6a48"
    ],
    "1f348": [
        "9fa66c",
        "e3e4aa"
    ],
    "1f935-1f3fe": [
        "3d2c24",
        "d7d2cc"
    ],
    "1f482-1f3fb-200d-2640-fe0f": [
        "4a3f33",
        "c4a280"
    ],
    "1f470-1f3fc-200d-2640-fe0f": [
        "c8c7c5",
        "a77c48"
    ],
    "1f36f": [
        "ab8c6e",
        "986829"
    ],
    "1f9d1-1f3ff-200d-1f9bd-200d-27a1-fe0f": [
        "c2c1c0",
        "353436"
    ],
    "1f4f1": [
        "adaaa8",
        "0a0a0a"
    ],
    "1f1f2-1f1f0": [
        "a32d29",
        "cfaf32"
    ],
    "1f9b9-1f3fd": [
        "482c1b",
        "9f7353"
    ],
    "1f3ae": [
        "898983",
        "31302b"
    ],
    "1f412": [
        "b18955",
        "5d3f1b"
    ],
    "1f374": [
        "010101",
        "7a8188"
    ],
    "1f4d9": [
        "df8b40",
        "252013"
    ],
    "1f6b5-1f3fb-200d-2642-fe0f": [
        "80817c",
        "bbd1d8"
    ],
    "1f9d1-1f3fc": [
        "c3985f",
        "21170b"
    ],
    "1f9d1-1f3fc-200d-1f9bc-200d-27a1-fe0f": [
        "e3e6e2",
        "4e5572"
    ],
    "1f64b-1f3ff": [
        "2a221f",
        "8b8985"
    ],
    "1f360": [
        "aa5561",
        "e3bf55"
    ],
    "1f446-1f3fb": [
        "e6b893",
        "c7835c"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff": [
        "3b302d",
        "cf9671"
    ],
    "1f1f2-1f1ff": [
        "1e6d67",
        "825713"
    ],
    "1f406": [
        "d4be94",
        "000000"
    ],
    "1f468-1f3fb-200d-1f4bb": [
        "88898b",
        "3b3536"
    ],
    "1f481-1f3fb-200d-2642-fe0f": [
        "c3957a",
        "375c94"
    ],
    "1f473-1f3fc-200d-2642-fe0f": [
        "d3d1cd",
        "9f7648"
    ],
    "1f467-1f3fc": [
        "bd9957",
        "916339"
    ],
    "1f939-1f3fd-200d-2640-fe0f": [
        "404130",
        "d9d0c8"
    ],
    "1fae6": [
        "772630",
        "e25577"
    ],
    "26f7-fe0f": [
        "2d4a63",
        "d16f55"
    ],
    "1f575-1f3fc-200d-2640-fe0f": [
        "c9a881",
        "4b4741"
    ],
    "1f6b5-1f3fe": [
        "ada495",
        "ddd5c6"
    ],
    "1f6b6-1f3fb-200d-2640-fe0f": [
        "b336ba",
        "100e1d"
    ],
    "1f473-200d-2640-fe0f": [
        "d5d4d0",
        "d29a1f"
    ],
    "1fad2": [
        "2f310b",
        "97a439"
    ],
    "1f61f": [
        "c77b1e",
        "fef590"
    ],
    "1f91e-1f3ff": [
        "392822",
        "1c110c"
    ],
    "1f638": [
        "f7da9a",
        "c18f23"
    ],
    "1f60b": [
        "bd6c28",
        "fed338"
    ],
    "270c-1f3ff": [
        "3c2b25",
        "564137"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff": [
        "2b201c",
        "deb290"
    ],
    "1f610": [
        "c47519",
        "fef592"
    ],
    "1f604": [
        "ae6b23",
        "fdda3f"
    ],
    "1f468-1f3ff-200d-1f393": [
        "b7aa97",
        "35302e"
    ],
    "1f1f1-1f1f8": [
        "1c3491",
        "e8e8e9"
    ],
    "1f939-200d-2640-fe0f": [
        "414a3a",
        "ecb733"
    ],
    "1f605": [
        "a4661a",
        "fdde43"
    ],
    "1f1f1-1f1f9": [
        "ae4134",
        "631a1d"
    ],
    "1f468-1f3fd-200d-1f52c": [
        "dbdbda",
        "785036"
    ],
    "1f611": [
        "c57219",
        "fbb81e"
    ],
    "1f60c": [
        "b86f21",
        "fab61e"
    ],
    "1f639": [
        "bbeaf6",
        "231e15"
    ],
    "1f3ca-1f3fb-200d-2642-fe0f": [
        "c9e5f0",
        "000000"
    ],
    "2194-fe0f": [
        "66839e",
        "fdfdfd"
    ],
    "1f919-1f3ff": [
        "49352e",
        "3a2923"
    ],
    "2195-fe0f": [
        "65829d",
        "fdfdfd"
    ],
    "2764-fe0f-200d-1fa79": [
        "b19795",
        "bf0f07"
    ],
    "1f6b6-200d-2640-fe0f": [
        "ac3ebc",
        "e3d6af"
    ],
    "1f468-200d-1f466-200d-1f466": [
        "607c95",
        "fcfcfc"
    ],
    "1fad3": [
        "634f35",
        "d2c5b0"
    ],
    "1f468-200d-2696-fe0f": [
        "f2ba29",
        "252221"
    ],
    "270f-fe0f": [
        "cfa432",
        "d3ccc9"
    ],
    "1f9d1-1f3fb-200d-1f692": [
        "a9886d",
        "ccc7b9"
    ],
    "1fae7": [
        "7aa5bb",
        "ada6af"
    ],
    "1f468-1f3fe-200d-1f680": [
        "bdb8b2",
        "3c342f"
    ],
    "1f6b5-1f3fd": [
        "5a544b",
        "ded7c8"
    ],
    "1f9df-200d-2642-fe0f": [
        "3a3633",
        "8d9986"
    ],
    "1f647-1f3fe-200d-2642-fe0f": [
        "776b67",
        "1a4a7f"
    ],
    "1f467-1f3fb": [
        "2b2625",
        "cb9672"
    ],
    "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2": [
        "4f677b",
        "c0cdd8"
    ],
    "1f469-1f3fd-200d-1f3a8": [
        "625445",
        "a78365"
    ],
    "1f468-1f3fb-200d-1f4bc": [
        "3a3332",
        "f0d3b7"
    ],
    "1f446-1f3fc": [
        "d09b73",
        "b47249"
    ],
    "1f4ff": [
        "6a232f",
        "7a6e58"
    ],
    "1f361": [
        "cfbda0",
        "b37e3c"
    ],
    "1f407": [
        "a8a7a8",
        "e8e9e9"
    ],
    "1f468-1f3fe-200d-1f3eb": [
        "c9ab91",
        "3c2a20"
    ],
    "1f413": [
        "d5cbc6",
        "915b1f"
    ],
    "1f3ad": [
        "b61c05",
        "daa873"
    ],
    "1f9d1-1f3fb": [
        "272323",
        "e9bf9c"
    ],
    "1f478-1f3ff": [
        "d9a71f",
        "3f342e"
    ],
    "1f9d1-1f3fb-200d-1f3ed": [
        "4a5065",
        "ebd4be"
    ],
    "1f4d8": [
        "5691bf",
        "0d0e12"
    ],
    "1f375": [
        "8e9373",
        "afb4a6"
    ],
    "1f938-1f3ff-200d-2642-fe0f": [
        "241d1a",
        "72655d"
    ],
    "1f4f0": [
        "cacaca",
        "6a6a6a"
    ],
    "1f468-1f3fe-200d-1f33e": [
        "7c5422",
        "a0ada2"
    ],
    "1f40a": [
        "44573a",
        "6b9a6d"
    ],
    "1f9b9-1f3fe": [
        "0d0908",
        "65289f"
    ],
    "26a0-fe0f": [
        "fff0dc",
        "fcc807"
    ],
    "1f1f2-1f1f1": [
        "a61f2d",
        "686b2c"
    ],
    "1f41e": [
        "817b79",
        "39130f"
    ],
    "1f3a2": [
        "5b6287",
        "bb7c23"
    ],
    "1f935-1f3fd": [
        "603c22",
        "e0dcd6"
    ],
    "1f349": [
        "dcb8ae",
        "666954"
    ],
    "1f37c": [
        "dde2da",
        "efa90a"
    ],
    "1f9d1-1f3fb-200d-1f9af-200d-27a1-fe0f": [
        "dccabc",
        "383b63"
    ],
    "1f9dd-1f3fb-200d-2642-fe0f": [
        "d4c08d",
        "4a8a5b"
    ],
    "1faf6-1f3fe": [
        "462110",
        "643119"
    ],
    "1f93d-1f3ff": [
        "4b3932",
        "f2f7f8"
    ],
    "1f3c3-200d-2640-fe0f-200d-27a1-fe0f": [
        "c78418",
        "d9d8c8"
    ],
    "1f3cb-1f3fb-200d-2640-fe0f": [
        "613f49",
        "e0b595"
    ],
    "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb": [
        "8f1b17",
        "dbb08f"
    ],
    "1f475-1f3fe": [
        "c4c4c3",
        "634331"
    ],
    "26ce": [
        "9438b0",
        "fcfbfc"
    ],
    "1f567": [
        "b1b4b8",
        "f8f9f8"
    ],
    "1f201": [
        "65829d",
        "fafbfb"
    ],
    "1f9d1-1f3fb-200d-1f527": [
        "1e1b1b",
        "c09e8a"
    ],
    "1f468-1f3fb-200d-1f9af-200d-27a1-fe0f": [
        "d0334a",
        "cb9c8f"
    ],
    "1f5a4": [
        "4d4d4d",
        "232222"
    ],
    "1f3c7-1f3ff": [
        "38251b",
        "3e91c3"
    ],
    "1f469-1f3ff-200d-2695-fe0f": [
        "0c0a09",
        "afaeaf"
    ],
    "264f": [
        "752c8a",
        "d5a7e0"
    ],
    "1f486-1f3fb-200d-2640-fe0f": [
        "6a5a52",
        "f3d4b5"
    ],
    "1f469-200d-1f469-200d-1f467-200d-1f466": [
        "4f677b",
        "c0cdd8"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe": [
        "7c513a",
        "eb4aa8"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe": [
        "483024",
        "d8b773"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe": [
        "845552",
        "392e2b"
    ],
    "1f977-1f3ff": [
        "010202",
        "2f3234"
    ],
    "26d3-fe0f-200d-1f4a5": [
        "cec9bf",
        "6f6965"
    ],
    "1f468-200d-1f466": [
        "526b80",
        "fcfcfc"
    ],
    "1f1e9-1f1ea": [
        "221f1f",
        "73632b"
    ],
    "1f44a-1f3ff": [
        "372721",
        "59443a"
    ],
    "1f99c": [
        "69872f",
        "ac5a12"
    ],
    "23ea": [
        "7495b3",
        "bfd0df"
    ],
    "1f645-1f3fb": [
        "c18356",
        "2b231f"
    ],
    "1f1f9-1f1e9": [
        "a71b35",
        "f4ca29"
    ],
    "1f1f9-1f1fc": [
        "bf1f3a",
        "408ccd"
    ],
    "1f469-1f3ff-200d-1f4bb": [
        "0b0807",
        "858789"
    ],
    "2328-fe0f": [
        "828385",
        "edeeef"
    ],
    "1f473-1f3fb": [
        "a7a6a3",
        "3b312c"
    ],
    "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb": [
        "114f87",
        "a98164"
    ],
    "1f9d8-1f3ff-200d-2640-fe0f": [
        "201713",
        "a94c7b"
    ],
    "1f1e7-1f1ff": [
        "103e74",
        "ced1cd"
    ],
    "1f64d-200d-2642-fe0f": [
        "ba7f17",
        "4772ad"
    ],
    "1f995": [
        "22666c",
        "45a5bb"
    ],
    "1f9ce-1f3fc-200d-2642-fe0f-200d-27a1-fe0f": [
        "393452",
        "b61b31"
    ],
    "1faf0-1f3fb": [
        "e1ae8a",
        "af6945"
    ],
    "1f981": [
        "b0641e",
        "f7b016"
    ],
    "1f9d1-1f3fc-200d-1f4bb": [
        "bd8f55",
        "87898b"
    ],
    "26e9-fe0f": [
        "030202",
        "bf3b1e"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe": [
        "815539",
        "382418"
    ],
    "1f9c1": [
        "c9ba9e",
        "bfa25e"
    ],
    "1f9d1-1f3ff-200d-1f9af": [
        "cfcac8",
        "120f23"
    ],
    "1f1ef-1f1f2": [
        "050505",
        "e4cc15"
    ],
    "1f933-1f3fc": [
        "bb7c53",
        "6c6c6d"
    ],
    "1f9b5": [
        "f4c846",
        "c0740e"
    ],
    "1f94d": [
        "374654",
        "848481"
    ],
    "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "c0925d",
        "231c18"
    ],
    "1f956": [
        "a17152",
        "f8d287"
    ],
    "1f46e-1f3fd-200d-2640-fe0f": [
        "82593e",
        "2381da"
    ],
    "23cf-fe0f": [
        "65829d",
        "fafbfb"
    ],
    "1f477-1f3fc-200d-2642-fe0f": [
        "e1b13f",
        "9ecdf3"
    ],
    "1f481-200d-2642-fe0f": [
        "f3dea5",
        "375c92"
    ],
    "1f93c-200d-2640-fe0f": [
        "2d8281",
        "e9b02f"
    ],
    "1f9d7-1f3fe": [
        "acaba8",
        "201612"
    ],
    "1f9bc": [
        "414242",
        "c33333"
    ],
    "1f9a9": [
        "ed5657",
        "925c60"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe": [
        "7d5946",
        "c1a18d"
    ],
    "1f926-1f3fe-200d-2642-fe0f": [
        "53392c",
        "415c7a"
    ],
    "1f469-1f3fc-200d-1f9af": [
        "bf3ac0",
        "2f2654"
    ],
    "1f942": [
        "9a9077",
        "f3f0dc"
    ],
    "1f93d-1f3fb-200d-2640-fe0f": [
        "e0b893",
        "f3f7f5"
    ],
    "1f469-1f3fb-200d-1f393": [
        "3a3737",
        "f0cfaf"
    ],
    "1f9ce": [
        "edbc34",
        "000000"
    ],
    "1f64d-1f3fb": [
        "242120",
        "e2d0bf"
    ],
    "267b-fe0f": [
        "7bea84",
        "0b500e"
    ],
    "1f954": [
        "c18740",
        "865734"
    ],
    "1f940": [
        "711b0f",
        "f9fefa"
    ],
    "1f469-1f3ff-200d-1f9bc-200d-27a1-fe0f": [
        "b73ea5",
        "1e181b"
    ],
    "1f3cc-1f3fd-200d-2640-fe0f": [
        "c3beba",
        "93503f"
    ],
    "1f9ba": [
        "50300e",
        "e45c2c"
    ],
    "1f9c3": [
        "0e9142",
        "dbebe1"
    ],
    "1f469-1f3fc-200d-1f9bd-200d-27a1-fe0f": [
        "b037b2",
        "363438"
    ],
    "1f6b6-200d-27a1-fe0f": [
        "cdcac6",
        "261e35"
    ],
    "1f968": [
        "e1b78e",
        "b0532b"
    ],
    "1f95b": [
        "cdcbc7",
        "70706f"
    ],
    "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f": [
        "aca5a5",
        "0c6328"
    ],
    "1f94f": [
        "204e84",
        "4591cc"
    ],
    "1f9b7": [
        "bea687",
        "f2ede3"
    ],
    "1f3d6-fe0f": [
        "e0c499",
        "815a3f"
    ],
    "1f9d1-1f3fc-200d-1f3eb": [
        "d0bd98",
        "465d48"
    ],
    "1f997": [
        "ac8a61",
        "312619"
    ],
    "1f1f9-1f1f7": [
        "bd2e36",
        "6f191f"
    ],
    "1f468-1f3fd-200d-1f3ed": [
        "566ba9",
        "95ade3"
    ],
    "1f6b6-1f3ff-200d-2642-fe0f": [
        "c01643",
        "424e89"
    ],
    "1f983": [
        "a8948d",
        "6a3e34"
    ],
    "1f3d7-fe0f": [
        "e2b658",
        "9f9fa0"
    ],
    "1f1e7-1f1f2": [
        "6c100e",
        "dccccf"
    ],
    "1f9d1-200d-1f9af": [
        "cecac9",
        "1b193d"
    ],
    "1f469-1f3ff-200d-1f33e": [
        "805e16",
        "1f1c0f"
    ],
    "1f645-1f3fc-200d-2640-fe0f": [
        "b28255",
        "712583"
    ],
    "1f477-200d-2642-fe0f": [
        "dea72d",
        "a1c9eb"
    ],
    "1f9d1-1f3fc-200d-1f33e": [
        "6f621a",
        "d2b99d"
    ],
    "23ec": [
        "65829d",
        "fdfdfe"
    ],
    "1f99a": [
        "47a94e",
        "2f5f58"
    ],
    "1f44a-1f3fd": [
        "925e48",
        "000000"
    ],
    "1f98e": [
        "3f7a43",
        "eff3f1"
    ],
    "1f481-1f3ff-200d-2640-fe0f": [
        "5e4e45",
        "a253a2"
    ],
    "1f469-1f3ff-200d-1f3eb": [
        "c9a384",
        "454840"
    ],
    "1f3c4-1f3fd-200d-2642-fe0f": [
        "0e5d73",
        "86d25c"
    ],
    "1f646-1f3fc-200d-2642-fe0f": [
        "6399d6",
        "d9b787"
    ],
    "1f977-1f3fd": [
        "020202",
        "323538"
    ],
    "1f6b5-1f3ff-200d-2640-fe0f": [
        "868178",
        "331e1d"
    ],
    "1f1e9-1f1ec": [
        "223f75",
        "836e73"
    ],
    "1f9d1-1f3fc-200d-1f680": [
        "cfc9c5",
        "8c8b8c"
    ],
    "1f1ee-1f1f8": [
        "15387c",
        "e3dcdf"
    ],
    "1f468-1f3fd-200d-1f692": [
        "7e604d",
        "662e25"
    ],
    "1f469-1f3ff-200d-1f680": [
        "d1ccc5",
        "7e7a73"
    ],
    "1f482-1f3ff-200d-2642-fe0f": [
        "4b4641",
        "9b8974"
    ],
    "1f469-200d-2764-200d-1f468": [
        "efb726",
        "ce439d"
    ],
    "1f6b6-1f3fc-200d-2642-fe0f-200d-27a1-fe0f": [
        "d3324f",
        "383f80"
    ],
    "1f9d1-1f3fd-200d-1f4bc": [
        "54321a",
        "e9e8e6"
    ],
    "1f91c-1f3fb": [
        "e7b895",
        "000000"
    ],
    "1f3c3-1f3fd-200d-2640-fe0f-200d-27a1-fe0f": [
        "a7775c",
        "ded8da"
    ],
    "1f3c7-1f3fd": [
        "301e15",
        "adb3b5"
    ],
    "1f21a": [
        "f99202",
        "faf9f6"
    ],
    "1f64b-1f3fc-200d-2642-fe0f": [
        "dfbd83",
        "3a64a0"
    ],
    "1f9d1-1f3fb-200d-1f52c": [
        "e7e6e4",
        "1f1c1c"
    ],
    "1f559": [
        "b1b4b7",
        "f7f7f7"
    ],
    "264d": [
        "9237ae",
        "faf8fb"
    ],
    "1f469-200d-1f9bc-200d-27a1-fe0f": [
        "b46aab",
        "5e566a"
    ],
    "1f441-fe0f-200d-1f5e8-fe0f": [
        "6d7072",
        "f4f5f8"
    ],
    "1f9d1-200d-2708-fe0f": [
        "daa420",
        "252321"
    ],
    "1f647-200d-2640-fe0f": [
        "fbca39",
        "7e378c"
    ],
    "1f937-1f3ff-200d-2640-fe0f": [
        "534338",
        "903da1"
    ],
    "1f565": [
        "bfc2c6",
        "f2f3f3"
    ],
    "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe": [
        "a0948d",
        "3c302a"
    ],
    "1f482-1f3fb": [
        "473e2d",
        "f3e5d3"
    ],
    "0031-fe0f-20e3": [
        "66849f",
        "fbfcfc"
    ],
    "1f388": [
        "ee7e83",
        "bb2526"
    ],
    "1f9d4-1f3ff-200d-2640-fe0f": [
        "473d3a",
        "2c2624"
    ],
    "1f93e-1f3fd-200d-2640-fe0f": [
        "674847",
        "809a82"
    ],
    "2600-fe0f": [
        "d57b25",
        "ecaa2a"
    ],
    "1f938-1f3fe": [
        "3e2411",
        "ab9f8f"
    ],
    "2601-fe0f": [
        "b9c5d0",
        "000000"
    ],
    "1f93d-1f3fd": [
        "9d7256",
        "f3f7f7"
    ],
    "1f1f2-1f1f3": [
        "90212a",
        "143d5c"
    ],
    "1f17f-fe0f": [
        "0057b2",
        "f9fbfc"
    ],
    "1f40c": [
        "b8915f",
        "5d3821"
    ],
    "1f439": [
        "9c686c",
        "f1efef"
    ],
    "1f36e": [
        "c47932",
        "822e16"
    ],
    "1f4f2": [
        "b1b1b1",
        "090a09"
    ],
    "1f9d1-200d-1f91d-200d-1f9d1": [
        "d0cac1",
        "ecb227"
    ],
    "1f935-1f3ff": [
        "25201e",
        "d3cfcb"
    ],
    "1f37a": [
        "7a502d",
        "d2c1aa"
    ],
    "1f3a0": [
        "ab8359",
        "e6ebeb"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc": [
        "be865a",
        "d94296"
    ],
    "1f468-200d-1f469-200d-1f466": [
        "64819b",
        "fdfdfd"
    ],
    "1f1f2-1f1fe": [
        "c25640",
        "e6dfdf"
    ],
    "1f3c8": [
        "c8a086",
        "c96a3f"
    ],
    "1f405": [
        "6d513c",
        "010100"
    ],
    "1f3cd-fe0f": [
        "5b6465",
        "010101"
    ],
    "26f9-1f3fe-200d-2640-fe0f": [
        "833d23",
        "d8dbd9"
    ],
    "1f64b-1f3fe": [
        "473126",
        "85827f"
    ],
    "1f363": [
        "e69e8e",
        "000000"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe": [
        "88583c",
        "e0aa91"
    ],
    "1f377": [
        "7e7474",
        "dedddd"
    ],
    "1f3ce-fe0f": [
        "010000",
        "ec1516"
    ],
    "1f468-1f3fe-200d-1f4bb": [
        "d4d1cf",
        "463127"
    ],
    "1f478-1f3fd": [
        "754822",
        "b38360"
    ],
    "1f3af": [
        "7eb1b6",
        "702728"
    ],
    "1f411": [
        "9c9b91",
        "595347"
    ],
    "1f9dc-1f3ff-200d-2642-fe0f": [
        "923231",
        "5f6b97"
    ],
    "1f9d8-200d-2640-fe0f": [
        "b37119",
        "d59a1e"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb": [
        "402d24",
        "d09373"
    ],
    "1f9b9-1f3ff-200d-2642-fe0f": [
        "191414",
        "50217c"
    ],
    "1fad1": [
        "506837",
        "416112"
    ],
    "2708-fe0f": [
        "61696c",
        "2195c9"
    ],
    "1f6b5-1f3ff": [
        "7b7971",
        "dcd6c8"
    ],
    "2b1c": [
        "d9d9d9",
        "e5e5e5"
    ],
    "1fae5": [
        "dd9820",
        "c0730c"
    ],
    "2709-fe0f": [
        "e6e6e6",
        "ff0000"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe": [
        "6c3b26",
        "e0b38f"
    ],
    "1f1f1-1f1e7": [
        "9aa28d",
        "7a261b"
    ],
    "1f60a": [
        "c57519",
        "fef48c"
    ],
    "1f9d7-1f3ff-200d-2642-fe0f": [
        "e4763a",
        "575c62"
    ],
    "1f3cb-fe0f-200d-2640-fe0f": [
        "683a4e",
        "c9aa99"
    ],
    "270c-1f3fe": [
        "673b23",
        "99623b"
    ],
    "1f468-1f3fd-200d-1f527": [
        "c8bcba",
        "3b62c6"
    ],
    "1f487-1f3fd-200d-2640-fe0f": [
        "b8aea7",
        "361813"
    ],
    "1f91e-1f3fe": [
        "78472b",
        "160905"
    ],
    "1f61e": [
        "bd7121",
        "fdf48d"
    ],
    "1f5c4-fe0f": [
        "6a7071",
        "e5e7e8"
    ],
    "1f919-1f3fd": [
        "b27b5d",
        "784c37"
    ],
    "1f607": [
        "613704",
        "fccd34"
    ],
    "2692-fe0f": [
        "656365",
        "363533"
    ],
    "1f1ec-1f1ee": [
        "b7a4a3",
        "700c11"
    ],
    "1f613": [
        "dc8a16",
        "ebf6c2"
    ],
    "1f9d1-1f3fb-200d-2695-fe0f": [
        "2e2928",
        "bcbbba"
    ],
    "1f1ec-1f1ed": [
        "b52533",
        "0e482f"
    ],
    "1f612": [
        "b76e21",
        "fdf58f"
    ],
    "1f3cc-fe0f-200d-2642-fe0f": [
        "bac5be",
        "7a7775"
    ],
    "1f606": [
        "b06c22",
        "f2efb8"
    ],
    "1f93d-1f3ff-200d-2642-fe0f": [
        "877167",
        "eceeef"
    ],
    "1f3c3-1f3fd-200d-2640-fe0f": [
        "aa7f67",
        "2b1b37"
    ],
    "1f91e-1f3fd": [
        "98654c",
        "80533e"
    ],
    "1f61d": [
        "ba6b1c",
        "fdf58f"
    ],
    "1f9cd-1f3fe-200d-2640-fe0f": [
        "7b4e33",
        "2384bf"
    ],
    "1f919-1f3fe": [
        "865131",
        "6f3f26"
    ],
    "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f": [
        "b4a6a6",
        "b91c1c"
    ],
    "1f1f1-1f1e6": [
        "133163",
        "eceaed"
    ],
    "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd": [
        "a95b40",
        "362d2c"
    ],
    "270c-1f3fd": [
        "94614a",
        "432818"
    ],
    "2b1b": [
        "292827",
        "020201"
    ],
    "1fae4": [
        "814007",
        "fbc42b"
    ],
    "1fad0": [
        "e5e1c9",
        "3c5280"
    ],
    "1f9da-1f3fd-200d-2642-fe0f": [
        "9fe4cd",
        "795831"
    ],
    "1f468-1f3fb-200d-1f33e": [
        "79531a",
        "d6c5aa"
    ],
    "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc": [
        "e8bca4",
        "462e23"
    ],
    "1f9d1-1f3fe-200d-1f3ed": [
        "191617",
        "5971b6"
    ],
    "1f3dc-fe0f": [
        "674e36",
        "f7a82f"
    ],
    "1faf8": [
        "ba6e00",
        "f4bd1e"
    ],
    "2b06-fe0f": [
        "6885a1",
        "fbfcfc"
    ],
    "1f64e-1f3fc-200d-2640-fe0f": [
        "e2ce99",
        "70267d"
    ],
    "1f468-1f3fb-200d-1f3eb": [
        "e6c7ab",
        "425948"
    ],
    "2b07-fe0f": [
        "65839d",
        "fcfdfd"
    ],
    "1f9d8-1f3fb-200d-2642-fe0f": [
        "c5845c",
        "24272d"
    ],
    "1f3db-fe0f": [
        "fcfbf6",
        "aba284"
    ],
    "1f469-1f3fc-200d-1f3a8": [
        "d2bd98",
        "5c594f"
    ],
    "1f478-1f3fe": [
        "8e5724",
        "463228"
    ],
    "1f9db-1f3fd-200d-2640-fe0f": [
        "141313",
        "cfcbcb"
    ],
    "1f468-1f3fe-200d-1f4bc": [
        "503528",
        "8ea8c1"
    ],
    "1f376": [
        "dfdfdd",
        "5867ab"
    ],
    "1f410": [
        "867766",
        "ae9d87"
    ],
    "1f404": [
        "aba7a3",
        "3f3b39"
    ],
    "1f3c9": [
        "b68041",
        "f4f2eb"
    ],
    "1f1f2-1f1fd": [
        "9f1b30",
        "efeceb"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd": [
        "c48d69",
        "513b2f"
    ],
    "1f362": [
        "715749",
        "cdaf8b"
    ],
    "1f64b-1f3fd": [
        "5f3b22",
        "cd9b62"
    ],
    "1f9b8-1f3fd-200d-2640-fe0f": [
        "56311e",
        "cf2642"
    ],
    "1f468-1f3fb-200d-1f680": [
        "c1b9b0",
        "35322f"
    ],
    "1f9ce-1f3fc-200d-27a1-fe0f": [
        "b2884c",
        "000001"
    ],
    "1f468-200d-1f469-200d-1f467": [
        "64819b",
        "fdfdfd"
    ],
    "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb": [
        "3b3331",
        "cb8f69"
    ],
    "1f41f": [
        "465c80",
        "96c8e7"
    ],
    "1f3a1": [
        "a3aaaf",
        "8e2f32"
    ],
    "1f9d1-1f3fe-200d-1f692": [
        "9c7963",
        "a72d25"
    ],
    "1f438": [
        "dfe5eb",
        "618e47"
    ],
    "1f40b": [
        "b1ccd7",
        "6c98aa"
    ],
    "1f9d1-1f3ff-200d-1f3a8": [
        "261f1d",
        "9f8f75"
    ],
    "1f9b9-1f3ff": [
        "0e0a0a",
        "6b30a1"
    ],
    "1f1f2-1f1f2": [
        "a0af30",
        "6e2c26"
    ],
    "1f4f3": [
        "f89302",
        "e9dac1"
    ],
    "1f36d": [
        "7c7464",
        "b79560"
    ],
    "1f5d2-fe0f": [
        "d5d7da",
        "696d71"
    ],
    "1f938-1f3fd": [
        "412a19",
        "bd9374"
    ],
    "1f9d6-1f3fd-200d-2640-fe0f": [
        "d5e8e9",
        "ba9579"
    ],
    "1f93d-1f3fe": [
        "7a4827",
        "f3f7f8"
    ],
    "1f486-1f3ff-200d-2642-fe0f": [
        "493933",
        "4b90cd"
    ],
    "1f5d3-fe0f": [
        "eaeaea",
        "b86868"
    ],
    "1faf6-1f3ff": [
        "271911",
        "583f34"
    ],
    "1f469-1f3fb-200d-2696-fe0f": [
        "6a5547",
        "e7cbb1"
    ],
    "1f468-1f3fc-200d-1f52c": [
        "dcdbd5",
        "9d7b5b"
    ],
    "1f475-1f3ff": [
        "b2b1b1",
        "3b2b25"
    ],
    "1f389": [
        "ce65a2",
        "9d4a30"
    ],
    "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd": [
        "c6c0be",
        "37302d"
    ],
    "1f482-1f3fc": [
        "42392b",
        "b28d68"
    ],
    "1f469-1f3fd-200d-1f9af": [
        "be39c2",
        "3b4274"
    ],
    "260e-fe0f": [
        "d67779",
        "e7dbdb"
    ],
    "1f469-1f3fe-200d-1f393": [
        "544a45",
        "302825"
    ],
    "1f564": [
        "cacdd0",
        "f7f7f7"
    ],
    "1f3cb-1f3ff-200d-2642-fe0f": [
        "445261",
        "427bad"
    ],
    "1f9dd-1f3ff-200d-2640-fe0f": [
        "392d23",
        "d4c886"
    ],
    "264e": [
        "9237ae",
        "fbfbfb"
    ],
    "1f468-200d-1f469-200d-1f466-200d-1f466": [
        "4f677b",
        "c0cdd8"
    ],
    "1f558": [
        "c5c9cc",
        "f4f5f4"
    ],
    "1f935-1f3fd-200d-2640-fe0f": [
        "805536",
        "37291f"
    ],
    "1f3c7-1f3fe": [
        "382419",
        "d4b39f"
    ],
    "1f415-200d-1f9ba": [
        "211c19",
        "227a7a"
    ],
    "1f9d1-1f3fd-200d-1f4bb": [
        "6e4429",
        "8e9092"
    ],
    "1f938-1f3fb-200d-2640-fe0f": [
        "312f2e",
        "efcba9"
    ],
    "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff": [
        "42332d",
        "d9b974"
    ],
    "1f468-200d-1f9af-200d-27a1-fe0f": [
        "d13448",
        "d8d1ce"
    ],
    "1f91c-1f3fc": [
        "d3a27b",
        "000000"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff": [
        "37261e",
        "8d338c"
    ],
    "00ae-fe0f": [
        "474747",
        "cdcdcd"
    ],
    "1f469-200d-2764-200d-1f469": [
        "f5bd2b",
        "c3419c"
    ],
    "1f1ee-1f1f9": [
        "a42f37",
        "f4f2f2"
    ],
    "1f977-1f3fe": [
        "010101",
        "303235"
    ],
    "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff": [
        "544048",
        "f3bebf"
    ],
    "1f9db-200d-2640-fe0f": [
        "0a0909",
        "f0bb2e"
    ],
    "1f1e7-1f1fe": [
        "a1110f",
        "0d610c"
    ],
    "1f98d": [
        "888686",
        "666463"
    ],
    "1f6b4-1f3fd-200d-2642-fe0f": [
        "0c0c7b",
        "505151"
    ],
    "1f44a-1f3fe": [
        "683b23",
        "9b653d"
    ],
    "23eb": [
        "66839e",
        "fbfcfc"
    ],
    "1f1e7-1f1f3": [
        "ab7a34",
        "050505"
    ],
    "1f982": [
        "7b4310",
        "b67b23"
    ],
    "1f6a3-1f3fd-200d-2642-fe0f": [
        "804739",
        "c7c1b3"
    ],
    "1f471-1f3fe-200d-2640-fe0f": [
        "bba057",
        "523929"
    ],
    "1f996": [
        "d0de23",
        "608819"
    ],
    "1faf1-1f3fe-200d-1faf2-1f3fd": [
        "9e674f",
        "000000"
    ],
    "1f3ca-1f3ff-200d-2640-fe0f": [
        "cbe4ef",
        "2e1924"
    ],
    "1f9b6": [
        "a75404",
        "de9b1f"
    ],
    "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff": [
        "85624e",
        "f96dc3"
    ],
    "1f9c2": [
        "484641",
        "c2c2c0"
    ],
    "1f6b6-1f3fb-200d-27a1-fe0f": [
        "e7ceb6",
        "131120"
    ],
    "1f95c": [
        "cea75f",
        "785026"
    ],
    "1f969": [
        "e5bbb4",
        "c11e11"
    ],
    "1f9d1-1f3fe-200d-1f527": [
        "372720",
        "3b6dde"
    ],
    "1f941": [
        "8a827d",
        "e4ecf1"
    ],
    "1f9d7-1f3ff": [
        "adaba8",
        "5d5b56"
    ],
    "0035-fe0f-20e3": [
        "66839e",
        "fbfbfc"
    ],
    "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff": [
        "5c4a45",
        "c4977b"
    ],
    "1f64d-1f3fc": [
        "b68755",
        "d9d7c4"
    ],
    "1f9cd": [
        "d8d2bf",
        "787675"
    ],
    "1f955": [
        "2b5b1b",
        "db996e"
    ]
}